

// MultiMap.js (refactored UI only — same dependencies)
import React, { useState, useEffect, useMemo, useRef, useCallback, useTransition } from "react";
import { Close } from "@mui/icons-material";
import { FormGroup, FormControlLabel, Checkbox, Typography, Radio, FormControl } from "@mui/material";
import Icon from '@mui/material/Icon';
// --- MIGRATED to MapLibre (free, no Google key for map render). Old Google imports kept for rollback ---
// import { GoogleMap, Polyline, Marker, useJsApiLoader } from "@react-google-maps/api";
// import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import MapGL, { Marker, Source, Layer, NavigationControl } from "react-map-gl/maplibre";
import { MapboxOverlay } from "@deck.gl/mapbox";
import "maplibre-gl/dist/maplibre-gl.css";
import { ScatterplotLayer, IconLayer, TextLayer } from '@deck.gl/layers';
import { HeatmapLayer, PathLayer } from 'deck.gl';
import Supercluster from 'supercluster';
import axios from "axios";
import * as _ from "underscore";
import { saveAs } from "file-saver";
import Geocode from "react-geocode";
import moment from "moment-timezone";
import { Segmented } from 'antd';
import GaugeChart from 'react-gauge-chart'
import { IoMapSharp } from "react-icons/io5";
import { PiVideoDuotone } from "react-icons/pi";
import { RiCalculatorFill, RiArticleFill, RiFileDownloadFill, RiHistoryFill, RiNotification3Fill, RiTrafficLightLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import LoadingScreen from "../../../utils/LoadingScreen";
import ProfileMenu from "../../../utils/ProfileMenu";
import { useBranding } from "../../../contexts/BrandingContext";
import { useDefectConfig } from "../../../contexts/DefectConfigContext";
import { useAuthority } from "../../../contexts/AuthorityContext";
import { useMapTile } from "../../../contexts/MapTileContext";
import "./MultiMap.css";
import Expand from "../../../assets/Expand.svg";
import trafficSignalIcon from "../../../assets/traffic-signal.svg";
import selectedPointIcon from "../../../assets/road-engineer-option2-removebg.svg";
import { FcPrevious, FcNext, FcVideoCall, FcNoVideo, FcCamera } from "react-icons/fc";
import { tr } from "@faker-js/faker";
import { mapLabel, getUniversalColorForLabel } from "../../../utils/labelMapping";
import { kotaColorForLabel, isKotaOrg, kotaCategoryForLabel, kotaTabsForLabel, KOTA_TAB_LABELS } from "../../../utils/kotaDefectConfig";
import { categorizeDefectsByKeyword } from "../../../utils/defectCategorization";
import BHILWARA_TRAFFIC_POINTS from "./bhilwaraTrafficPoints";

const libraries = ['places'];

// ═══════════════════════════════════════════════════════════════════
// Khammam Municipal Corporation — All 50 Wards with center coords
// Each marker on the map is assigned to its nearest ward instantly.
// ═══════════════════════════════════════════════════════════════════
const KHAMMAM_WARDS = [
  { ward: 1, name: "Ward 1 - Raghunadha Palem", lat: 17.2690, lng: 80.1280 },
  { ward: 2, name: "Ward 2 - Saradhi Nagar", lat: 17.2670, lng: 80.1350 },
  { ward: 3, name: "Ward 3 - Mamilla Gadaem", lat: 17.2620, lng: 80.1360 },
  { ward: 4, name: "Ward 4 - Bhimas Nagar", lat: 17.2610, lng: 80.1450 },
  { ward: 5, name: "Ward 5 - UPH Colony", lat: 17.2595, lng: 80.1490 },
  { ward: 6, name: "Ward 6 - Prashanthi Nagar", lat: 17.2650, lng: 80.1520 },
  { ward: 7, name: "Ward 7 - Tekulapalli", lat: 17.2620, lng: 80.1600 },
  { ward: 8, name: "Ward 8 - Indira Nagar", lat: 17.2570, lng: 80.1580 },
  { ward: 9, name: "Ward 9 - Sri Nagar Colony", lat: 17.2530, lng: 80.1610 },
  { ward: 10, name: "Ward 10 - Madhura Nagar", lat: 17.2490, lng: 80.1620 },
  { ward: 11, name: "Ward 11 - Raghavaiah Nagar", lat: 17.2510, lng: 80.1550 },
  { ward: 12, name: "Ward 12 - Sathupalii Road", lat: 17.2530, lng: 80.1500 },
  { ward: 13, name: "Ward 13 - Mamatha Hospital Area", lat: 17.2500, lng: 80.1470 },
  { ward: 14, name: "Ward 14 - VDO's Colony", lat: 17.2580, lng: 80.1440 },
  { ward: 15, name: "Ward 15 - NST Road", lat: 17.2570, lng: 80.1380 },
  { ward: 16, name: "Ward 16 - Khanapuram Haveli", lat: 17.2520, lng: 80.1350 },
  { ward: 17, name: "Ward 17 - Khammam Fort", lat: 17.2480, lng: 80.1370 },
  { ward: 18, name: "Ward 18 - Lakaram Tank Bund", lat: 17.2440, lng: 80.1430 },
  { ward: 19, name: "Ward 19 - Munawarpet", lat: 17.2420, lng: 80.1380 },
  { ward: 20, name: "Ward 20 - Pakabanda Bazar", lat: 17.2380, lng: 80.1450 },
  { ward: 21, name: "Ward 21 - Sai Nagar", lat: 17.2400, lng: 80.1510 },
  { ward: 22, name: "Ward 22 - Ballepalli", lat: 17.2360, lng: 80.1530 },
  { ward: 23, name: "Ward 23 - Masjid-E-Mustafa Nagar", lat: 17.2350, lng: 80.1400 },
  { ward: 24, name: "Ward 24 - Shivalayam Area", lat: 17.2310, lng: 80.1420 },
  { ward: 25, name: "Ward 25 - Rajendra Nagar", lat: 17.2340, lng: 80.1320 },
  { ward: 26, name: "Ward 26 - Prakash Nagar", lat: 17.2420, lng: 80.1280 },
  { ward: 27, name: "Ward 27 - Sri Ayyappa Swamy Area", lat: 17.2380, lng: 80.1300 },
  { ward: 28, name: "Ward 28 - Annapurna Colony", lat: 17.2360, lng: 80.1250 },
  { ward: 29, name: "Ward 29 - Gandhi Nagar", lat: 17.2450, lng: 80.1230 },
  { ward: 30, name: "Ward 30 - Pumping Well Road", lat: 17.2430, lng: 80.1170 },
  { ward: 31, name: "Ward 31 - Basavi Gardens", lat: 17.2500, lng: 80.1190 },
  { ward: 32, name: "Ward 32 - SV Market Area", lat: 17.2530, lng: 80.1250 },
  { ward: 33, name: "Ward 33 - DMart Area", lat: 17.2580, lng: 80.1200 },
  { ward: 34, name: "Ward 34 - Nava Nagar", lat: 17.2540, lng: 80.1310 },
  { ward: 35, name: "Ward 35 - Balaji Nagar", lat: 17.2550, lng: 80.1140 },
  { ward: 36, name: "Ward 36 - Church Junction", lat: 17.2420, lng: 80.1340 },
  { ward: 37, name: "Ward 37 - Overhead Tank Area", lat: 17.2430, lng: 80.1280 },
  { ward: 38, name: "Ward 38 - Jyothi Nagar", lat: 17.2470, lng: 80.1140 },
  { ward: 39, name: "Ward 39 - Bhuranpuram", lat: 17.2630, lng: 80.1410 },
  { ward: 40, name: "Ward 40 - Sahakar Nagar", lat: 17.2560, lng: 80.1480 },
  { ward: 41, name: "Ward 41 - Stambadri Lakshmi Area", lat: 17.2590, lng: 80.1360 },
  { ward: 42, name: "Ward 42 - Sammakka Colony", lat: 17.2630, lng: 80.1180 },
  { ward: 43, name: "Ward 43 - Wyra Road", lat: 17.2660, lng: 80.1250 },
  { ward: 44, name: "Ward 44 - Old Bus Stand Area", lat: 17.2580, lng: 80.1300 },
  { ward: 45, name: "Ward 45 - Sathupalli Road South", lat: 17.2460, lng: 80.1550 },
  { ward: 46, name: "Ward 46 - Green Honda Area", lat: 17.2520, lng: 80.1650 },
  { ward: 47, name: "Ward 47 - Park Area South", lat: 17.2320, lng: 80.1530 },
  { ward: 48, name: "Ward 48 - Vemikya Nagar", lat: 17.2370, lng: 80.1470 },
  { ward: 49, name: "Ward 49 - Hospital Road", lat: 17.2470, lng: 80.1580 },
  { ward: 50, name: "Ward 50 - Khammam District Court", lat: 17.2590, lng: 80.1530 },
];

// Fast Haversine distance in km between two points
const _haversineKm = (lat1, lng1, lat2, lng2) => {
  const toRad = (v) => (v * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

// Given a lat/lng, find the nearest Khammam ward
const findNearestWard = (lat, lng) => {
  let minDist = Infinity;
  let nearest = KHAMMAM_WARDS[0];
  for (const w of KHAMMAM_WARDS) {
    const d = _haversineKm(lat, lng, w.lat, w.lng);
    if (d < minDist) {
      minDist = d;
      nearest = w;
    }
  }
  return nearest.name;
};

// Label-to-color map for inference_info label-based point coloring.
// When defect_state is "none", the dominant color across all labels on a frame is used.
const LABEL_COLOR_MAP = {
  // ── IBI Guideline PDF — 24 main labels (defaults when no state sub-label) ──
  // Defects:
  'pavement defects':          '#DC3C3C',  // Red (always a defect)
  'traffic behaviour':         '#DC3C3C',  // Red (Wrong Side Driving = High)
  'encroachment':              '#E87A00',  // Orange
  'illegal parking':           '#C8C800',  // Yellow
  'natural':                   '#C8C800',  // Yellow
  'infrastructure':            '#C8C800',  // Yellow

  // Asset (material) detections — docx has no color for these states,
  // treat as neutral Green:
  'road surface':              '#00BB00',  // Bituminous/Concrete/Paver/Unpaved
  'road structure':            '#00BB00',  // Flyover/Underpass

  // Subcategory detections — the ML emits the bare subcategory label only when a
  // defect is detected (no "good" suffix). Default to each subcategory's dominant
  // defect severity per the IBI Guideline docx. Labels that explicitly include
  // "good" still fall through to the 'good' → Green rule further down.
  'pavement marking':          '#DC3C3C',  // Poor/Faded → Red
  'median':                    '#DC3C3C',  // Damaged → Red
  'refuge island':             '#E87A00',  // Damaged → Orange
  'kerb ramp':                 '#C8C800',  // Damaged → Yellow (Missing = Orange)
  'foot over bridge (fob)':    '#DC3C3C',  // Poor → Red
  'pedestrian crossing':       '#E87A00',  // Poor/Worn Out → Orange
  'pelican control signal':    '#E87A00',  // Poor/Damaged → Orange (Missing = Red)
  'pedestrian signal':         '#DC3C3C',  // Damaged/Non-Functional → Red
  'speed limit signages':      '#DC3C3C',  // Poor → Red
  'school zone signage':       '#DC3C3C',  // Poor → Red
  'pedestrian signage':        '#DC3C3C',  // Poor → Red
  'metro signages':            '#DC3C3C',  // Poor → Red
  'speed hump':                '#DC3C3C',  // Damaged → Red
  'rumble strip':              '#DC3C3C',  // Damaged → Red
  'street light':              '#DC3C3C',  // Damaged/Non-Functional → Red
  'flood light (high mast)':   '#DC3C3C',  // Damaged/Non-Functional → Red

  // ── IBI Guideline — Pavement Defects sub-labels ──
  'faulting at joints':        '#DC3C3C',
  'blow-up (buckling)':        '#DC3C3C',
  'corner break (concrete)':   '#E87A00',
  'delamination':              '#C8C800',
  'patch':                     '#00BB00',

  // ── IBI Guideline — state sub-labels (apply across subcategories) ──
  // Good (any subcategory) → Green
  'good':                      '#00BB00',
  // Asset sub-types (Road Surface variants) → Green
  'bituminous':                '#00BB00',
  'concrete':                  '#00BB00',
  'paver blocks':              '#00BB00',
  'unpaved':                   '#00BB00',
  'flyover':                   '#00BB00',
  'underpass':                 '#00BB00',
  'footpath':                  '#00BB00',
  'road':                      '#00BB00',

  // Damaged / high-severity states
  'damaged':                   '#DC3C3C',
  'non-functional':            '#DC3C3C',
  'non functional':            '#DC3C3C',
  'poor':                      '#DC3C3C',
  'poor/faded':                '#DC3C3C',
  'wrong side driving':        '#DC3C3C',

  // Medium-severity states
  'missing':                   '#E87A00',
  'paint faded':               '#E87A00',
  'damaged/faded':             '#E87A00',
  'not accessible':            '#E87A00',
  'poor/worn out':             '#E87A00',
  'poor/damaged':              '#E87A00',
  'barricading':               '#E87A00',
  'vendor':                    '#E87A00',
  'shop spillover':            '#E87A00',

  // Low-severity states
  'visibly obstructed':        '#C8C800',
  'obstructed':                '#C8C800',
  'overhanging branches':      '#C8C800',
  'vegetation overgrowth':     '#C8C800',
  'electric pole/infrastructure': '#C8C800',
  'traffic kiosk':             '#C8C800',

  // ── Legacy NHAI vocabulary kept for backward compatibility ──
  'pavement damage (severe)': '#DC3C3C',
  'potholes': '#DC3C3C',
  'pothole': '#DC3C3C',
  'settlement': '#DC3C3C',
  'rutting': '#DC3C3C',
  'shoulder edge drop': '#DC3C3C',
  'damaged sign boards / sign structures': '#DC3C3C',
  'damaged sign boards': '#DC3C3C',
  'damaged highway lights': '#DC3C3C',
  'non-functional highway lights': '#DC3C3C',
  'missing assets (street lights)': '#DC3C3C',
  'damaged crash barriers': '#DC3C3C',
  'damaged metal beam crash barrier': '#DC3C3C',
  'damaged pedestrian guard rail': '#DC3C3C',
  'damaged kerb': '#DC3C3C',
  'damaged drain cover slabs': '#DC3C3C',
  'missing drain cover slabs': '#DC3C3C',
  'damaged blinkers': '#DC3C3C',
  'damaged attenuators': '#DC3C3C',
  'damaged delineators': '#DC3C3C',
  'damaged anti-glare': '#DC3C3C',
  'damaged hazard markers': '#DC3C3C',
  'reduced visibility due to overgrowth': '#DC3C3C',
  'damaged rumble strips': '#DC3C3C',
  'faded pavement marking': '#DC3C3C',
  'pavement marking - poor visibility (night)': '#DC3C3C',
  'work zone - inadequate barricading': '#DC3C3C',
  'work zone - poor diversion arrangement / condition': '#DC3C3C',
  'missing assets (guard rails)': '#DC3C3C',
  'median separator damaged': '#DC3C3C',
  'unauthorized median opening': '#DC3C3C',
  'stripping / delamination': '#E87A00',
  'cracks': '#E87A00',
  'crack': '#E87A00',
  'cracking': '#E87A00',
  'water stagnation': '#E87A00',
  'shoulder unevenness': '#E87A00',
  'shoulder rain cut': '#E87A00',
  'signage - poor visibility (day)': '#E87A00',
  'signage - poor visibility (night)': '#E87A00',
  'damaged footpath tiles / paver blocks': '#E87A00',
  'damaged footpath': '#E87A00',
  'damaged road studs': '#E87A00',
  'bus bay - damaged shelters': '#E87A00',
  'truck lay by - damaged shelters': '#E87A00',
  'missing plants / irregular gaps (median)': '#E87A00',
  'deteriorated or damaged plants (median)': '#E87A00',
  'unauthorized hoardings': '#E87A00',
  'pavement marking - poor visibility (day)': '#E87A00',
  'work zone - inadequate signboard visibility': '#E87A00',
  'faded painting concrete crash barrier': '#E87A00',
  'barriers - faded painting guard rails': '#E87A00',
  'faded kerb painting': '#E87A00',
  'median separator paint faded': '#E87A00',
  'general encroachment': '#E87A00',
  'unsealed roads': '#C8C800',
  'pavement joint': '#C8C800',
  'road studs - poor visibility (day)': '#C8C800',
  'road studs - poor visibility (night)': '#C8C800',
  'bus bay - faded markings': '#C8C800',
  'bus bay - damaged signages': '#C8C800',
  'truck lay by - faded markings': '#C8C800',
  'truck lay by - damaged signages': '#C8C800',
  'manhole': '#C8C800',
  'illegal parking': '#C8C800',
  'shoulder - vegetation growth': '#C8C800',
  'excessive plantation growth': '#C8C800',
  'unauthorized advertisement board': '#C8C800',
  'cleanliness - litter': '#C8C800',
  'cleanliness - debris': '#C8C800',
};

// Normalize a stored label (snake_case / hyphens) to plain lowercase for map lookup
const _normLabelForColor = (label) =>
  label.toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ').trim();

// Return the mapped color for a raw inference_info label, or null if not found.
// Resolution order:
//   1. Kota org → kotaDefectConfig severity map (Parameter.docx taxonomy)
//   2. Universal SEVERITY_MAP in labelMapping.js (single source of truth for
//      all other organizations — Bhilwara is short-circuited earlier in
//      getMarkerColor before this function runs).
const _getLabelColor = (rawLabel) => {
  if (isKotaOrg()) {
    const c = kotaColorForLabel(rawLabel);
    if (c) return c;
  }
  return getUniversalColorForLabel(rawLabel);
};

// ── Bhilwara-specific color logic ────────────────────────────────────────────
// Point color depends on BOTH defect label AND severity for bhilwaraUser@roadvision.ai

// Severity-dependent defects: color varies by severity level
const BHILWARA_SEVERITY_COLOR = {
  'potholes': { high: '#DC3C3C', medium: '#E87A00', low: '#C8C800' },
  'pothole':  { high: '#DC3C3C', medium: '#E87A00', low: '#C8C800' },
  'cracking': { high: '#E87A00', medium: '#C8C800', low: '#C8C800' },
  'crack':    { high: '#E87A00', medium: '#C8C800', low: '#C8C800' },
  'cracks':   { high: '#E87A00', medium: '#C8C800', low: '#C8C800' },
  'rutting':  { high: '#DC3C3C', medium: '#E87A00', low: '#C8C800' },
};

// Fixed-color defects: color is determined by label alone, ignoring severity
const BHILWARA_FIXED_COLOR = {
  'patching':                                              '#C8C800',
  'water stagnation':                                      '#E87A00',
  'rain cuts':                                             '#E87A00',
  'rain cuts shoulders':                                   '#E87A00',
  'shoulder rain cut':                                     '#E87A00',
  'edge drop uneven shoulders':                            '#DC3C3C',
  'shoulder edge drop':                                    '#DC3C3C',
  'shoulder unevenness':                                   '#DC3C3C',
  'damaged sign boards structures':                        '#DC3C3C',
  'damaged sign boards':                                   '#DC3C3C',
  'signage visibility day night':                          '#E87A00',
  'signage poor visibility (day)':                         '#E87A00',
  'signage poor visibility (night)':                       '#E87A00',
  'damaged lights':                                        '#DC3C3C',
  'damaged highway lights':                                '#DC3C3C',
  'non functional lights':                                 '#DC3C3C',
  'missing assets (street lights)':                        '#DC3C3C',
  'crash barriers guard rails damaged':                    '#DC3C3C',
  'damaged crash barriers':                                '#DC3C3C',
  'damaged metal beam crash barrier':                      '#DC3C3C',
  'damaged pedestrian guard rail':                         '#DC3C3C',
  'faded painting barrier guard rail':                     '#E87A00',
  'faded painting concrete crash barrier':                 '#E87A00',
  'barriers faded painting guard rails':                   '#E87A00',
  'damaged kerb faded paint':                              '#DC3C3C',
  'damaged kerb':                                          '#DC3C3C',
  'faded kerb painting':                                   '#DC3C3C',
  'damaged missing cover slabs':                           '#DC3C3C',
  'damaged drain cover slabs':                             '#DC3C3C',
  'missing drain cover slabs':                             '#DC3C3C',
  'damaged footpath':                                      '#E87A00',
  'damaged footpath tiles / paver blocks':                 '#E87A00',
  'damaged blinkers attenuators delineators anti glare':   '#DC3C3C',
  'damaged blinkers':                                      '#DC3C3C',
  'damaged attenuators':                                   '#DC3C3C',
  'damaged delineators':                                   '#DC3C3C',
  'damaged anti-glare':                                    '#DC3C3C',
  'damaged road studs rumble strips hazard markers':       '#E87A00',
  'damaged road studs':                                    '#E87A00',
  'damaged rumble strips':                                 '#E87A00',
  'damaged hazard markers':                                '#E87A00',
  'road stud rumble strip visibility day night':           '#C8C800',
  'road studs poor visibility (day)':                      '#C8C800',
  'road studs poor visibility (night)':                    '#C8C800',
  'damaged bus shelters faded markings damaged signages':  '#E87A00',
  'damaged bus shelters':                                  '#E87A00',
  'bus bay damaged shelters':                              '#E87A00',
  'truck lay by damaged shelters':                         '#E87A00',
  'bus bay faded markings':                                '#C8C800',
  'truck lay by faded markings':                           '#C8C800',
  'missing plants irregular gaps':                         '#E87A00',
  'missing plants / irregular gaps (median)':              '#E87A00',
  'deteriorated damaged plants':                           '#E87A00',
  'deteriorated or damaged plants (median)':               '#E87A00',
  'reduced visibility due to plant growth':                '#DC3C3C',
  'reduced visibility due to overgrowth':                  '#DC3C3C',
  'unauthorized signboards hoardings':                     '#E87A00',
  'unauthorized hoardings':                                '#E87A00',
  'holding advertisement boards':                          '#C8C800',
  'unauthorized advertisement board':                      '#C8C800',
  'faded pavement marking':                                '#DC3C3C',
  'pavement marking poor visibility (night)':              '#DC3C3C',
  'pavement marking visibility day night':                 '#E87A00',
  'pavement marking poor visibility (day)':                '#E87A00',
  'missing poor safety measures':                          '#DC3C3C',
  'work zone inadequate barricading':                      '#DC3C3C',
  'work zone inadequate signboard visibility':             '#DC3C3C',
  'inappropriate diversions':                              '#DC3C3C',
  'work zone poor diversion arrangement / condition':      '#DC3C3C',
  'encroachments illegal parking':                         '#E87A00',
  'general encroachment':                                  '#E87A00',
  'illegal parking':                                       '#E87A00',
  'unauthorized median openings':                          '#DC3C3C',
  'unauthorized median opening':                           '#DC3C3C',
  'vegetation growth shoulders':                           '#C8C800',
  'excessive plantation growth':                           '#C8C800',
  'overall cleanliness':                                   '#C8C800',
  'cleanliness litter':                                    '#C8C800',
  'cleanliness debris':                                    '#C8C800',
};

// Normalize a raw severity value to 'high' | 'medium' | 'low' | 'none'
const _normSeverity = (raw) => {
  const s = (raw || '').toLowerCase().trim();
  if (s === 'high' || s === 'h' || s === '3') return 'high';
  if (s === 'medium' || s === 'm' || s === '2') return 'medium';
  if (s === 'low' || s === 'l' || s === '1') return 'low';
  return 'none';
};

// Keyword fallback — catches backend label variants that don't substring-match the
// BHILWARA_FIXED_COLOR keys (e.g. "vegetation_growth_on_shoulders" vs "vegetation_growth_shoulders").
// Orange is checked BEFORE Red so "pavement marking visibility" labels don't fall through to red.
const _BHW_ORANGE_KW = [
  'water stagnation', 'stagnation',
  'rain cut',
  'signage visibility', 'visibility of signage', 'sign visibility',
  'faded painting', 'barrier paint',
  'footpath', 'paver block', 'footway',
  'damaged road stud', 'damaged rumble', 'hazard marker',
  'bus shelter', 'damaged bus',
  'missing plant', 'irregular gap',
  'deteriorated plant', 'damaged plant',
  'unauthorized signboard', 'unauthorized hoarding',
  'marking visibility', 'pavement marking visibility',
  'encroachment', 'illegal parking',
];
const _BHW_RED_KW = [
  'edge drop', 'uneven shoulder', 'unevenness',
  'damaged sign board', 'sign structure', 'sign board damage',
  'damaged light', 'highway light',
  'non functional', 'non-functional',
  'crash barrier', 'guard rail', 'guardrail',
  'damaged kerb', 'kerb faded', 'faded kerb', 'kerb paint',
  'drain cover', 'cover slab',
  'blinker', 'attenuator', 'delineator', 'anti-glare', 'anti glare',
  'sight distance', 'reduced visibility due to plant', 'overgrowth',
  'pavement marking', // generic — catches "pavement marking" alone after orange check passes
  'work zone', 'barricading',
  'inappropriate diversion',
  'median opening', 'unauthorized median',
];
const _BHW_YELLOW_KW = [
  'patching',
  'vegetation growth', 'shoulder vegetation', 'vegetation on shoulder',
  'studs & markers', 'studs and markers', 'stud visibility',
  'marker visibility', 'rumble strip visibility', 'road stud visibility',
  'bus bay marking', 'bus bay faded', 'faded bus bay',
  'truck lay by marking', 'faded truck lay',
  'advertisement board', 'advertisement hoarding', 'holding board',
  'cleanliness', 'litter', 'debris',
];

// Return the Bhilwara color for a single inference_info item (label + severity)
const _getBhilwaraLabelColor = (rawLabel, rawSeverity) => {
  const norm = _normLabelForColor(rawLabel);
  const sev = _normSeverity(rawSeverity);

  // 1. Exact match in severity-dependent map
  if (BHILWARA_SEVERITY_COLOR[norm]) {
    const colors = BHILWARA_SEVERITY_COLOR[norm];
    return colors[sev] || colors.low || '#C8C800';
  }
  // 2. Partial match in severity-dependent map
  for (const [key, colors] of Object.entries(BHILWARA_SEVERITY_COLOR)) {
    if (norm.includes(key) || key.includes(norm)) {
      return colors[sev] || colors.low || '#C8C800';
    }
  }
  // 3. Exact match in fixed-color map
  if (BHILWARA_FIXED_COLOR[norm]) return BHILWARA_FIXED_COLOR[norm];
  // 4. Partial match in fixed-color map
  for (const [key, color] of Object.entries(BHILWARA_FIXED_COLOR)) {
    if (norm.includes(key) || key.includes(norm)) return color;
  }
  // 5. Keyword fallback — handles backend label variants not caught above
  //    Orange checked before Red to avoid ambiguous "pavement marking" labels → red
  if (_BHW_ORANGE_KW.some(kw => norm.includes(kw))) return '#E87A00';
  if (_BHW_RED_KW.some(kw => norm.includes(kw))) return '#DC3C3C';
  if (_BHW_YELLOW_KW.some(kw => norm.includes(kw))) return '#C8C800';

  return null;
};

// Derive the dominant Bhilwara point color from a frame's inference_info array
const _getBhilwaraMarkerColor = (inferenceInfo) => {
  if (!inferenceInfo || inferenceInfo.length === 0) return '#00BB00';
  const COLOR_PRIORITY = { '#DC3C3C': 3, '#E87A00': 2, '#C8C800': 1 };
  const colorCounts = {};
  inferenceInfo.forEach(info => {
    let color = _getBhilwaraLabelColor(info.label || '', info.severity || '');
    if (!color) {
      const sev = _normSeverity(info.severity || '');
      if (sev === 'high') color = '#DC3C3C';
      else if (sev === 'medium') color = '#E87A00';
      else color = '#C8C800';
    }
    colorCounts[color] = (colorCounts[color] || 0) + 1;
  });
  const entries = Object.entries(colorCounts);
  if (entries.length > 0) {
    return entries.sort(
      (a, b) => b[1] - a[1] || (COLOR_PRIORITY[b[0]] || 0) - (COLOR_PRIORITY[a[0]] || 0)
    )[0][0];
  }
  return '#C8C800';
};

// ── Bhilwara filter panel: static label list and category config ──────────────
// Ordered list of display labels for bhilwaraUser's defect filter sidebar.
// Severity variants are separate checkboxes filtering by label + severity.
const BHILWARA_STATIC_LABELS = [
  'Pothole (High)', 'Pothole (Medium)', 'Pothole (Low)',
  'Cracking (High)', 'Cracking (Medium)', 'Cracking (Low)',
  'Rutting (High)', 'Rutting (Medium)', 'Rutting (Low)',
  'Patching', 'Water Stagnation',
  'Rain Cuts', 'Unevenness / Edge Drop Of Shoulder',
  'Damaged Sign Boards / Sign Structures', 'Visibility Of Signages (Day/Night)',
  'Highway Lights Damaged', 'Non-Functional Lights',
  'Damaged Crash Barriers / Guardrails (Cc/Mbcb)', 'Faded Painting On Barriers',
  'Damaged Kerb / Faded Kerb Painting',
  'Damaged / Missing Drain Cover Slabs',
  'Damaged Footpath (Tiles/Pavers)',
  'Damaged Blinkers / Attenuators / Delineators / Anti-Glare',
  'Missing/Damaged Road Studs / Rumble Strips / Hazard Markers', 'Visibility Of Studs & Markers (Day/Night)',
  'Damaged Bus Shelters', 'Faded Bus Bay / Truck Lay-By Markings',
  'Missing Plants / Irregular Gaps', 'Damaged / Deteriorated Plants', 'Reduced Sight Distance (Due To Overgrowth)',
  'Unauthorized Signboards / Hoardings', 'Holding / Advertisement Boards',
  'Pavement Marking (Faded)', 'Pavement Marking Visibility (Day/Night)',
  'Work Zone Safety (Signboard Visibility, Barricading)', 'Inappropriate Diversions',
  'Encroachment', 'Unauthorized Median Openings', 'Encroachments / Illegal Parking',
  'Vegetation Growth On Shoulders',
  'Cleanliness (Poor)',
];

// Names must be exact lowercase of BHILWARA_STATIC_LABELS so cbByLabel lookup succeeds.
const BHILWARA_SUB_CATEGORIES_CONFIG = {
  pavement: {
    pavement_condition: {
      label: 'Pavement Condition',
      names: [
        'pothole (high)', 'pothole (medium)', 'pothole (low)',
        'cracking (high)', 'cracking (medium)', 'cracking (low)',
        'rutting (high)', 'rutting (medium)', 'rutting (low)',
        'patching', 'water stagnation',
      ],
    },
    shoulder_condition: {
      label: 'Shoulder Condition',
      names: ['rain cuts', 'unevenness / edge drop of shoulder'],
    },
  },
  assets: {
    signages:         { label: 'Signages',                        names: ['damaged sign boards / sign structures', 'visibility of signages (day/night)'] },
    highway_lighting: { label: 'Highway Lighting',                names: ['highway lights damaged', 'non-functional lights'] },
    crash_barriers:   { label: 'Crash Barriers & Guard Rails',    names: ['damaged crash barriers / guardrails (cc/mbcb)', 'faded painting on barriers'] },
    kerb_median:      { label: 'Kerb & Median Condition',         names: ['damaged kerb / faded kerb painting'] },
    drainage:         { label: 'Drainage',                        names: ['damaged / missing drain cover slabs'] },
    footpath:         { label: 'Footpath',                        names: ['damaged footpath (tiles/pavers)'] },
    safety_devices:   { label: 'Safety Devices',                  names: ['damaged blinkers / attenuators / delineators / anti-glare'] },
    road_studs:       { label: 'Road Studs & Markers',            names: ['missing/damaged road studs / rumble strips / hazard markers', 'visibility of studs & markers (day/night)'] },
    bus_bay:          { label: 'Bus Bay & Truck Lay-By Facilities',names: ['damaged bus shelters', 'faded bus bay / truck lay-by markings'] },
    plantation:       { label: 'Plantation / Landscaping',        names: ['missing plants / irregular gaps', 'damaged / deteriorated plants', 'reduced sight distance (due to overgrowth)'] },
    unauthorized:     { label: 'Unauthorized Activity',           names: ['unauthorized signboards / hoardings', 'holding / advertisement boards'] },
  },
  roadSafety: {
    signages:         { label: 'Signages',                        names: ['damaged sign boards / sign structures', 'visibility of signages (day/night)'] },
    highway_lighting: { label: 'Highway Lighting',                names: ['highway lights damaged', 'non-functional lights'] },
    safety_devices:   { label: 'Safety Devices',                  names: ['damaged blinkers / attenuators / delineators / anti-glare'] },
    road_studs:       { label: 'Road Studs & Markers',            names: ['missing/damaged road studs / rumble strips / hazard markers', 'visibility of studs & markers (day/night)'] },
    pavement_markings:{ label: 'Pavement Markings',               names: ['pavement marking (faded)', 'pavement marking visibility (day/night)'] },
    work_zone:        { label: 'Work Zone Safety',                names: ['work zone safety (signboard visibility, barricading)', 'inappropriate diversions'] },
    crash_barriers:   { label: 'Crash Barriers & Guard Rails',    names: ['damaged crash barriers / guardrails (cc/mbcb)', 'faded painting on barriers'] },
    kerb_median:      { label: 'Kerb & Median Condition',         names: ['damaged kerb / faded kerb painting'] },
    unauthorized:     { label: 'Unauthorized Activity',           names: ['encroachment', 'unauthorized median openings', 'encroachments / illegal parking', 'unauthorized signboards / hoardings', 'holding / advertisement boards'] },
    plantation:       { label: 'Plantation / Landscaping',        names: ['vegetation growth on shoulders', 'missing plants / irregular gaps', 'damaged / deteriorated plants', 'reduced sight distance (due to overgrowth)'] },
    bus_bay:          { label: 'Bus Bay & Truck Lay-By Facilities',names: ['damaged bus shelters', 'faded bus bay / truck lay-by markings'] },
    cleanliness:      { label: 'Cleanliness',                     names: ['cleanliness (poor)'] },
  },
};

// ── In-memory cache (survives unmount/remount, no size limit) ──────────────
// sessionStorage has a ~5 MB limit and silently fails for large marker sets.
// This module-scope object keeps processed markers in RAM so returning to
// the GIS page after navigating away is instant (no API calls, no JSON parse).
const _memCache = { key: null, data: null, ts: 0 };
const MEM_CACHE_TTL = 4 * 60 * 60 * 1000; // 4 hours

// AuthContext.logout fires this event — drop the in-memory marker cache so
// the next login doesn't inherit the previous user's data.
if (typeof window !== 'undefined') {
  window.addEventListener('roadvision:logout', () => {
    _memCache.key = null;
    _memCache.data = null;
    _memCache.ts = 0;
  });
}

// Snap GPS survey points to nearest road centerline using Google Roads API.
// Runs in background batches of 100 — map shows raw coords first, then
// silently updates to snapped coords. Falls back gracefully if API not enabled.
// Infer direction tag for each marker based on its uid.
// Our consolidated uids look like "R116690_day_forward", "R180280_night_return", etc.
// Returns: "forward" | "return" | null (unknown)
const _directionFromUid = (uid) => {
  if (!uid || typeof uid !== 'string') return null;
  if (uid.endsWith('_forward')) return 'forward';
  if (uid.endsWith('_return')) return 'return';
  return null;
};

// Offset a lat/lon by (metersNorth, metersEast). Small-angle flat-earth approx.
const _offsetLatLng = (lat, lng, metersNorth, metersEast) => {
  const dLat = metersNorth / 111320.0;
  const dLng = metersEast / (111320.0 * Math.cos((lat * Math.PI) / 180));
  return { latitude: lat + dLat, longitude: lng + dLng };
};

// --- MapLibre helpers (replace google.maps.LatLngBounds + map.fitBounds) ---
// Free CARTO RASTER basemaps (no API key). We build a minimal raster style inline
// rather than load CARTO's vector GL style JSON — the vector style tripped a
// "Cannot read properties of undefined (reading 'carto')" parse error in this
// maplibre-gl version. Raster tiles render reliably on any MapLibre version.
const _rasterStyle = (name) => ({
  version: 8,
  sources: {
    basemap: {
      type: "raster",
      tiles: [
        `https://a.basemaps.cartocdn.com/${name}/{z}/{x}/{y}.png`,
        `https://b.basemaps.cartocdn.com/${name}/{z}/{x}/{y}.png`,
        `https://c.basemaps.cartocdn.com/${name}/{z}/{x}/{y}.png`,
        `https://d.basemaps.cartocdn.com/${name}/{z}/{x}/{y}.png`,
      ],
      tileSize: 256,
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
    },
  },
  layers: [{ id: "basemap", type: "raster", source: "basemap" }],
});
const MAPLIBRE_STYLE_LIGHT = _rasterStyle("light_all"); // positron-equivalent (light)
const MAPLIBRE_STYLE_DARK = _rasterStyle("dark_all");   // dark-matter-equivalent (dark)

// Hard cap on dots/segments handed to deck.gl per frame. The viewport filter keeps
// this bounded at normal zooms; the cap is the safety net for very low zoom
// (whole-country view) where the viewport still holds 100k+ points.
const VIEWPORT_RENDER_CAP = 20000;

// Fit a MapLibre map to a list of coords. Accepts {lat,lng} or {latitude,longitude}.
// `padding` may be a number or {top,bottom,left,right} (same shape Google accepted).
const fitMapToCoords = (map, coords, padding, opts = {}) => {
  if (!map || !coords || coords.length === 0) return;
  let minLng = Infinity, minLat = Infinity, maxLng = -Infinity, maxLat = -Infinity;
  for (const c of coords) {
    const lat = c.lat != null ? c.lat : c.latitude;
    const lng = c.lng != null ? c.lng : c.longitude;
    if (lat == null || lng == null) continue;
    minLat = Math.min(minLat, lat); maxLat = Math.max(maxLat, lat);
    minLng = Math.min(minLng, lng); maxLng = Math.max(maxLng, lng);
  }
  if (!isFinite(minLng)) return;
  try {
    map.fitBounds([[minLng, minLat], [maxLng, maxLat]], {
      padding: padding != null ? padding : 40,
      duration: 0,
      maxZoom: opts.maxZoom != null ? opts.maxZoom : 18,
    });
  } catch (e) { /* noop */ }
};

const snapMarkersToRoads = async (markers) => {
  const apiKey = process.env.REACT_APP_GOOGLE_KEYS;
  if (!apiKey || markers.length === 0) return markers;

  // Use snapToRoads (with path) for ordered sequences — gives better alignment
  // than nearestRoads. Falls back to nearestRoads if Roads API rejects snapToRoads.
  const BATCH_SIZE = 100;
  const snappedCoords = new Map();

  const batches = [];
  for (let i = 0; i < markers.length; i += BATCH_SIZE) {
    batches.push({ startIdx: i, items: markers.slice(i, i + BATCH_SIZE) });
  }

  await Promise.all(batches.map(async ({ startIdx, items }) => {
    const path = items.map(m => `${m.latitude},${m.longitude}`).join('|');
    try {
      let res = await fetch(
        `https://roads.googleapis.com/v1/snapToRoads?path=${encodeURIComponent(path)}&interpolate=false&key=${apiKey}`
      );
      let data = await res.json();
      if (!data.snappedPoints) {
        res = await fetch(
          `https://roads.googleapis.com/v1/nearestRoads?points=${encodeURIComponent(path)}&key=${apiKey}`
        );
        data = await res.json();
      }
      if (data.snappedPoints) {
        data.snappedPoints.forEach(sp => {
          if (sp.originalIndex !== undefined && sp.originalIndex !== null) {
            snappedCoords.set(startIdx + sp.originalIndex, {
              latitude: sp.location.latitude,
              longitude: sp.location.longitude,
            });
          }
        });
      }
    } catch (e) {
      console.warn(`Road snapping failed for batch starting at ${startIdx}:`, e);
    }
  }));

  if (snappedCoords.size === 0) {
    console.warn("⚠ Snap to Roads returned no data — check Roads API is enabled on your GCP project.");
    return markers;
  }

  // Apply snapped coordinates. For bidirectional stretches (forward/return),
  // offset the snapped point ~3 m perpendicular to the road direction so
  // forward and return don't overlap on the centerline.
  //
  // Offset direction: we use the previous→next marker vector to estimate local
  // road bearing, then take its left normal for "forward", right normal for "return".
  const LANE_OFFSET_M = 3.0;

  const isBidi = (m) => {
    const rid = m.road_id;
    return rid === 'R116690' || rid === 'R180280';
  };

  const result = markers.map((m, i) => {
    const snapped = snappedCoords.get(i);
    if (!snapped) return m;

    const direction = _directionFromUid(m.uid);
    if (!isBidi(m) || !direction) {
      // Unidirectional or unknown direction: just snap, no offset
      return { ...m, ...snapped };
    }

    // Compute local road bearing using neighboring SNAPPED points
    let prev = snappedCoords.get(i - 1) || snapped;
    let next = snappedCoords.get(i + 1) || snapped;
    // If both fallbacks, no bearing — return snapped without offset
    if (prev === snapped && next === snapped) {
      return { ...m, ...snapped };
    }

    // Road direction vector (in degrees lat/lng)
    const dLat = next.latitude - prev.latitude;
    const dLng = next.longitude - prev.longitude;

    // Convert to approximate meters (flat-earth) to get perpendicular unit vector
    const mLat = snapped.latitude;
    const kLng = 111320.0 * Math.cos((mLat * Math.PI) / 180);
    const vxM = dLng * kLng;      // east  component (m)
    const vyM = dLat * 111320.0;  // north component (m)
    const len = Math.hypot(vxM, vyM) || 1;
    // Left normal (−y, +x) for "forward", right normal (+y, −x) for "return"
    let offNorthM, offEastM;
    if (direction === 'forward') {
      offNorthM = -vxM / len * LANE_OFFSET_M;
      offEastM  =  vyM / len * LANE_OFFSET_M;
    } else { // return
      offNorthM =  vxM / len * LANE_OFFSET_M;
      offEastM  = -vyM / len * LANE_OFFSET_M;
    }
    const offset = _offsetLatLng(snapped.latitude, snapped.longitude, offNorthM, offEastM);
    return { ...m, ...offset };
  });

  return result;
};

// ── Reusable searchable, scrollable multi-select dropdown body ───────────────
// Shared by the top filter bar (Road Name, Authority, Road Type, Road Condition).
// Keeps the menu compact (capped height + internal scroll) and adds a search box
// so long option lists (e.g. dozens of wards/roads) stay usable. Search state is
// internal so each menu manages its own query independently.
const FilterCheckboxMenu = ({ options, selected, onToggle, width = 'w-48', placeholder = 'Search...' }) => {
  const [query, setQuery] = useState('');
  const q = query.trim().toLowerCase();
  const filtered = q ? options.filter(opt => String(opt).toLowerCase().includes(q)) : options;
  return (
    <div className={`absolute top-full left-0 mt-1 ${width} bg-white rounded-lg shadow-xl border border-gray-200 z-50 flex flex-col max-h-72`}>
      <div className="p-2 border-b border-gray-100">
        <div className="relative">
          <input
            type="text"
            autoFocus
            placeholder={placeholder}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="w-full px-3 py-1.5 pl-8 text-xs border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <svg className="w-3.5 h-3.5 text-slate-400 absolute left-2.5 top-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      </div>
      <div className="overflow-y-auto flex-1 py-1">
        {filtered.length > 0 ? filtered.map(opt => (
          <label key={opt} className="flex items-center gap-2 px-3 py-1.5 hover:bg-gray-50 cursor-pointer text-sm text-gray-700">
            <input type="checkbox" className="w-3.5 h-3.5 accent-blue-600" checked={selected.includes(opt)} onChange={() => onToggle(opt)} />
            {opt}
          </label>
        )) : (
          <div className="px-3 py-2 text-xs text-gray-400 text-center">No matches</div>
        )}
      </div>
    </div>
  );
};

const MultiMap = () => {
  const { brandingSettings } = useBranding();
  const { isLabelEnabled, processedLabels } = useDefectConfig();
  const { authorities: AUTHORITY_OPTIONS_FROM_CTX } = useAuthority();
  // Admin-configurable basemap tiles (Settings → Application Settings). When a
  // custom XYZ tile is set it overrides the built-in light/dark basemaps.
  const { isCustom: isCustomTile, rasterStyle: customTileStyle } = useMapTile();
  // Geocode.setApiKey(process.env.REACT_APP_GOOGLE_KEYS); // replaced by Nominatim (free) in getAddressFromGoogleMaps
  const isKhammamUser = (JSON.parse(window.localStorage.getItem("user"))?.email || "").toLowerCase() === "khammam@roadvision.ai";
  const isBhilwaraUser = (JSON.parse(window.localStorage.getItem("user"))?.email || "").toLowerCase() === "bhilwarauser@roadvision.ai";
  // Ahmedabad: the pipeline emits the full defect class list (meta_data.processed_labels,
  // surfaced by /labels → processedLabels). The GIS filter lists EVERY processed defect,
  // not just detected ones, so selecting a zero-detection defect shows a "No data found"
  // empty-state instead of silently missing from the list. Gated to Ahmedabad for now.
  const isAhmedabadUser = (() => {
    try {
      const org = (window.localStorage.getItem('organization') || '').trim().toLowerCase();
      if (org === 'ahmedabadorg') return true;
      const user = JSON.parse(window.localStorage.getItem('user') || '{}');
      return (user?.organization || '').toString().trim().toLowerCase() === 'ahmedabadorg';
    } catch { return false; }
  })();
  // SuperAdmin-only GIS controls: (1) an Organization filter so the SuperAdmin can
  // deselect orgs they don't want on the map, and (2) a rule that only shows markers
  // whose frame image (og_file) is a full http(s) URL present in MongoDB.
  const isSuperAdmin = (window.localStorage.getItem("role") || "").replace(/^"|"$/g, "") === "SuperAdmin";
  const isFullHttpUrl = (s) => typeof s === "string" && /^https?:\/\//i.test(s.trim());

  // --- state (kept same as original) ---
  const [markers, setMarkers] = useState([]);
  const [open, setOpen] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(13);
  // Current map viewport bounds {west,south,east,north}. Drives viewport-scoped
  // clustering so we never render/process the full marker set at once.
  const [mapBounds, setMapBounds] = useState(null);
  const [selectedRadio, setSelectedRadio] = useState("ai_analyzed");
  const [polylinePaths, setPolylinePaths] = useState([]);
  const [allInferenceList, setInferenceList] = useState([]);
  const [info, setInfo] = useState({});
  const [selectedPolylineData, setSelectedPolylineData] = useState(null);
  const [isPolylineModalOpen, setPolylineModalOpen] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState({ latitude: null, longitude: null });
  // Visual position of the road-engineer marker. Tweened separately from
  // selectedMarker so the icon glides between defect points instead of jumping.
  const [markerPos, setMarkerPos] = useState({ latitude: null, longitude: null });
  const markerPosRef = useRef({ latitude: null, longitude: null }); // live position for the rAF tween
  const markerAnimRef = useRef(null); // in-flight requestAnimationFrame id
  const [center, setCenter] = useState({ lat: 17.2473, lng: 80.1514 }); // Khammam center
  const [hasInitialFit, setHasInitialFit] = useState(false); // tracks if we've done initial fitBounds
  // True while markers are being painted progressively (batch-by-batch) during the
  // initial fetch. The auto-fit effect skips while this is set so it doesn't lock
  // the zoom to a partial first-group view — the full fit runs once on final commit.
  const isProgressiveLoadingRef = useRef(false);
  const [geolocated, setGeolocated] = useState(false); // tracks if user location was used for initial center
  const [currentMarkerIndex, setCurrentMarkerIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(false);
  const [autoPlayIntervalId, setAutoPlayIntervalId] = useState(null);
  const [isRoad, setIsRoad] = useState(false);
  const [imageSrc, setImageSrc] = useState({ og_src: "", ai_src: "" });
  const [imgLoaded, setImgLoaded] = useState(false); // current image finished loading (drives fade-in)
  const [prevImgSrc, setPrevImgSrc] = useState("");  // last fully-loaded image, kept underneath during cross-fade
  // Geometry of the rendered frame relative to its wrapper, for bbox overlays.
  // {offX, offY, scale}: a natural-pixel point (px,py) maps to wrapper offset
  // (offX + px*scale, offY + py*scale). Measured from the real image rect so it
  // is correct in both panel (img fills wrapper) and fullscreen (img centered).
  const [imgGeom, setImgGeom] = useState(null);
  const [backupMarkerState, setBackupMarkerState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPending, startTransition] = useTransition();
  const [isMapReady, setIsMapReady] = useState(false);
  const [markersLoaded, setMarkersLoaded] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [mapStyleMode, setMapStyleMode] = useState('white'); // 'white' or 'dark'
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [mapDisplayMode, setMapDisplayMode] = useState('defects'); // 'defects' | 'heatmap' | 'road_condition'
  const [trafficCongestionData, setTrafficCongestionData] = useState([]); // traffic congestion points from road data
  const [showTrafficCongestion, setShowTrafficCongestion] = useState(false); // filter toggle for traffic congestion layer
  const [selectedTrafficPoint, setSelectedTrafficPoint] = useState(null); // clicked traffic congestion point for InfoWindow
  const [panelWidth, setPanelWidth] = useState(360); // right panel width in px
  const panelDragRef = useRef(null); // tracks drag state for resize handle
  const [isPanelDragging, setIsPanelDragging] = useState(false); // locks cursor during panel resize
  const [isImageFullView, setIsImageFullView] = useState(false); // tracks browser fullscreen state

  // Toggle the image into / out of the browser's native fullscreen via the
  // standard Fullscreen API. Native fullscreen ignores all React/CSS layout —
  // it puts the chosen element on top of the OS viewport — so we sidestep
  // every containing-block / z-index issue the previous lightbox approach hit.
  // The `src` is read lazily from imageRef.current so we don't capture
  // selectedImageSrc here (it's declared later in the component, hoisting
  // it into a useCallback dep would trip the TDZ at render time).
  const toggleImageFullView = useCallback(() => {
    const wrap = imageWrapperRef.current;
    if (!wrap) return;
    if (document.fullscreenElement) {
      document.exitFullscreen?.();
      return;
    }
    const newTabFallback = () => {
      const src = imageRef.current?.src;
      if (src) window.open(src, '_blank', 'noopener');
    };
    if (wrap.requestFullscreen) {
      wrap.requestFullscreen().catch(newTabFallback);
    } else {
      newTabFallback();
    }
  }, []);

  // Keep React state in sync with the browser's actual fullscreen status,
  // but ONLY when the fullscreen element is the road image itself — the page
  // also has a top-level "Full Screen" button that fullscreens documentElement,
  // and we don't want clicking that to flip the image-fullscreen flag.
  useEffect(() => {
    const onChange = () => {
      setIsImageFullView(document.fullscreenElement === imageWrapperRef.current);
    };
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  // preserved references
  var polylineSegments = [];
  const [searchParams, setSearchParams] = useSearchParams();
  const uid_list = useMemo(() => JSON.parse(decodeURIComponent(searchParams.get("listOfIds") || "[]")), [searchParams]);

  // Optional chainage-segment filter — set when a user clicks Map on a row of
  // the Reports → Chainage table. Format: bbox=lat1,lng1,lat2,lng2 (start and
  // end coords of the segment). Markers outside that bounding box (with a
  // small buffer to catch markers parked at the edge of the segment) are
  // hidden, and the map view is fit to those bounds.
  const chainageBbox = useMemo(() => {
    const raw = searchParams.get('bbox');
    if (!raw) return null;
    const parts = raw.split(',').map(Number);
    if (parts.length !== 4 || !parts.every(Number.isFinite)) return null;
    const [lat1, lng1, lat2, lng2] = parts;
    const buffer = 0.0003;  // ≈ 33 m on either side — covers GPS jitter
    return {
      minLat: Math.min(lat1, lat2) - buffer,
      maxLat: Math.max(lat1, lat2) + buffer,
      minLng: Math.min(lng1, lng2) - buffer,
      maxLng: Math.max(lng1, lng2) + buffer,
      raw: { lat1, lng1, lat2, lng2 },
    };
  }, [searchParams]);
  const chainageLabelParam = searchParams.get('chainage') || '';
  const imageRef = useRef(null);
  // Wrapper around the road image. Fullscreen targets this div (not the
  // <img>) so the buttons sitting on top stay visible in fullscreen — the
  // browser fullscreens the chosen element and only its descendants.
  const imageWrapperRef = useRef(null);
  const zoomTimeoutRef = useRef(null);
  const mapRef = useRef(null);
  const overlayRef = useRef(null);
  const isFilteringRef = useRef(false); // prevents filter re-trigger loop
  const defectTypesAppliedRef = useRef(false); // prevents re-applying URL defect filter

  // --- existing helper functions & effects (kept intact) ---
  const updatePolylinePaths = useCallback((newMarkers) => {
    if (isRoad) {
      const paths = newMarkers.map((marker) => ({
        lat: marker.latitude,
        lng: marker.longitude,
      }));
      setPolylinePaths(paths);
    } else {
      setPolylinePaths([]);
    }
  }, [isRoad]);
  polylineSegments.push(polylinePaths);

  useEffect(() => {
    updatePolylinePaths(markers);
  }, [markers, updatePolylinePaths]);

  useEffect(() => {
    if (markers.length === 0) return;

    let tempMarkers = markers;
    if (isRoad) {
      tempMarkers = markers.map((marker) => ({ ...marker, isvisible: false }));
      let temp = { ...checkboxes };
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = false; });
      setCheckboxes(temp);
      temp = { ...severityOptions };
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = false; });
      setSeverityOptions(temp);
    } else {
      polylineSegments = [];
      tempMarkers = markers.map((marker) => ({ ...marker, isvisible: true }));
      let temp = { ...segmentOptions };
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = false; });
      setSegmentOptions(temp);
    }
    setMarkers(tempMarkers);
  }, [isRoad]);

  // Geolocation-based centering disabled — map defaults to India center until markers load.

  // ── GIS defect-point cache helpers ────────────────────────────────────────
  // Uses sessionStorage so data is fresh on every new browser tab but instant
  // on re-navigation within the same session.
  const GIS_CACHE_TTL = 4 * 60 * 60 * 1000; // 4 hours
  const GIS_CACHE_VER = 'v13';

  const _gisHashKey = (str) => {
    let h = 5381;
    for (let i = 0; i < str.length; i++) h = ((h << 5) + h) ^ str.charCodeAt(i);
    return (h >>> 0).toString(36);
  };

  // Per-org/user cache scope. sessionStorage persists across logins in the same
  // tab, so an unscoped `gis_list` key let one org's cached project list bleed
  // into another org's session (e.g. Ahmedabad loading an IBI org's pothole
  // surveys). Scoping every GIS cache key by org+email prevents that cross-org bleed.
  const _gisScope = (() => {
    try {
      const org = (window.localStorage.getItem('organization') || '').trim().toLowerCase();
      const email = (JSON.parse(window.localStorage.getItem('user') || '{}')?.email || '').toLowerCase();
      return _gisHashKey(`${org}|${email}`);
    } catch { return 'anon'; }
  })();

  const _gisReadCache = (key) => {
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      const { payload, ts } = JSON.parse(raw);
      if (Date.now() - ts > GIS_CACHE_TTL) { sessionStorage.removeItem(key); return null; }
      return payload;
    } catch { return null; }
  };

  const _gisWriteCache = (key, payload) => {
    try {
      sessionStorage.setItem(key, JSON.stringify({ payload, ts: Date.now() }));
    } catch (e) {
      // sessionStorage full — skip cache write, data still shows correctly
      console.warn('GIS cache write failed (storage full?):', e.message);
    }
  };
  // ──────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const fetchData = async () => {
      let projectIds = Array.isArray(uid_list)
        ? uid_list.filter(Boolean).map((uid) => String(uid))
        : [];

      // No UIDs in URL — fetch all projects from get_list (cached for 15 min)
      if (projectIds.length === 0) {
        const listCacheKey = `gis_list_${GIS_CACHE_VER}_${_gisScope}`;
        const cachedList = _gisReadCache(listCacheKey);
        if (cachedList) {
          projectIds = cachedList;
        } else {
          try {
            const listRes = await axios.get(`${process.env.REACT_APP_BASE_URL}project/get_list`);
            const inferences = listRes.data.result.inferences || [];
            projectIds = inferences.map(inf => inf.uid || inf['$oid']).filter(Boolean);
            // Short TTL for the project list so new surveys appear within 15 min
            try {
              sessionStorage.setItem(listCacheKey, JSON.stringify({ payload: projectIds, ts: Date.now() - GIS_CACHE_TTL + 15 * 60 * 1000 }));
            } catch { }
          } catch (e) {
            console.error('Failed to fetch project list:', e);
            setMarkersLoaded(true);
            return;
          }
        }
      }

      if (projectIds.length === 0) return;

      // Check in-memory cache first (instant, no size limit, survives unmount)
      const sortedKey = projectIds.slice().sort().join(',');
      const markersCacheKey = `gis_markers_${GIS_CACHE_VER}_${_gisScope}_${_gisHashKey(sortedKey)}`;

      if (_memCache.key === markersCacheKey && Date.now() - _memCache.ts < MEM_CACHE_TTL) {
        console.log(`⚡ GIS memory-cache hit: ${_memCache.data.markers.length} markers loaded instantly`);
        setMarkers(_memCache.data.markers);
        setBackupMarkerState(_memCache.data.markers);
        setWardOptions(_memCache.data.wardOptions);
        setMarkersLoaded(true);
        return;
      }

      // Fallback: check sessionStorage cache (survives page-level re-renders)
      const cachedResult = _gisReadCache(markersCacheKey);
      if (cachedResult) {
        console.log(`✅ GIS sessionStorage cache hit: ${cachedResult.markers.length} markers loaded instantly`);
        setMarkers(cachedResult.markers);
        setBackupMarkerState(cachedResult.markers);
        setWardOptions(cachedResult.wardOptions);
        setMarkersLoaded(true);
        // Promote to memory cache for even faster subsequent hits
        _memCache.key = markersCacheKey;
        _memCache.data = cachedResult;
        _memCache.ts = Date.now();
        return;
      }

      try {
        const BATCH_SIZE = 10;
        const CONCURRENT_BATCHES = 3;
        let allInferences = [];

        const batches = [];
        for (let i = 0; i < projectIds.length; i += BATCH_SIZE) {
          batches.push(projectIds.slice(i, i + BATCH_SIZE));
        }

        console.log(`Loading ${projectIds.length} projects in ${batches.length} batches...`);

        const fetchBatch = async (batch, batchNumber) => {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_BASE_URL}project/get_project_by_id`,
              // SuperAdmin loads every org → use the ultra-slim "maponly" payload
              // (server-side og_file filter + bbox/og_file/inference_image dropped).
              // Normal org users keep the existing slim payload, unchanged.
              isSuperAdmin
                ? { project_uids: batch, maponly: true }
                : { project_uids: batch, slim: true },
              { headers: { 'Content-Type': 'application/json' } }
            );
            if (response.data.result.inferences) return response.data.result.inferences;
            return [];
          } catch (batchError) {
            console.error(`Batch ${batchNumber} failed:`, batchError.message);
            return [];
          }
        };

        const normalizeLabel = (label) => label.replace(/–|−|—/g, '-').replace(/[\s_]+/g, '_');
        const uniqueCoordinatesMap = new Map();

        // Dedup one batch group's inferences into uniqueCoordinatesMap (keyed by
        // "lat,lng"). Pulled out of the old single post-loop pass so we can paint
        // markers progressively as each group arrives instead of after the last batch.
        const ingestInferences = (inferences) => {
          inferences.forEach((inference) => {
            const { CODEBUILD_BUILD_ID, NEW_CODEBUILD_BUILD_ID } = inference.data;
            const road_rating = inference.data?.road_rating;
            const created = inference.created?.["$date"] || inference.created;
            const road_id = inference.data?.road_id || inference.road_id || '';
            const project_title_display = inference.data?.project_title_display || inference.project_title_display || '';
            const authority = inference.data?.authority || inference.authority || '';
            const road_type = inference.data?.road_type || inference.road_type || '';
            const organization = inference.organization || inference.data?.organization || '';
            const uid = inference.uid;

            (inference.data.frame_list_data || []).forEach((point) => {
              if (!point.latitude || !point.longitude || (point.latitude === 0 && point.longitude === 0)) return;
              // SuperAdmin view: only show data whose frame image URL is fully present in MongoDB.
              // In maponly mode this filter already ran SERVER-SIDE and og_file is
              // stripped from the payload, so guard on og_file being present to avoid
              // dropping every point here. (Normal/full payloads still filter as before.)
              if (isSuperAdmin && point.og_file != null && !isFullHttpUrl(point.og_file)) return;
              const coordinate = `${point.latitude},${point.longitude}`;
              const existing = uniqueCoordinatesMap.get(coordinate);

              if (point.inference_info) {
                point.inference_info.forEach(info => { info.label = normalizeLabel(info.label || ''); });
              }

              if (!existing || (point.inference_info?.length > 0 && !existing.inference_info?.length)) {
                uniqueCoordinatesMap.set(coordinate, {
                  ...point,
                  CODEBUILD_BUILD_ID,
                  NEW_CODEBUILD_BUILD_ID,
                  road_rating,
                  created,
                  road_id,
                  project_title_display,
                  authority,
                  road_type,
                  uid,
                  organization,
                  isvisible: true
                });
              }
            });
          });
        };

        // Progressive load: dedup + paint each group as it arrives instead of
        // blocking on the whole fetch. We update `markers` only (NOT
        // backupMarkerState) — the debounced filter effect early-returns while
        // backupMarkerState is empty, so these intermediate frames are never
        // clobbered, and the user watches dots fill in rather than a blank spinner.
        // Throttled to ~every 5th group to avoid a deck.gl rebuild per group.
        isProgressiveLoadingRef.current = true;
        for (let i = 0; i < batches.length; i += CONCURRENT_BATCHES) {
          const batchGroup = batches.slice(i, i + CONCURRENT_BATCHES);
          const results = await Promise.all(batchGroup.map((batch, index) => fetchBatch(batch, i + index + 1)));
          const groupInferences = results.flat();
          allInferences = allInferences.concat(groupInferences);

          ingestInferences(groupInferences);
          const groupNo = i / CONCURRENT_BATCHES;
          if (groupNo === 0 || groupNo % 5 === 0) {
            // Plain (not startTransition) so these stay sequential and the final
            // setMarkers(enriched) below is authoritative. A low-priority transition
            // here could be re-applied AFTER the final commit, reverting markers to a
            // partial set and leaving the map fitted but under-populated.
            setMarkers(Array.from(uniqueCoordinatesMap.values()));
            setMarkersLoaded(true);
          }

          if (i + CONCURRENT_BATCHES < batches.length) {
            await new Promise(resolve => setTimeout(resolve, 200));
          }
        }

        console.log(`Total inferences loaded: ${allInferences.length}`);
        setInferenceList(allInferences);

        // Final enrich. _ward (nearest Khammam ward) is consumed ONLY by the
        // Khammam ward-filter UI, which is itself gated to the Khammam user — so
        // skip the O(markers × wards) findNearestWard pass entirely for everyone
        // else. It used to run for all users and blocked first paint.
        const dedupedMarkers = Array.from(uniqueCoordinatesMap.values());
        const enriched = isKhammamUser
          ? dedupedMarkers.map(m => ({
              ...m,
              _ward: findNearestWard(Number(m.latitude), Number(m.longitude))
            }))
          : dedupedMarkers;

        const sortedWards = isKhammamUser
          ? (() => {
              const wardSet = new Set(enriched.map(m => m._ward));
              return KHAMMAM_WARDS.filter(w => wardSet.has(w.name)).map(w => w.name);
            })()
          : [];
        setWardOptions(sortedWards);
        // Progressive phase done — allow the auto-fit effect to fit to ALL markers.
        isProgressiveLoadingRef.current = false;
        setMarkers(enriched);
        setBackupMarkerState(enriched);
        setMarkersLoaded(true);

        // Explicitly fit the map to ALL markers now that loading is complete, so the
        // view always lands on the data regardless of effect/transition timing. If the
        // map isn't ready yet, the auto-fit effect / onLoad handler do it instead.
        if (mapRef.current && enriched.length > 0 && !hasInitialFit) {
          if (isKhammamUser) {
            mapRef.current.setCenter([80.15, 17.25]); // [lng, lat]
            mapRef.current.setZoom(13.7);
          } else {
            fitMapToCoords(
              mapRef.current,
              enriched.map(m => ({ lat: m.latitude, lng: m.longitude })),
              40,
              { maxZoom: 14 }
            );
          }
          setHasInitialFit(true);
        }
        console.log(`✅ ${enriched.length} markers ready, ${sortedWards.length} wards`);

        // Save to in-memory cache (always works, no size limit)
        const cachePayload = { markers: enriched, wardOptions: sortedWards };
        _memCache.key = markersCacheKey;
        _memCache.data = cachePayload;
        _memCache.ts = Date.now();

        // Also try sessionStorage (may fail for large datasets, that's OK)
        _gisWriteCache(markersCacheKey, cachePayload);

        // Snap to roads in background. Mutate coords IN-PLACE on the shared objects
        // so every existing closure (filter, segments, etc.) immediately sees snapped
        // values — avoids the revert caused by stale-closure filter re-runs.
        //
        // GUARD: skip snapping for SuperAdmin / very large datasets. snapMarkersToRoads
        // fires ~ceil(markers/100) Google Roads requests — thousands for a 1M-point
        // SuperAdmin load — which saturates the browser's ~6-connection pool and leaves
        // the basemap tile requests stuck "pending" (blank/unresponsive map). At this
        // scale the map shows clusters, not individual dots, so snapping adds no value.
        const SNAP_MAX_MARKERS = 5000;
        if (isSuperAdmin || enriched.length > SNAP_MAX_MARKERS) {
          console.log(`⏭️ Skipping road-snapping (${enriched.length} markers, superAdmin=${isSuperAdmin}) — avoids flooding the network with Roads API calls.`);
        } else {
        snapMarkersToRoads(enriched).then(snapped => {
          if (snapped === enriched) return; // API not enabled / quota exceeded
          snapped.forEach((sm, i) => {
            enriched[i].latitude = sm.latitude;
            enriched[i].longitude = sm.longitude;
          });
          // Shallow-copy markers only (not backupMarkerState) so React re-renders
          // with snapped positions. backupMarkerState objects are the same shared
          // references — already mutated — so no need to create a new array ref
          // (avoids re-running filterCheckboxMarkers and the label-extraction effect).
          // Wrap in startTransition to keep the UI responsive during the re-render.
          startTransition(() => {
            setMarkers(prev => [...prev]);
          });
          const snappedPayload = { ...cachePayload, markers: [...enriched] };
          _memCache.data = snappedPayload;
          // Persist the SNAPPED coords to sessionStorage too. Previously only the
          // in-memory cache got snapped coords while sessionStorage kept the pre-snap
          // ones — so a full page reload (mem cache gone) hit the sessionStorage cache
          // and re-ran the entire ~ceil(markers/100)-call snap pass every time. Writing
          // back here means reloads reuse snapped coords and skip the Roads API entirely.
          _gisWriteCache(markersCacheKey, snappedPayload);
          console.log(`📍 Road snapping applied to ${enriched.length} markers`);
        }).catch(() => { });
        }
      } catch (err) {
        console.error("ERROR fetching markers:", err);
        isProgressiveLoadingRef.current = false;
        setMarkersLoaded(true);
      }
    };
    fetchData();
  }, [uid_list]);

  // Fetch traffic congestion points from road data + static Bhilwara KMZ points
  useEffect(() => {
    const fetchTrafficData = async () => {
      try {
        const token = localStorage.getItem('token')?.replace(/^"|"$/g, '');
        if (!token) return;
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}dataUpload/get_excel_data`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );
        const roads = response.data.result || [];
        const allTrafficPoints = [];
        roads.forEach(road => {
          if (road.traffic_congestion_points && road.traffic_congestion_points.length > 0) {
            road.traffic_congestion_points.forEach(tp => {
              if (tp.latitude && tp.longitude) {
                allTrafficPoints.push({
                  latitude: tp.latitude,
                  longitude: tp.longitude,
                  address: tp.address || '',
                  road_name: road.road_name || '',
                  road_id: road.road_id || ''
                });
              }
            });
          }
        });

        // Bhilwara: merge static KMZ traffic points
        if (isBhilwaraUser) {
          BHILWARA_TRAFFIC_POINTS.forEach(tp => {
            allTrafficPoints.push({
              latitude: tp.latitude,
              longitude: tp.longitude,
              address: tp.name,
              road_name: '',
              road_id: ''
            });
          });
        }

        setTrafficCongestionData(allTrafficPoints);
      } catch (err) {
        console.error('Failed to fetch traffic congestion data:', err);
      }
    };
    fetchTrafficData();
  }, [isBhilwaraUser]);

  // Extract unique defect labels from markers and build checkboxes dynamically
  useEffect(() => {
    if (backupMarkerState.length === 0) return;

    // Bhilwara: use a fixed static label list instead of deriving from backend data
    if (isBhilwaraUser) {
      setCheckboxes(prevCheckboxes => {
        const newCheckboxes = {
          0: { id: "0", label: "All Defect Types", prefix: "ALL", selected: prevCheckboxes[0]?.selected || false },
        };
        const enabledBhilwaraLabels = BHILWARA_STATIC_LABELS.filter(l => isLabelEnabled(l));
        enabledBhilwaraLabels.forEach((label, index) => {
          const existing = Object.values(prevCheckboxes).find(cb => cb.label === label);
          newCheckboxes[index + 1] = {
            id: (index + 1).toString(),
            label,
            prefix: label.split(' ').map(w => w.charAt(0)).join('').toUpperCase(),
            selected: existing?.selected || false,
          };
        });
        const currentLabels = Object.values(prevCheckboxes).map(cb => cb.label).sort().join(',');
        const newLabels = Object.values(newCheckboxes).map(cb => cb.label).sort().join(',');
        return currentLabels !== newLabels ? newCheckboxes : prevCheckboxes;
      });
      return;
    }

    // Ahmedabad: build the filter from the pipeline's full processed-label list
    // (processedLabels, from /labels → meta_data.processed_labels) instead of only
    // the labels present on detected markers. Labels the model processed but never
    // detected still appear (count 0); selecting one surfaces "No data found".
    // Ahmedabad marker labels are already canonical (e.g. "Cleanliness - Debris"),
    // matching processedLabels exactly, so no _format() reshaping is applied.
    if (isAhmedabadUser && processedLabels.length > 0) {
      const labelCounts = {};
      backupMarkerState.forEach(marker => {
        marker.inference_info?.forEach(info => {
          if (info.label) labelCounts[info.label] = (labelCounts[info.label] || 0) + 1;
        });
      });

      const sortedLabels = processedLabels
        .filter(label => isLabelEnabled(label))
        .slice()
        .sort();

      console.log('=== Ahmedabad Defect Filter (processed_labels) ===');
      sortedLabels.forEach(label => {
        console.log(`${label}: ${labelCounts[label] || 0} points`);
      });
      console.log('Total processed labels:', sortedLabels.length);
      console.log('==================================');

      setCheckboxes(prevCheckboxes => {
        const newCheckboxes = {
          0: { id: "0", label: "All Defect Types", prefix: "ALL", selected: prevCheckboxes[0]?.selected || false },
        };
        sortedLabels.forEach((label, index) => {
          const existing = Object.values(prevCheckboxes).find(cb => cb.label === label);
          newCheckboxes[index + 1] = {
            id: (index + 1).toString(),
            label,
            prefix: label.split(' ').map(w => w.charAt(0)).join('').toUpperCase(),
            selected: existing?.selected || false,
          };
        });
        const currentLabels = Object.values(prevCheckboxes).map(cb => cb.label).sort().join(',');
        const newLabels = Object.values(newCheckboxes).map(cb => cb.label).sort().join(',');
        return currentLabels !== newLabels ? newCheckboxes : prevCheckboxes;
      });
      return;
    }

    // Kota users get the same checkbox shape as everyone else: one entry per
    // distinct LEAF label (e.g. "Faded Pavement Marking", "Cleanliness –
    // Litter"). categorizedCheckboxes below groups them under sub-categories
    // and tabs to match the Reports → Defect-wise filter dropdown.
    const kotaMode = isKotaOrg();

    // Optimized: Process labels in a single pass with memoized formatting
    const uniqueLabels = new Set();
    const labelCache = new Map(); // Cache formatted labels

    // Title-case formatter shared between IBI and Kota — keeps the GIS filter
    // labels consistent (e.g. "faded_pavement_marking" → "Faded Pavement Marking").
    const _format = (raw) =>
      raw
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    backupMarkerState.forEach(marker => {
      marker.inference_info?.forEach(info => {
        if (!info.label) return;
        // Kota uses LEAF labels in the GIS filter (matches the Reports
        // page Defect Types layout — sub-categories grouped under tabs).
        // The category-level rollup lives in `categorizedCheckboxes` below.
        if (!labelCache.has(info.label)) labelCache.set(info.label, _format(info.label));
        uniqueLabels.add(labelCache.get(info.label));
      });
    });

    // Convert Set to sorted array, filtering out disabled labels from defect config
    const sortedLabels = Array.from(uniqueLabels)
      .filter(label => kotaMode || isLabelEnabled(label))
      .sort();

    // Count points per defect label
    const labelCounts = {};
    backupMarkerState.forEach(marker => {
      marker.inference_info?.forEach(info => {
        if (info.label) {
          const formatted = labelCache.get(info.label);
          labelCounts[formatted] = (labelCounts[formatted] || 0) + 1;
        }
      });
    });
    console.log('=== Defect Filter Point Counts ===');
    sortedLabels.forEach(label => {
      console.log(`${label}: ${labelCounts[label] || 0} points`);
    });
    console.log('Total unique labels:', sortedLabels.length);
    console.log('==================================');

    // Build new checkboxes object
    setCheckboxes(prevCheckboxes => {
      // Build new checkboxes object, preserving existing selections
      const newCheckboxes = {
        0: { id: "0", label: "All Defect Types", prefix: "ALL", selected: prevCheckboxes[0]?.selected || false },
      };

      sortedLabels.forEach((label, index) => {
        const id = (index + 1).toString();
        // Create a prefix from the label (first letters of each word)
        const prefix = label
          .split(' ')
          .map(word => word.charAt(0))
          .join('')
          .toUpperCase();

        // Find if this label already exists in checkboxes and preserve its selection state
        const existingCheckbox = Object.values(prevCheckboxes).find(cb => cb.label === label);

        newCheckboxes[index + 1] = {
          id,
          label,
          prefix,
          selected: existingCheckbox?.selected || false
        };
      });

      // Only update if the checkboxes structure has changed (not just selection state)
      const currentLabels = Object.values(prevCheckboxes).map(cb => cb.label).sort().join(',');
      const newLabels = Object.values(newCheckboxes).map(cb => cb.label).sort().join(',');

      if (currentLabels !== newLabels) {
        return newCheckboxes;
      }

      return prevCheckboxes;
    });
  }, [backupMarkerState.length, isAhmedabadUser, processedLabels]); // re-run on new markers or when the Ahmedabad processed-label master list arrives

  const handleDownload = () => {
    const image = imageRef.current;
    saveAs(image.src, "image");
  };

  const selectedImageSrc = useMemo(() => selectedRadio === "original" ? imageSrc.og_src : imageSrc.ai_src, [selectedRadio, imageSrc]);

  // Reset the fade whenever the shown image changes (new point or Original/AI toggle)
  // so the incoming image fades in while the previous one stays underneath.
  useEffect(() => { setImgLoaded(false); }, [selectedImageSrc]);

  // Measure the rendered image rect vs its wrapper so bbox overlays align in
  // both panel and fullscreen (where the img is centered, not wrapper-filling).
  const measureGeom = useCallback(() => {
    const imgEl = imageRef.current, wrapEl = imageWrapperRef.current;
    if (!imgEl || !wrapEl || !imgEl.naturalWidth || !imgEl.naturalHeight) return;
    const ir = imgEl.getBoundingClientRect();
    const wr = wrapEl.getBoundingClientRect();
    if (!ir.width || !ir.height) return;
    const scale = Math.min(ir.width / imgEl.naturalWidth, ir.height / imgEl.naturalHeight);
    const dispW = imgEl.naturalWidth * scale, dispH = imgEl.naturalHeight * scale;
    const offX = (ir.left - wr.left) + (ir.width - dispW) / 2;
    const offY = (ir.top - wr.top) + (ir.height - dispH) / 2;
    setImgGeom({ offX, offY, scale });
  }, []);

  // Re-measure on mount, panel/fullscreen change, image change, and any resize
  // (covers browser zoom too). Observe both the img and the wrapper.
  useEffect(() => {
    const imgEl = imageRef.current, wrapEl = imageWrapperRef.current;
    if (!imgEl || !wrapEl) return;
    measureGeom();
    const ro = new ResizeObserver(measureGeom);
    ro.observe(imgEl);
    ro.observe(wrapEl);
    return () => ro.disconnect();
  }, [open, loading, isImageFullView, selectedImageSrc, measureGeom]);


  const handleClose = () => {
    setOpen(false);
    setIsSidebarVisible(true); // Show sidebar when modal closes

    // Reverse the pan shift so the view stays in the same area
    if (mapRef.current) {
      mapRef.current.panBy([-Math.round(panelWidth / 2), 0]); // MapLibre panBy takes [x, y]
    }
  };

  const handleOverviewClick = () => {
    if (!mapRef.current || markers.length === 0) return;

    const visibleMarkers = markers.filter(m => m.isvisible);
    if (visibleMarkers.length === 0) {
      alert("No visible markers to display. Please adjust your filters.");
      return;
    }

    // Close any open modals first
    if (open) {
      setOpen(false);
    }

    // Ensure sidebar is visible
    if (!isSidebarVisible) {
      setIsSidebarVisible(true);
    }

    // Wait a moment for any UI updates, then fit bounds to all visible markers
    setTimeout(() => {
      if (!mapRef.current) return;
      // Padding accounts for the sidebar (extra on the left)
      fitMapToCoords(
        mapRef.current,
        visibleMarkers.map(m => ({ lat: m.latitude, lng: m.longitude })),
        { top: 100, bottom: 100, left: 400, right: 100 }
      );
    }, 200);
  };

  // Pan/zoom map to traffic congestion points when filter is toggled on
  useEffect(() => {
    if (!showTrafficCongestion || trafficCongestionData.length === 0 || !mapRef.current) return;
    setTimeout(() => {
      if (!mapRef.current) return;
      fitMapToCoords(
        mapRef.current,
        trafficCongestionData.map(tp => ({ lat: tp.latitude, lng: tp.longitude })),
        { top: 100, bottom: 100, left: 400, right: 100 },
        { maxZoom: 16 } // don't zoom in too much (esp. for a single point)
      );
    }, 200);
  }, [showTrafficCongestion, trafficCongestionData]);

  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullScreen(true);
    } else {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  }, []);

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullScreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullScreenChange);
  }, []);

  const getPathFromInference = (inference) => {
    // Show polylines in Roads mode (mapDisplayMode) OR when road segment filter is active
    if (!isRoad && mapDisplayMode !== 'road_condition') return [];

    const data = inference?.data || inference || {};
    // DEBUG — open browser console to see what's loaded
    if (process.env.NODE_ENV !== 'production') {
      console.log('[Road] road_rating:', data.road_rating ?? inference?.road_rating,
        '| frames:', (data.frame_list_data || []).length,
        '| isRoad:', isRoad, '| mode:', mapDisplayMode);
    }
    const frameList = (data.frame_list_data || [])
      .filter(entry => entry.latitude && entry.longitude && (entry.latitude !== 0 || entry.longitude !== 0))
      .map(entry => ({ lat: entry.latitude, lng: entry.longitude }));

    // Condition top-bar filter (Very Poor / Poor / Fair / Good)
    if (selectedConditions.length > 0) {
      const roadId = data.road_id || inference?.uid;
      const roadCond = roadConditionMap[roadId];
      if (roadCond && !selectedConditions.includes(roadCond)) return [];
    }

    // road_rating may be at inference.data.road_rating OR inference.road_rating, and may be a string
    const roadRating = parseFloat(data.road_rating ?? inference?.road_rating);

    // Determine which road rating bucket this inference belongs to
    let tempRoadRatingLevel = 0;
    if (!isNaN(roadRating)) {
      if (roadRating <= 40) tempRoadRatingLevel = 1;
      else if (roadRating <= 80) tempRoadRatingLevel = 2;
      else tempRoadRatingLevel = 3;
    }

    // Collect selected segment filter indices (skip index 0 = "All" header)
    const keyArray = [];
    Object.values(segmentOptions).forEach((checkbox, index) => {
      if (index > 0 && checkbox.selected) keyArray.push(index);
    });

    // No segment filter active → show all polylines
    if (keyArray.length === 0) return frameList;

    // Unknown road rating (tempRoadRatingLevel=0) → show in all modes when filter active
    if (tempRoadRatingLevel === 0) return frameList;

    // Segment filter active → only show matching road rating
    return keyArray.includes(tempRoadRatingLevel) ? frameList : [];
  };

  // Glide the road-engineer marker from its current point to the new one so
  // stepping between defects animates instead of teleporting. Uses rAF and
  // drives only markerPos (not selectedMarker), so the map-centering effect
  // keyed on selectedMarker still fires just once per navigation.
  const animateSelectedMarker = useCallback((targetLat, targetLng) => {
    if (markerAnimRef.current) {
      cancelAnimationFrame(markerAnimRef.current);
      markerAnimRef.current = null;
    }
    const from = markerPosRef.current;
    // No previous position (first open) → place it immediately, nothing to glide from.
    if (from.latitude === null || from.longitude === null) {
      markerPosRef.current = { latitude: targetLat, longitude: targetLng };
      setMarkerPos({ latitude: targetLat, longitude: targetLng });
      return;
    }
    const fromLat = from.latitude;
    const fromLng = from.longitude;
    const duration = 500; // ms
    const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
    let startTs = null;
    const step = (ts) => {
      if (startTs === null) startTs = ts;
      const p = Math.min((ts - startTs) / duration, 1);
      const e = easeInOutQuad(p);
      const lat = fromLat + (targetLat - fromLat) * e;
      const lng = fromLng + (targetLng - fromLng) * e;
      markerPosRef.current = { latitude: lat, longitude: lng };
      setMarkerPos({ latitude: lat, longitude: lng });
      if (p < 1) {
        markerAnimRef.current = requestAnimationFrame(step);
      } else {
        markerPosRef.current = { latitude: targetLat, longitude: targetLng };
        markerAnimRef.current = null;
      }
    };
    markerAnimRef.current = requestAnimationFrame(step);
  }, []);

  // Stop any in-flight marker tween when the component unmounts.
  useEffect(() => () => { if (markerAnimRef.current) cancelAnimationFrame(markerAnimRef.current); }, []);

  const handleMarkerClick = useCallback(async (
    og_file,
    ai_file,
    defectState,
    maininfo,
    latitude,
    longitude,
    codebuidlid,
    created_date,
    defect_state,
    markerId,
    markerIndex
  ) => {
    setLoading(true);
    // setIsSidebarVisible(false); // Hide sidebar when marker is clicked
    try {
      // Resolve each image source INDEPENDENTLY: a full HTTP(S) URL (e.g. a GCS
      // public URL — what SuperAdmin markers carry) is used directly; a storage
      // key is signed via /project/get_signed_url. Previously this required BOTH
      // to be full URLs to skip signing, so a full-URL og_file + key inference_image
      // (the SuperAdmin case) fell through and tried to "sign" the full URL → 500.
      const isFullUrl = (s) => typeof s === 'string' && /^https?:\/\//i.test(s);
      const resolveSrc = async (key) => {
        if (isFullUrl(key)) return key;     // already a usable URL
        if (!key) return '';                 // nothing to resolve
        const resp = await axios.post(
          `${process.env.REACT_APP_BASE_URL}project/get_signed_url`,
          { s3Key: key, CODEBUILD_BUILD_ID: codebuidlid },
        );
        return resp.data.result.url;
      };
      const [og_src, ai_src] = await Promise.all([resolveSrc(og_file), resolveSrc(ai_file)]);

      setImageSrc({ og_src, ai_src });
      setOpen(true);

      const uniqueLabels = [...new Set(maininfo.map(info => {
        const raw = mapLabel(info.label);
        return raw.replace(/[_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      }))];
      const date = moment(created_date);

      setSelectedMarker({ latitude, longitude });
      animateSelectedMarker(latitude, longitude); // glide the engineer icon to the new point
      setCurrentMarkerIndex(markerIndex);

      // Render the panel with what we already have. The reverse-geocoded address
      // is filled in asynchronously below so navigating between points doesn't
      // flash the full-panel loading screen while the geocode request resolves.
      setInfo({
        defectState: defectState,
        label: uniqueLabels,
        latitude,
        longitude,
        address: "Loading address…",
        defect_state,
        date_time: date.tz("Asia/Kolkata").format("MMMM Do, YYYY "),
      });
      setLoading(false);

      getAddressFromGoogleMaps(latitude, longitude)
        .then(address => setInfo(prev => (prev ? { ...prev, address } : prev)))
        .catch(() => setInfo(prev => (prev ? { ...prev, address: "" } : prev)));

      // Pan the map so the point lands in the centre of the visible area (left of
      // the panel). MapLibre equivalent of the old Google projection math: project
      // the point to screen pixels, shift east by half the panel width, then
      // unproject back to a lng/lat target so the marker sits clear of the panel.
      if (mapRef.current) {
        const map = mapRef.current;
        try {
          const pt = map.project([longitude, latitude]); // {x, y} screen pixels
          const target = map.unproject([pt.x + panelWidth / 2, pt.y]);
          map.panTo(target);
        } catch (e) {
          map.panTo([longitude, latitude]);
        }
      }
    } catch (err) {
      console.error("Error fetching images:", err);
    }
    setLoading(false);
  }, []);

  // For SuperAdmin map-only markers, the bulk payload omits og_file /
  // inference_image / inference_info.bbox (see backend maponly mode). This holds
  // the full inference_info (WITH bbox) for the currently-open marker so the
  // click popup's box overlay (overlayBoxes) can render. Null for normal markers.
  const [clickedDetail, setClickedDetail] = useState(null);

  // Single entry point for opening a marker's detail popup. Normal markers (and
  // any marker that already carries og_file) open immediately. SuperAdmin
  // map-only markers lazy-fetch their full frame detail (image keys + bbox) for
  // just that one point before opening — so the bulk map stays lightweight.
  const openMarkerDetail = useCallback(async (marker, deckIndex) => {
    if (!marker) return;
    if (!isSuperAdmin || marker.og_file != null) {
      setClickedDetail(null);
      const inferenceInfo = marker.inference_info || [];
      handleMarkerClick(
        marker.og_file,
        (marker.inference_image || (marker.og_file || '').replace('/frames/', '/predict/')),
        inferenceInfo.length,
        inferenceInfo,
        marker.latitude,
        marker.longitude,
        marker.NEW_CODEBUILD_BUILD_ID || marker.CODEBUILD_BUILD_ID,
        marker.created,
        marker.markerId,
        marker.markerIndex,
        deckIndex
      );
      return;
    }
    // SuperAdmin map-only marker → fetch the full (slim) detail for this point's
    // project, then find the frame at this coordinate to recover og_file /
    // inference_image / inference_info(+bbox).
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}project/get_project_by_id`,
        { project_uids: [marker.uid], slim: true },
        { headers: { 'Content-Type': 'application/json' } }
      );
      const inf = (res.data?.result?.inferences || [])[0];
      const frames = inf?.data?.frame_list_data || [];
      // Match by NEAREST coordinate rather than exact string equality — robust to
      // tiny float/formatting differences (and any prior coord nudging) that would
      // otherwise miss the frame and leave the image src empty (→ 404 placeholder).
      let frame = {};
      let bestD = Infinity;
      for (const f of frames) {
        if (f.latitude == null || f.longitude == null) continue;
        const d = Math.abs(f.latitude - marker.latitude) + Math.abs(f.longitude - marker.longitude);
        if (d < bestD) { bestD = d; frame = f; }
      }
      const inferenceInfo = frame.inference_info || marker.inference_info || [];
      setClickedDetail({ inference_info: inferenceInfo });
      handleMarkerClick(
        frame.og_file,
        (frame.inference_image || (frame.og_file || '').replace('/frames/', '/predict/')),
        inferenceInfo.length,
        inferenceInfo,
        marker.latitude,
        marker.longitude,
        marker.NEW_CODEBUILD_BUILD_ID || marker.CODEBUILD_BUILD_ID,
        marker.created,
        marker.markerId,
        marker.markerIndex,
        deckIndex
      );
    } catch (e) {
      console.error('Failed to load marker detail:', e);
      setLoading(false);
    }
  }, [isSuperAdmin, handleMarkerClick]);

  // Reverse-geocode via Nominatim (OpenStreetMap, free, no key) instead of Google.
  // Name kept as getAddressFromGoogleMaps so call sites are unchanged.
  const getAddressFromGoogleMaps = async (lat, long) => {
    // --- old Google version (react-geocode) kept for rollback ---
    // let address = await Geocode.fromLatLng(lat, long);
    // return address.results[0].formatted_address;
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${long}&zoom=18&addressdetails=0`,
        { headers: { Accept: "application/json" } }
      );
      const data = await res.json();
      return data.display_name || "";
    } catch (e) {
      return "";
    }
  };

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  };

  const handlePolylineClick = async (event, inference) => {
    const { data: { road_length, frame_list_data, road_rating, data_submitted } } = inference;
    const roadRating = typeof road_rating === "number" ? road_rating : 0;
    const roadLength = typeof road_length === "number" ? road_length : 0;
    if (!frame_list_data || frame_list_data.length === 0) return;

    const entryPoint = { lat: frame_list_data[0].latitude, lng: frame_list_data[0].longitude };
    const exitPoint = { lat: frame_list_data[frame_list_data.length - 1].latitude, lng: frame_list_data[frame_list_data.length - 1].longitude };

    let totalDistance = 0;
    for (let i = 1; i < frame_list_data.length; i++) {
      const prevFrame = frame_list_data[i - 1];
      const currentFrame = frame_list_data[i];
      if (prevFrame.latitude === currentFrame.latitude && prevFrame.longitude === currentFrame.longitude) continue;
      const distance = calculateDistance(prevFrame.latitude, prevFrame.longitude, currentFrame.latitude, currentFrame.longitude);
      totalDistance += distance;
    }

    const startingAddress = await getAddressFromGoogleMaps(entryPoint.lat, entryPoint.lng);
    const endingAddress = await getAddressFromGoogleMaps(exitPoint.lat, exitPoint.lng);
    const roadCondition = roadRating <= 40 ? "Poor" : (roadRating <= 80 ? "Fair" : "Good");
    const defects = [...new Set(frame_list_data.map(item => item.defect))];
    const polylineData = {
      roadRating: roadRating,
      roadLength: roadLength,
      roadCondition: roadCondition,
      dateSubmitted: data_submitted,
      entryPoint: entryPoint,
      exitPoint: exitPoint,
      startingAddress: startingAddress,
      endingAddress: endingAddress,
      defects: defects
    };
    setSelectedPolylineData(polylineData);
    setPolylineModalOpen(true);
  };

  const getRoadColor = (roadRating) => {
    if (roadRating <= 40) return "#FF0000";
    if (roadRating > 40 && roadRating <= 80) return "#FFFF00";
    return "#00FF00";
  };

  // ─── FIX: getMarkerColor — derive color from inference_info when defect_state is "none" ───
  // REASON: Backend sends defect_state:"none" in two cases that should NOT be green:
  //   1. Frames with low-severity pavement defects (Median Separator Damaged, Missing Drain Cover Slabs)
  //   2. Frames with non-severity defects like Unauthorized Hoardings, Illegal Parking (severity:"none")
  // Without this fix all of the above fall to the default branch and render green,
  // hiding actual defects on the map.
  //
  // Color tiers when defect_state is "none" but inference_info has defects:
  //   - Has high  severity item → red
  //   - Has medium severity item → orange
  //   - Has low   severity item → yellow
  //   - Has any defect (severity "none") → light blue (#4A90D9) — observed defect, no severity
  //   - Truly empty inference_info → green (no defects at all)
  //
  // OLD LOGIC (removed — only handled explicit low/medium/high on defect_state field):
  // const getMarkerColor = useCallback((defectState, isActive) => {
  //   if (isActive) return "#00FFFF";
  //   switch ((defectState || '').toLowerCase()) {
  //     case "low": return "#C8C800";
  //     case "medium": return "#E87A00";
  //     case "high": return "#DC3C3C";
  //     default: return "#00BB00";
  //   }
  // }, []);
  const getMarkerColor = useCallback((defectState, isActive, inferenceInfo) => {
    if (isActive) return "#00FFFF";
    // Bhilwara: color derives from label+severity combination, ignoring frame-level defect_state
    if (isBhilwaraUser) return _getBhilwaraMarkerColor(inferenceInfo);
    const COLOR_PRIORITY = {
      '#DC3C3C': 3,  // Red — High severity
      '#E87A00': 2,  // Orange — Medium
      '#C8C800': 1,  // Yellow — Low
    };

    // Majority (mode) vote across inference_info DETECTIONS, using the universal
    // SEVERITY_MAP (see labelMapping.js): the severity color with the MOST
    // DETECTIONS wins. Every detection counts (a defect found N times counts N),
    // so the badge agrees with the ×N detection totals shown in the panel
    // breakdown. Exact ties break toward higher severity. Examples:
    //   1 high + 3 low → Low  (low has more detections)
    //   1 high + 1 low → High (tie, broken toward higher severity)
    // The label majority — not the frame-level defect_state — drives the color.
    if (inferenceInfo && inferenceInfo.length > 0) {
      const colorCounts = {};
      inferenceInfo.forEach(info => {
        const color = _getLabelColor(info.label || '');
        if (color) colorCounts[color] = (colorCounts[color] || 0) + 1;
      });
      const entries = Object.entries(colorCounts);
      if (entries.length > 0) {
        return entries.sort(
          (a, b) => b[1] - a[1] || (COLOR_PRIORITY[b[0]] ?? 0) - (COLOR_PRIORITY[a[0]] ?? 0)
        )[0][0];
      }
    }

    // No label mapped to a severity → fall back to the frame-level defect_state.
    const state = (defectState || '').toLowerCase();
    if (state === 'high') return "#DC3C3C";
    if (state === 'medium') return "#E87A00";
    if (state === 'low') return "#C8C800";

    // No defect_state severity and no matched label → no defects.
    return "#00BB00";
  }, [isBhilwaraUser]);

  // ── km per severity level ────────────────────────────────────────────────
  // Algorithm: split each road into 100m segments, classify each segment by
  // dominant frame color (getMarkerColor logic), count segments per bucket,
  // then distribute road_length proportionally → total always matches road_length.
  const kmBySeverity = useMemo(() => {
    const totals = { high: 0, medium: 0, low: 0, noDefect: 0 };

    const classifySegment = (frames) => {
      const counts = { high: 0, medium: 0, low: 0, noDefect: 0 };
      frames.forEach(frame => {
        const color = getMarkerColor(frame.defect_state, false, frame.inference_info);
        if (color === '#DC3C3C') counts.high++;
        else if (color === '#E87A00') counts.medium++;
        else if (color === '#C8C800') counts.low++;
        else counts.noDefect++;
      });
      // Dominant color wins; tie-break: high > medium > low > noDefect
      return ['high', 'medium', 'low', 'noDefect']
        .sort((a, b) => counts[b] - counts[a])[0];
    };

    // Deduplicate by road_id — same road surveyed multiple times should only count once
    const seenRoadIds = new Set();

    allInferenceList.forEach((inference) => {
      const roadId = inference.data?.road_id || inference.uid;
      if (seenRoadIds.has(roadId)) return;
      seenRoadIds.add(roadId);

      const roadLength = typeof inference.data?.road_length === 'number' ? inference.data.road_length : 0;
      if (roadLength <= 0) return;

      const frames = (inference.data?.frame_list_data || []).filter(
        f => f.latitude && f.longitude && !(f.latitude === 0 && f.longitude === 0)
      );
      if (frames.length === 0) return;

      // Count how many 100m segments fall into each bucket
      const segmentCounts = { high: 0, medium: 0, low: 0, noDefect: 0 };
      let segmentFrames = [];
      let segmentKm = 0;
      let totalSegments = 0;

      for (let i = 0; i < frames.length; i++) {
        segmentFrames.push(frames[i]);

        if (i < frames.length - 1) {
          const d = calculateDistance(
            frames[i].latitude, frames[i].longitude,
            frames[i + 1].latitude, frames[i + 1].longitude
          );
          segmentKm += d;

          if (segmentKm >= 0.1) {
            segmentCounts[classifySegment(segmentFrames)]++;
            totalSegments++;
            segmentFrames = [];
            segmentKm = 0;
          }
        }
      }

      // Last partial segment
      if (segmentFrames.length > 0) {
        segmentCounts[classifySegment(segmentFrames)]++;
        totalSegments++;
      }

      if (totalSegments === 0) return;

      // Distribute road_length proportionally → sum always equals road_length
      totals.high += (segmentCounts.high / totalSegments) * roadLength;
      totals.medium += (segmentCounts.medium / totalSegments) * roadLength;
      totals.low += (segmentCounts.low / totalSegments) * roadLength;
      totals.noDefect += (segmentCounts.noDefect / totalSegments) * roadLength;
    });

    // Save to localStorage so FinalReportDashboard can read the same values
    // even if user navigates to home before visiting GIS.
    // Key is per-user so different projects/accounts never mix.
    try {
      const userEmail = JSON.parse(window.localStorage.getItem('user'))?.email || 'default';
      localStorage.setItem(`gis_severity_km_${userEmail}`, JSON.stringify(totals));
    } catch { }

    return totals;
  }, [allInferenceList, getMarkerColor]);

  // Maps each road_id → dominant condition label for the Condition top-bar filter
  const roadConditionMap = useMemo(() => {
    const map = {};
    const seenRoadIds = new Set();
    allInferenceList.forEach((inference) => {
      const roadId = inference.data?.road_id || inference.uid;
      if (seenRoadIds.has(roadId)) return;
      seenRoadIds.add(roadId);
      const frames = (inference.data?.frame_list_data || []).filter(
        f => f.latitude && f.longitude && !(f.latitude === 0 && f.longitude === 0)
      );
      if (frames.length === 0) return;
      const counts = { high: 0, medium: 0, low: 0, noDefect: 0 };
      frames.forEach(frame => {
        const color = getMarkerColor(frame.defect_state, false, frame.inference_info);
        if (color === '#DC3C3C') counts.high++;
        else if (color === '#E87A00') counts.medium++;
        else if (color === '#C8C800') counts.low++;
        else counts.noDefect++;
      });
      const dominant = ['high', 'medium', 'low', 'noDefect'].sort((a, b) => counts[b] - counts[a])[0];
      map[roadId] = dominant === 'high' ? 'Poor'
        : dominant === 'medium' ? 'Fair'
          : 'Good'; // low or noDefect → Good
    });
    return map;
  }, [allInferenceList, getMarkerColor]);

  const getSevereState = (severity) => {
    if (severity === 0) return "None";
    if (severity === 1) return "Mild";
    if (severity >= 2 && severity <= 3) return "Moderate";
    return "Severe";
  };

  // MapLibre needs no async script loader; the map is always "loaded".
  // const { isLoaded } = useJsApiLoader({
  //   id: 'google-map-script',
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEYS,
  //   libraries,
  // });
  const isLoaded = true;

  // Set center based on URL or calculate from markers
  const { avgLat, avgLng } = useMemo(() => {
    if (markers.length === 0) return { avgLat: 0, avgLng: 0 };
    const sumLat = markers.reduce((acc, point) => acc + point.latitude, 0);
    const sumLng = markers.reduce((acc, point) => acc + point.longitude, 0);
    return {
      avgLat: sumLat / markers.length,
      avgLng: sumLng / markers.length
    };
  }, [markers]);

  useEffect(() => {
    // Check if this is the specific URL that needs custom center
    const projectIds = JSON.parse(decodeURIComponent(searchParams.get("listOfIds") || "[]"));
    const specificProjectIds = [
      "22c98a5a-92c5-4176-a714-1312b6f254a4",
      "250496f0-41fb-435a-8379-ca220a460d58",
      "46f32bb9-0e3a-450c-ad36-afdc4e1aa4a6",
      "56a7b9ce-5f72-4a49-b069-824a19fa832d",
      "5dab09c4-fe46-41bf-b271-b4665cb6223f",
      "898a2245-a6b9-4ef0-9990-c4d974ff5f60",
      "a4a2ee84-1ba6-44b7-a4ca-45303c3772d8",
      "e244ea60-e890-4e2e-b642-dfa0130c729d",
      "ebbd772f-7f55-4cec-a88c-bc84f46ecdba"
    ];

    // Check if all specific project IDs are present in the URL
    const hasAllSpecificIds = specificProjectIds.every(id => projectIds.includes(id)) &&
      projectIds.length === specificProjectIds.length;

    if (hasAllSpecificIds) {
      // Use specific coordinates for this URL
      setCenter({ lat: 25.368259, lng: 74.665789 });
    } else if (avgLat !== 0 || avgLng !== 0) {
      // Use average of markers for other URLs (skip when markers not yet loaded)
      // setCenter({ lat: avgLat, lng: avgLng });
    }
  }, [avgLat, avgLng, searchParams]);

  useEffect(() => {
    if (selectedMarker.latitude !== null && selectedMarker.longitude !== null) {
      setCenter({ lat: selectedMarker.latitude, lng: selectedMarker.longitude });
    }
  }, [selectedMarker]);

  const mapId = "c7ce1a914d921fb";
  const defaultCustomMarker = {
    path: "M 0,0 m -5,0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0", // Circle path (dot)
    fillColor: "#FF0000",
    fillOpacity: 1,
    strokeColor: "#000000",
    strokeWeight: 1.5,
    scale: 1,
  };
  const selectedCustomMarker = {
    ...defaultCustomMarker,
    fillColor: "#00FFFF",
    strokeColor: "#000000",
    strokeWeight: 2.5,
    scale: 1.4
  };

  const calculateScale = (zoom) => {
    // Small scale for dot-like markers
    if (zoom <= 14) return 0.6;
    if (zoom <= 16) return 0.7;
    if (zoom <= 18) return 0.8;
    return 0.9;
  };

  // MapLibre: onZoom fires with the map; read zoom from mapRef (throttled).
  const handleZoomChanged = useCallback(() => {
    const map = mapRef.current;
    if (!map) return;
    const newZoomLevel = map.getZoom();

    // Throttle zoom updates to improve performance
    if (zoomTimeoutRef.current) {
      clearTimeout(zoomTimeoutRef.current);
    }

    zoomTimeoutRef.current = setTimeout(() => {
      setZoomLevel(newZoomLevel);
    }, 100);
  }, []);

  // react-map-gl onLoad passes an event whose .target is the MapLibre map instance.
  const handleMapLoad = useCallback((evt) => {
    const map = evt && evt.target ? evt.target : evt;
    mapRef.current = map;

    // Initialize deck.gl overlay (MapboxOverlay works with MapLibre).
    // Added as a map control; it auto-syncs with the basemap on move/zoom,
    // so the manual google.maps redraw listeners are no longer needed.
    const overlay = new MapboxOverlay({
      interleaved: false,
      layers: [],
    });
    map.addControl(overlay);
    overlayRef.current = overlay;

    setIsMapReady(true);

    // Check if this is the specific URL that needs custom center
    const projectIds = JSON.parse(decodeURIComponent(searchParams.get("listOfIds") || "[]"));
    const specificProjectIds = [
      "22c98a5a-92c5-4176-a714-1312b6f254a4",
      "250496f0-41fb-435a-8379-ca220a460d58",
      "46f32bb9-0e3a-450c-ad36-afdc4e1aa4a6",
      "56a7b9ce-5f72-4a49-b069-824a19fa832d",
      "5dab09c4-fe46-41bf-b271-b4665cb6223f",
      "898a2245-a6b9-4ef0-9990-c4d974ff5f60",
      "a4a2ee84-1ba6-44b7-a4ca-45303c3772d8",
      "e244ea60-e890-4e2e-b642-dfa0130c729d",
      "ebbd772f-7f55-4cec-a88c-bc84f46ecdba"
    ];

    const hasAllSpecificIds = specificProjectIds.every(id => projectIds.includes(id)) &&
      projectIds.length === specificProjectIds.length;

    if (hasAllSpecificIds && markers.length > 0) {
      // Use specific coordinates and zoom for this URL ([lng, lat] for MapLibre)
      map.setCenter([74.658777, 25.365649]);
      map.setZoom(17);
    } else if (markers.length > 0) {
      // Fit bounds to show all markers for other URLs
      fitMapToCoords(map, markers.map(m => ({ lat: m.latitude, lng: m.longitude })));
    }
  }, [markers, searchParams]);

  const handleMapIdle = useCallback(() => {
    if (!isMapReady) {
      setIsMapReady(true);
    }
    // Capture the viewport bounds + zoom each time the map settles, so the
    // cluster layer only renders what's currently on screen (not all 1M points).
    const map = mapRef.current;
    if (map) {
      try {
        const b = map.getBounds();
        setMapBounds({ west: b.getWest(), south: b.getSouth(), east: b.getEast(), north: b.getNorth() });
        const z = map.getZoom();
        if (typeof z === 'number') setZoomLevel(z);
      } catch (e) { /* noop */ }
    }
  }, [isMapReady]);

  // pageLoading kept for backwards compatibility but no longer blocks rendering
  useEffect(() => {
    if (isLoaded && isMapReady && markersLoaded) {
      setPageLoading(false);
    }
  }, [isLoaded, isMapReady, markersLoaded]);

  // Auto-fit map to markers as soon as the first batch arrives
  useEffect(() => {
    if (hasInitialFit) return;
    // Skip while progressively painting — fitting to a partial first group would
    // zoom into one corner. The full fit runs once when the final commit clears this.
    if (isProgressiveLoadingRef.current) return;
    if (!mapRef.current || markers.length === 0) return;

    const isKhammam = (JSON.parse(window.localStorage.getItem("user"))?.email || "").toLowerCase() === "khammam@roadvision.ai";

    if (isKhammam) {
      // User requested "Default as Khammam" and "more zoom overview".
      // We skip fitBounds so it doesn't zoom out to show outlier points.
      mapRef.current.setCenter([80.15, 17.25]); // [lng, lat]
      mapRef.current.setZoom(13.7);
    } else {
      // Cap the initial fit at zoom 14 so it doesn't zoom in too far.
      fitMapToCoords(
        mapRef.current,
        markers.map(m => ({ lat: m.latitude, lng: m.longitude })),
        40,
        { maxZoom: 14 }
      );
    }

    setHasInitialFit(true);
  }, [markers, hasInitialFit]);

  // segmentOptions, checkboxes, severityOptions, roadsegmentOptions (kept the same)
  const [segmentOptions, setSegmentOptions] = useState({
    0: { label: "All", selected: false },
    1: { label: "Poor", color: "#FF0000", selected: false },
    2: { label: "Fair", color: "#FFA500", selected: false },
    3: { label: "Good", color: "#00FF00", selected: false },
  });

  const handleSegmentOptionState = (id) => {
    let temp = { ...segmentOptions };
    if (id === 0) {
      const allSelected = !temp[0].selected;
      Object.keys(temp).forEach((key) => {
        temp[key].selected = allSelected;
      });
    } else {
      temp[id].selected = !temp[id].selected;
      if (Object.values(temp).slice(1).every((option) => option.selected)) {
        temp[0].selected = true;
      } else {
        temp[0].selected = false;
      }
    }
    setSegmentOptions(temp);
  };

  useEffect(() => {
    let keyArray = Object.values(segmentOptions).slice(1).filter((checkbox) => checkbox.selected).map((checkbox) => checkbox.label.toLowerCase());
    if (keyArray.length !== 0) {
      setIsRoad(true);
      setAllFalse("checkboxes");
      setAllFalse("severity");
    } else {
      setIsRoad(false);
    }
  }, [segmentOptions]);

  const [defectSearchTerm, setDefectSearchTerm] = useState("");
  const [openSections, setOpenSections] = useState({ pavement: true, assets: false, roadSafety: false });
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showDefectFilters, setShowDefectFilters] = useState(true);
  const [showLegend, setShowLegend] = useState(false);
  const [wardDropdownOpen, setWardDropdownOpen] = useState(false);
  const [defectDropdownOpen, setDefectDropdownOpen] = useState(false);
  const wardDropdownRef = useRef(null);
  const defectDropdownRef = useRef(null);

  // Is the current user operating under BangaloreOrg (IBI)? Treated similar to
  // isKotaOrg() — pins org-specific filter options.
  const isBangaloreOrg = (() => {
    try {
      const org = (window.localStorage.getItem('organization') || '').trim().toLowerCase();
      if (org === 'bangaloreorg') return true;
      const u = JSON.parse(window.localStorage.getItem('user') || '{}');
      return (u?.organization || '').toString().trim().toLowerCase() === 'bangaloreorg';
    } catch { return false; }
  })();

  // IBI has 4 known stretches — map their road_ids to friendly names so the
  // Road Name dropdown shows "Stretch 1" instead of "R274416". The backend's
  // get_project_by_id unsets project_title_display, so we can't read it off
  // markers; this map is the client-side source of truth for IBI labels.
  const IBI_ROAD_NAME_MAP = {
    R274416: 'Stretch 1',
    R116690: 'Stretch 2',
    R180280: 'Stretch 3',
    R852199: 'Stretch 4',
  };

  // ─── Top Filter Bar State ───
  // Road Name options derived dynamically from loaded markers (distinct project titles).
  // For IBI we fall back to a hand-mapped friendly name keyed off road_id so
  // the dropdown reads "Stretch 1" rather than "R274416".
  const ROAD_NAME_OPTIONS = useMemo(() => {
    const set = new Set();
    backupMarkerState.forEach(m => {
      let v = m.project_title_display;
      if (!v && isBangaloreOrg && m.road_id && IBI_ROAD_NAME_MAP[m.road_id]) {
        v = IBI_ROAD_NAME_MAP[m.road_id];
      }
      if (!v) v = m.road_id;
      if (v) set.add(v);
    });
    return Array.from(set).sort();
  }, [backupMarkerState, isBangaloreOrg]);
  // Pin the Authority dropdown per org:
  //   Kota   → "Septagon" (single contractor)
  //   IBI    → "GBA"      (Greater Bengaluru Authority, single authority for the 4 Bangalore stretches)
  // Other orgs continue to read from the AuthorityContext.
  const AUTHORITY_OPTIONS = isKotaOrg()
    ? ['Septagon']
    : isBangaloreOrg
      ? ['GBA']
      : (AUTHORITY_OPTIONS_FROM_CTX.length > 0 ? AUTHORITY_OPTIONS_FROM_CTX : ['PWD', 'UIT', 'NHAI']);
  // Road Type options are derived from the road_type actually present on the
  // loaded markers (read from inference data.road_type), so each org sees its
  // own types — e.g. upwest: "Main Carriageway" / "Service Roads". Falls back
  // to a sensible default list before markers load or when the field is blank.
  const ROAD_TYPE_OPTIONS = useMemo(() => {
    const present = Array.from(new Set(
      (backupMarkerState || []).map(m => (m.road_type || '').trim()).filter(Boolean)
    )).sort();
    if (present.length > 0) return present;
    return isKotaOrg() ? ['National Highway'] : ['Minor Road', 'Urban Street'];
  }, [backupMarkerState]);
  const CONDITION_OPTIONS = ['Good', 'Fair', 'Poor'];
  // SuperAdmin-only: distinct organizations present on the loaded markers, so the
  // SuperAdmin can deselect orgs they don't want to see on the map.
  const ORG_OPTIONS = useMemo(() => {
    if (!isSuperAdmin) return [];
    return Array.from(new Set(
      (backupMarkerState || []).map(m => (m.organization || '').trim()).filter(Boolean)
    )).sort();
  }, [backupMarkerState, isSuperAdmin]);

  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [selectedRoadNames, setSelectedRoadNames] = useState([]);
  const [selectedAuthorities, setSelectedAuthorities] = useState([]);
  const [selectedRoadTypes, setSelectedRoadTypes] = useState([]);
  const [selectedConditions, setSelectedConditions] = useState([]);
  const [selectedSurveyDate, setSelectedSurveyDate] = useState('');
  // When the user arrives via the Reports page "Map" link (URL ?listOfIds=["R116690_night_return"])
  // align the default Day/Night + LHS/RHS filters with the uid being opened so its markers
  // don't get hidden by the unrelated default selection.
  const _uidListForDefaults = useMemo(() => {
    try { return JSON.parse(decodeURIComponent(searchParams.get("listOfIds") || "[]")); }
    catch { return []; }
  }, [searchParams]);
  const _defaultDayNight = useMemo(() => {
    if (_uidListForDefaults.length !== 1) return [];
    const u = String(_uidListForDefaults[0] || '').toLowerCase();
    if (u.includes('_night')) return ['Night'];
    if (u.includes('_day'))   return ['Day'];
    return [];
  }, [_uidListForDefaults]);
  const _defaultSides = useMemo(() => {
    if (_uidListForDefaults.length !== 1) return [];
    const u = String(_uidListForDefaults[0] || '').toLowerCase();
    // Two uid conventions in production:
    //   *_forward / *_return  (Kota, Khammam, IBI surveys)
    //   *_lhs     / *_rhs     (Lucknow surveys: "R074598_S1_day_LHS")
    if (u.includes('_rhs') || u.includes('_return'))  return ['RHS'];
    if (u.includes('_lhs') || u.includes('_forward')) return ['LHS'];
    return [];
  }, [_uidListForDefaults]);

  const [selectedDayNight, setSelectedDayNight] = useState(_defaultDayNight);
  const [selectedSides, setSelectedSides] = useState(_defaultSides);

  const DAY_NIGHT_OPTIONS = ['Day', 'Night'];
  const SIDE_OPTIONS = ['LHS', 'RHS'];

  const [orgDropdownOpen, setOrgDropdownOpen] = useState(false);
  const [roadNameDropdownOpen, setRoadNameDropdownOpen] = useState(false);
  const [authorityDropdownOpen, setAuthorityDropdownOpen] = useState(false);
  const [roadTypeDropdownOpen, setRoadTypeDropdownOpen] = useState(false);
  const [conditionDropdownOpen, setConditionDropdownOpen] = useState(false);
  const [surveyDateOpen, setSurveyDateOpen] = useState(false);
  const [dayNightDropdownOpen, setDayNightDropdownOpen] = useState(false);
  const [sideDropdownOpen, setSideDropdownOpen] = useState(false);

  const orgDropdownRef = useRef(null);
  const roadNameDropdownRef = useRef(null);
  const authorityDropdownRef = useRef(null);
  const roadTypeDropdownRef = useRef(null);
  const conditionDropdownRef = useRef(null);
  const surveyDateRef = useRef(null);
  const dayNightDropdownRef = useRef(null);
  const sideDropdownRef = useRef(null);

  // Derive day/night and LHS/RHS from a marker's source uid
  // (e.g., "R116690_day_forward" → day + LHS; "R116690_night_return" → night + RHS)
  const dayNightOf = (m) => {
    const u = String(m?.uid || '').toLowerCase();
    if (u.includes('_night')) return 'Night';
    if (u.includes('_day')) return 'Day';
    return null;
  };
  const sideOf = (m) => {
    const u = String(m?.uid || '').toLowerCase();
    // Two uid conventions in production:
    //   *_forward / *_return  (Kota, Khammam, IBI)
    //   *_lhs     / *_rhs     (Lucknow: "R074598_S1_day_LHS")
    if (u.includes('_rhs') || u.includes('_return')) return 'RHS';
    return 'LHS';
  };

  const toggleTopFilter = (setter, value) =>
    setter(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);

  const clearTopFilters = () => {
    setSelectedOrganizations([]);
    setSelectedRoadNames([]);
    setSelectedAuthorities([]);
    setSelectedRoadTypes([]);
    setSelectedConditions([]);
    setSelectedSurveyDate('');
    setSelectedDayNight([]);
    setSelectedSides([]);
    setShowTrafficCongestion(false);
  };

  const hasTopFilters = selectedOrganizations.length > 0 || selectedRoadNames.length > 0 || selectedAuthorities.length > 0 ||
    selectedRoadTypes.length > 0 || selectedConditions.length > 0 || selectedSurveyDate !== '' ||
    selectedDayNight.length > 0 || selectedSides.length > 0 || showTrafficCongestion;

  // Derive unique survey dates from loaded markers (YYYY-MM-DD, newest first)
  const uniqueSurveyDates = useMemo(() => {
    const toDateStr = (v) => {
      if (!v) return null;
      const d = new Date(v);
      return isNaN(d.getTime()) ? String(v).slice(0, 10) : d.toISOString().slice(0, 10);
    };
    return [...new Set(backupMarkerState.map(m => toDateStr(m.created)).filter(Boolean))]
      .sort((a, b) => new Date(b) - new Date(a));
  }, [backupMarkerState]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wardDropdownRef.current && !wardDropdownRef.current.contains(e.target)) {
        setWardDropdownOpen(false);
      }
      if (defectDropdownRef.current && !defectDropdownRef.current.contains(e.target)) {
        setDefectDropdownOpen(false);
      }
      if (orgDropdownRef.current && !orgDropdownRef.current.contains(e.target)) {
        setOrgDropdownOpen(false);
      }
      if (roadNameDropdownRef.current && !roadNameDropdownRef.current.contains(e.target)) {
        setRoadNameDropdownOpen(false);
      }
      if (authorityDropdownRef.current && !authorityDropdownRef.current.contains(e.target)) {
        setAuthorityDropdownOpen(false);
      }
      if (roadTypeDropdownRef.current && !roadTypeDropdownRef.current.contains(e.target)) {
        setRoadTypeDropdownOpen(false);
      }
      if (conditionDropdownRef.current && !conditionDropdownRef.current.contains(e.target)) {
        setConditionDropdownOpen(false);
      }
      if (surveyDateRef.current && !surveyDateRef.current.contains(e.target)) {
        setSurveyDateOpen(false);
      }
      if (dayNightDropdownRef.current && !dayNightDropdownRef.current.contains(e.target)) {
        setDayNightDropdownOpen(false);
      }
      if (sideDropdownRef.current && !sideDropdownRef.current.contains(e.target)) {
        setSideDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ─── Ward Filter State ───
  const [wardSearchTerm, setWardSearchTerm] = useState("");
  const [selectedWardFilters, setSelectedWardFilters] = useState([]);
  const [wardOptions, setWardOptions] = useState([]);        // unique sorted ward names (only those with points)

  // Filter ward options based on search
  const filteredWardOptions = useMemo(() => {
    if (!wardSearchTerm.trim()) return wardOptions;
    const s = wardSearchTerm.toLowerCase();
    return wardOptions.filter(w => w.toLowerCase().includes(s));
  }, [wardOptions, wardSearchTerm]);

  // Handle ward filter toggle
  const handleWardFilterToggle = useCallback((ward) => {
    setSelectedWardFilters(prev => {
      if (ward === '__ALL__') {
        return prev.length === wardOptions.length ? [] : [...wardOptions];
      }
      return prev.includes(ward) ? prev.filter(w => w !== ward) : [...prev, ward];
    });
  }, [wardOptions]);

  const [checkboxes, setCheckboxes] = useState({
    0: { id: "0", label: "All Defect Types", prefix: "ALL", selected: false },
  });

  // Runtime bounding boxes drawn over the ORIGINAL frame. Honors the GIS defect
  // filter: if any defect labels are selected, only those boxes show; if none
  // are selected, all boxes show. (AI Analyzed keeps its baked-in boxes.)
  // Declared after `checkboxes` so the memo can read the active filter.
  // NOTE: Runtime bbox annotation over the original frame is disabled for now.
  // Whole logic commented out; overlayBoxes defaults to [] so the render maps
  // over an empty list and draws nothing. Re-enable by restoring the memo below.
  const overlayBoxes = [];
  // const overlayBoxes = useMemo(() => {
  //   if (selectedRadio !== "original") return [];
  //   // Prefer the lazy-fetched detail (SuperAdmin map-only markers carry no bbox
  //   // in the bulk payload); fall back to the marker in the array for normal users.
  //   const marker = clickedDetail || markers[currentMarkerIndex];
  //   if (!marker || !imgGeom) return [];
  //   const { offX, offY, scale } = imgGeom;
  //   const _format = (raw) => (raw || "").split("_")
  //     .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
  //   const selected = new Set(
  //     Object.values(checkboxes).filter(cb => cb.id !== "0" && cb.selected).map(cb => cb.label)
  //   );
  //   return (marker.inference_info || [])
  //     .filter(info => Array.isArray(info.bbox) && info.bbox.length === 4 &&
  //       (selected.size === 0 || selected.has(_format(info.label))))
  //     .map((info, i) => {
  //       const [x, y, w, h] = info.bbox;
  //       const sev = (info.severity || "none").toLowerCase();
  //       const color = sev === "high" ? "#DC3C3C" : sev === "medium" ? "#E87A00"
  //         : sev === "low" ? "#C8C800" : "#3b82f6";
  //       return {
  //         key: i, name: mapLabel(info.label), color,
  //         left: offX + x * scale, top: offY + y * scale, width: w * scale, height: h * scale,
  //       };
  //     });
  // }, [selectedRadio, clickedDetail, markers, currentMarkerIndex, imgGeom, checkboxes]);

  // Filter defect types based on search term
  const filteredCheckboxes = useMemo(() => {
    if (!defectSearchTerm.trim()) return checkboxes;

    const searchLower = defectSearchTerm.toLowerCase();
    const filtered = {};

    Object.entries(checkboxes).forEach(([key, value]) => {
      if (value.label.toLowerCase().includes(searchLower)) {
        filtered[key] = value;
      }
    });

    return filtered;
  }, [checkboxes, defectSearchTerm]);

  // Subcategory configuration for the GIS defect filter.
  // Bhilwara has its own curated config; Kota and the default org route
  // through dedicated paths in `categorizedCheckboxes` (KOTA_TAB_LABELS walk
  // and the shared keyword categorizer respectively).
  const SUB_CATEGORIES_CONFIG = useMemo(() => {
    if (isBhilwaraUser) return BHILWARA_SUB_CATEGORIES_CONFIG;
    return null;
  }, [isBhilwaraUser]);

  const getSeverityOrder = useCallback((label) => {
    if (!label) return 2;
    const n = label.toLowerCase();
    // High (0)
    if (n.includes('pavement damage') || (n.includes('pavement') && n.includes('severe'))) return 0;
    if (n === 'potholes' || n === 'pothole') return 0;
    if (n.includes('settlement')) return 0;
    if (n.includes('rutting')) return 0;
    if (n.includes('edge drop')) return 0;
    if (n.includes('damaged sign board') || n.includes('damaged sign structure')) return 0;
    if (n.includes('damaged highway light')) return 0;
    if (n.includes('non-functional') || n.includes('non functional')) return 0;
    if (n.includes('missing assets') && n.includes('street')) return 0;
    if (n.includes('damaged crash barrier')) return 0;
    if (n.includes('metal beam crash barrier') || n.includes('mbcb')) return 0;
    if (n.includes('pedestrian guard rail')) return 0;
    if (n.includes('damaged kerb') && !n.includes('faded') && !n.includes('painting')) return 0;
    if (n.includes('damaged drain cover') || n.includes('missing drain cover')) return 0;
    if (n.includes('damaged blinker')) return 0;
    if (n.includes('damaged attenuator')) return 0;
    if (n.includes('damaged delineator')) return 0;
    if (n.includes('anti-glare') || n.includes('anti glare')) return 0;
    if (n.includes('damaged hazard marker')) return 0;
    if (n.includes('damaged rumble strip')) return 0;
    if (n.includes('faded pavement marking')) return 0;
    if (n.includes('pavement marking') && n.includes('night')) return 0;
    if (n.includes('work zone') && n.includes('barricading')) return 0;
    if (n.includes('work zone') && n.includes('diversion')) return 0;
    if (n.includes('missing assets') && n.includes('guard rail')) return 0;
    if (n.includes('median separator') && !n.includes('paint')) return 0;
    if (n.includes('median opening') || n.includes('unauthorized median')) return 0;
    if (n.includes('reduced visibility')) return 0;
    // Medium (1)
    if (n.includes('stripping') || n.includes('delamination')) return 1;
    if (n.includes('cracking')) return 1;
    if (n.includes('water stagnation')) return 1;
    if (n.includes('unevenness')) return 1;
    if (n.includes('rain cut')) return 1;
    if (n.includes('signage') && n.includes('poor visibility')) return 1;
    if (n.includes('damaged road stud')) return 1;
    if (n.includes('bus bay') && n.includes('shelter')) return 1;
    if (n.includes('truck lay by') && n.includes('shelter')) return 1;
    if (n.includes('missing plants') || n.includes('irregular gap')) return 1;
    if (n.includes('deteriorated')) return 1;
    if (n.includes('hoarding')) return 1;
    if (n.includes('pavement marking') && n.includes('poor visibility') && n.includes('day')) return 1;
    if (n.includes('work zone') && n.includes('signboard')) return 1;
    if (n.includes('faded painting')) return 1;
    if (n.includes('faded kerb') || (n.includes('kerb') && n.includes('faded'))) return 1;
    if (n.includes('median separator') && n.includes('paint')) return 1;
    if (n.includes('general encroachment')) return 1;
    if (n.includes('damaged footpath') || n.includes('paver block')) return 1;
    // Low (2)
    return 2;
  }, []);

  const categorizedCheckboxes = useMemo(() => {
    const searchLower = defectSearchTerm.toLowerCase().trim();

    // Build a lookup: lowercase label -> { key, ...cb }
    const cbByLabel = {};
    Object.entries(checkboxes).forEach(([key, cb]) => {
      if (key === '0') return;
      if (searchLower && !cb.label.toLowerCase().includes(searchLower)) return;
      cbByLabel[cb.label.toLowerCase()] = { key, ...cb };
    });

    const result = { pavement: [], assets: [], roadSafety: [] };

    // Kota path: walk KOTA_TAB_LABELS in the order Parameter.docx defines so
    // each tab gets its own (sub-category, label) pairing. The same leaf can
    // appear under different sub-categories in different tabs (e.g. Signage
    // belongs to "Signages" under Asset Management and "Signages & Overhead
    // Structures" under Road Safety) — only a per-tab walk preserves that.
    // Categories appear in docx order, leaves in docx order within each
    // category. Leaves the road has no data for are skipped.
    if (isKotaOrg()) {
      const _key = (s) => (s || '').toLowerCase().trim();
      ['pavement', 'assets', 'roadSafety'].forEach(tab => {
        const groupMap = new Map();   // category → { subKey, subLabel, items, _orderedLeaves }
        (KOTA_TAB_LABELS[tab] || []).forEach(({ category, label }) => {
          const cb = cbByLabel[_key(label)];
          if (!cb) return;            // road has no marker carrying this leaf
          if (!groupMap.has(category)) {
            groupMap.set(category, { subKey: category, subLabel: category, items: [] });
          }
          groupMap.get(category).items.push(cb);
        });
        result[tab] = Array.from(groupMap.values());
      });
      return result;
    }

    // Bhilwara: exact-label matching against curated config.
    if (isBhilwaraUser && SUB_CATEGORIES_CONFIG) {
      Object.entries(SUB_CATEGORIES_CONFIG).forEach(([catKey, subCats]) => {
        const subGroups = [];
        Object.entries(subCats).forEach(([subKey, { label: subLabel, names }]) => {
          const items = [];
          names.forEach(name => {
            const cb = cbByLabel[name];
            if (cb) items.push(cb);
            // Same label can appear in multiple Bhilwara tabs — don't remove from pool.
          });
          items.sort((a, b) => getSeverityOrder(a.label) - getSeverityOrder(b.label));
          if (items.length > 0) subGroups.push({ subKey, subLabel, items });
        });
        result[catKey] = subGroups;
      });
      return result;
    }

    // Default org: keyword-based categorization shared with the Defect-wise
    // Report (ProductList). Leaf labels like "Potholes", "Damaged Crash
    // Barriers", "Faded Pavement Marking" are bucketed via substring rules.
    const grouped = categorizeDefectsByKeyword(Object.values(cbByLabel), cb => cb.label);
    ['pavement', 'assets', 'roadSafety'].forEach(catKey => {
      grouped[catKey].forEach(group => {
        group.items.sort((a, b) => getSeverityOrder(a.label) - getSeverityOrder(b.label));
      });
      result[catKey] = grouped[catKey];
    });

    return result;
  }, [checkboxes, defectSearchTerm, SUB_CATEGORIES_CONFIG, isBhilwaraUser, getSeverityOrder]);

  // Pre-select defect types from URL parameter (used when navigating from Dashboard)
  useEffect(() => {
    if (defectTypesAppliedRef.current) return; // already applied, don't re-run
    const defectTypesParam = searchParams.get("defectTypes");
    if (!defectTypesParam) return;
    // Only apply once checkboxes are populated (more than just "All Defect Types")
    if (Object.keys(checkboxes).length <= 1) return;

    try {
      const requestedDefects = JSON.parse(decodeURIComponent(defectTypesParam));
      if (!Array.isArray(requestedDefects) || requestedDefects.length === 0) return;

      defectTypesAppliedRef.current = true; // mark as applied

      // Normalise dashes — the URL value carries an en-dash ("Pavement
      // Defects – Rutting") while checkbox labels (built from normalised
      // inference_info) use a regular hyphen ("Pavement Defects - Rutting").
      // Without this both sides miss each other and the leaf filter selects
      // the wrong checkbox (or nothing).
      const dashNorm = (s) => (s || '').replace(/–|−|—/g, '-');
      const requestedLower = requestedDefects.map(d => dashNorm(d).toLowerCase());

      // Strip severity suffix and trailing 's' for robust matching
      // e.g. "Pothole (High)" → "pothole", "Potholes" → "pothole"
      const stripForMatch = (s) =>
        dashNorm(s).toLowerCase().replace(/\s*\((?:high|medium|low)\)\s*$/i, '').replace(/s$/, '').trim();

      setCheckboxes(prev => {
        const updated = { ...prev };
        let anyMatched = false;

        // Prefer exact-match passes before falling back to substring matching —
        // otherwise "Pavement Defects – Rutting" can substring-match a bare
        // "Pavement Defects" checkbox and select the wrong row.
        const passes = [
          (labelLower, labelBase, r, rBase) => labelLower === r || labelBase === rBase,
          (labelLower, labelBase, r, rBase) =>
            labelLower.includes(r) || r.includes(labelLower) ||
            labelBase.includes(rBase) || rBase.includes(labelBase),
        ];

        for (const matchFn of passes) {
          Object.keys(updated).forEach(key => {
            if (key === '0' || updated[key].selected) return;
            const labelLower = dashNorm(updated[key].label).toLowerCase();
            const labelBase = stripForMatch(updated[key].label);
            if (requestedLower.some(r => matchFn(labelLower, labelBase, r, stripForMatch(r)))) {
              updated[key] = { ...updated[key], selected: true };
              anyMatched = true;
            }
          });
          if (anyMatched) break;  // exact-match pass succeeded — don't widen
        }
        return anyMatched ? updated : prev;
      });

      // Clear the defectTypes param from URL after applying
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("defectTypes");
      setSearchParams(newParams, { replace: true });
    } catch (e) {
      console.error("Error parsing defectTypes param:", e);
    }
  }, [checkboxes, searchParams, setSearchParams]);

  const [severityOptions, setSeverityOptions] = useState({
    0: { label: "Select All", color: "#1967D2", selected: false },
    1: { label: "Low", color: "#E1E105", checkedColor: "#E1E105", selected: false },
    2: { label: "Medium", color: "#FFA500", checkedColor: "#FFA500", selected: false },
    3: { label: "High", color: "#9E0042", checkedColor: "#FF0000", selected: false },
    4: { label: "No Defect", color: "#00BB00", checkedColor: "#00BB00", selected: false },
  });

  const [roadsegmentOptions, setRoadSegmentOptions] = useState({
    0: { id: "0", label: "All Feature Types", prefix: "ALL", selected: false },
    1: { id: "1", label: "Crash Barriers Guard Rails Damaged", prefix: "CBGRD", selected: false },
    2: { id: "2", label: "Damaged Blinkers Attenuators Delineators Anti Glare", prefix: "DBADA", selected: false },
    3: { id: "3", label: "Damaged Bus Shelters Faded Markings Damaged Signages", prefix: "DBSFMDS", selected: false },
    4: { id: "4", label: "Damaged Lights", prefix: "DL", selected: false },
    5: { id: "5", label: "Damaged Road Studs Rumble Strips Hazard Markers", prefix: "DRSRSHM", selected: false },
    6: { id: "6", label: "Damaged Sign Boards Structures", prefix: "DSBS", selected: false },
    7: { id: "7", label: "Encroachments Illegal Parking", prefix: "EIP", selected: false },
    8: { id: "8", label: "Faded Painting Barrier Guard Rail", prefix: "FPBGR", selected: false },
    9: { id: "9", label: "Faded Pavement Marking", prefix: "FPM", selected: false },
    10: { id: "10", label: "Inappropriate Diversions", prefix: "ID", selected: false },
    11: { id: "11", label: "Missing Assets Change Detection", prefix: "MACD", selected: false },
    12: { id: "12", label: "Missing Poor Safety Measures", prefix: "MPSM", selected: false },
    13: { id: "13", label: "Non Functional Lights", prefix: "NFL", selected: false },
    14: { id: "14", label: "Overall Cleanliness", prefix: "OC", selected: false },
    15: { id: "15", label: "Pavement Marking Visibility Day Night", prefix: "PMVDN", selected: false },
    16: { id: "16", label: "Road Stud Rumble Strip Visibility Day Night", prefix: "RSRSVDN", selected: false },
    17: { id: "17", label: "Signage Visibility Day Night", prefix: "SVDN", selected: false },
    18: { id: "18", label: "Unauthorized Median Openings", prefix: "UMO", selected: false },
    19: { id: "19", label: "Unauthorized Signboards Hoardings", prefix: "USH", selected: false },
  });

  const handleCheckboxChange = (event, id) => {
    setIsRoad(false);
    if (id === 0 && event.target.checked) setAllTrue("checkboxes");
    else if (id === 0 && !event.target.checked) setAllFalse("checkboxes");
    if (id !== 0) {
      const temp = { ...checkboxes };
      temp[id]["selected"] = !temp[id]["selected"];
      setCheckboxes(temp);
    }
  };

  const setAllTrue = (setKey) => {
    let temp = {};
    if (setKey === "checkboxes") {
      temp = { ...checkboxes };
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = true; });
      setCheckboxes(temp);
    }
    if (setKey === "severity") {
      temp = { ...severityOptions };
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = true; });
      setSeverityOptions(temp);
    }
  };

  const setAllFalse = (setKey) => {
    let temp = {};
    if (setKey === "checkboxes") {
      temp = { ...checkboxes };
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = false; });
      setCheckboxes(temp);
    }
    if (setKey === "severity") {
      temp = { ...severityOptions };
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = false; });
      setSeverityOptions(temp);
    }
  };

  const checkIfAllPresent = (number, array) => {
    return JSON.stringify(Array.from({ length: number - 1 }, (_, i) => i + 1)) === JSON.stringify(array.sort());
  };

  // Normalize dashes in labels (convert en-dashes to regular hyphens)
  const normalizeLabel = (label) => label.replace(/–|−|—/g, '-');

  const createLabelMappingForCheckboxes = () => {
    // Kota mode: each checkbox is now a leaf label (matches the Reports →
    // Defect-wise filter layout). Map each checkbox to itself, normalised so
    // tiny formatting differences (en-dash spacing, casing) still match the
    // backend label on inference_info bboxes.
    if (isKotaOrg()) {
      const mapping = {};
      Object.values(checkboxes).forEach(cb => {
        if (cb.id === "0") return;  // "All Defect Types"
        mapping[cb.label.toLowerCase()] = [normalizeLabel(cb.label.toLowerCase())];
      });
      return mapping;
    }

    const mapping = {};

    // Map each checkbox label to backend label patterns
    const labelToBackendMapping = {
      'pothole (high)': ['pothole', 'potholes'],
      'pothole (medium)': ['pothole', 'potholes'],
      'pothole (low)': ['pothole', 'potholes'],
      'cracking (high)': ['crack', 'cracking'],
      'cracking (medium)': ['crack', 'cracking'],
      'cracking (low)': ['crack', 'cracking'],
      'rutting (high)': ['rut', 'rutting'],
      'rutting (medium)': ['rut', 'rutting'],
      'rutting (low)': ['rut', 'rutting'],
      'rain cuts': ['rain'],
      'water stagnation': ['water', 'stagnation'],
      'pavement marking (faded)': ['Pavement Marking'],
      'pavement marking visibility (day/night)': ['Pavement Marking Visibility'],
      'missing/damaged road studs / rumble strips / hazard markers': ['Missing/damaged Road Studs / Rumble Strips / Hazard Markers'],
      'visibility of studs & markers (day/night)': ['road_stud_rumble_strip_visibility_day_night'],
      'unevenness / edge drop of shoulder': ['edge_drop', 'uneven'],
      'vegetation growth on shoulders': ['vegetation'],
      'damaged / missing drain cover slabs': ['damaged_missing_cover_slabs', 'cover_slab'],
      'damaged footpath (tiles/pavers)': ['damaged_footpath', 'footpath'],
      'cleanliness (poor)': ['overall_cleanliness', 'cleanliness'],
      'Encroachments/ illegal parking': ['Encroachments_illegal_parking'],
      'missing plants / irregular gaps': ['missing_plants_irregular_gaps', 'missing'],
      'damaged / deteriorated plants': ['deteriorated_damaged_plants', 'deteriorated'],
      'unauthorized median openings': ['unauthorized_median_openings'],
      'reduced sight distance (due to overgrowth)': ['reduced_visibility_due_to_plant_growth', 'reduced'],
      'damaged kerb / faded kerb painting': ['damaged_kerb_faded_paint', 'kerb'],
      'damaged crash barriers / guardrails (cc/mbcb)': ['crash_barriers_guard_rails_damaged', 'crash_barrier'],
      'faded painting on barriers': ['faded_painting_barrier_guard_rail'],
      'damaged sign boards / sign structures': ['damaged_sign_boards_structures', 'sign_board'],
      'visibility of signages (day/night)': ['signage_visibility_day_night'],
      'damaged blinkers / attenuators / delineators/ anti-glare': ['damaged_blinkers_attenuators_delineators_anti_glare'],
      'highway lights damaged': ['damaged_lights', 'lights'],
      'non-functional lights': ['non_functional_lights'],
      'unauthorized signboards / hoardings': ['unauthorized_signboards_hoardings'],
      'inappropriate diversions': ['inappropriate_diversions'],
      'damaged bus shelters': ['damaged_bus_shelters_faded_markings_damaged_signages', 'bus_shelter'],
      'faded bus bay / truck lay-by markings': ['faded_bus_bay', 'bus_bay'],
      'holding / advertisement boards': ['advertisement', 'hoarding'],
      'work zone safety (signboard visibility, barricading)': ['work_zone', 'safety'],
      'patching': ['patching', 'patch'],
      'Encroachment': ['Encroachment']
    };

    Object.keys(checkboxes).forEach(key => {
      const index = parseInt(key);
      if (index > 0) {
        const rawLabel = checkboxes[key].label.toLowerCase();
        const label = normalizeLabel(rawLabel); // Normalize dashes
        // Check if there's a mapping for this label
        let backendLabels = null;
        for (const [mappingKey, mappingValue] of Object.entries(labelToBackendMapping)) {
          if (normalizeLabel(mappingKey) === label) {
            backendLabels = mappingValue;
            break;
          }
        }
        // If no mapping found, just use the normalized label
        // (markers are already normalized to this form)
        if (!backendLabels) {
          backendLabels = [label];
        }
        // Normalize all backend labels and remove duplicates
        const normalizedBackendLabels = backendLabels.map(bl => normalizeLabel(bl.toLowerCase()));
        mapping[label] = [...new Set(normalizedBackendLabels)];
      }
    });

    return mapping;
  };

  const createFeatureLabelMappingForCheckboxes = () => {
    const mapping = {};
    const featureLabels = {
      0: 'crash_barriers_guard_rails_damaged', 1: 'damaged_blinkers_attenuators_delineators_anti_glare',
      2: 'damaged_bus_shelters_faded_markings_damaged_signages', 3: 'damaged_lights',
      4: 'damaged_road_studs_rumble_strips_hazard_markers', 5: 'Damaged Kerb / Faded Kerb Painting',
      6: 'encroachments_illegal_parking', 7: 'faded_painting_barrier_guard_rail',
      8: 'faded_pavement_marking', 9: 'inappropriate_diversions',
      10: 'missing_assets_change_detection', 11: 'missing_poor_safety_measures',
      12: 'non_functional_lights', 13: 'overall_cleanliness',
      14: 'pavement_marking_visibility_day_night', 15: 'road_stud_rumble_strip_visibility_day_night',
      16: 'signage_visibility_day_night', 17: 'unauthorized_median_openings',
      18: 'Unauthorized Signboards / Hoardings'
    };


    const featureKeyToMarkerLabel = {

      'damaged_lights': ['damaged_lights'],
      'damaged_road_studs_rumble_strips_hazard_markers': ['damaged_road_studs_rumble_strips_hazard_markers'],
      'Damaged Kerb / Faded Kerb Painting': ['Damaged Kerb / Faded Kerb Painting'],
      'encroachments_illegal_parking': ['encroachments_illegal_parking'],
      'faded_painting_barrier_guard_rail': ['faded_painting_barrier_guard_rail'],
      'faded_pavement_marking': ['faded_pavement_marking'],
      'inappropriate_diversions': ['inappropriate_diversions'],
      'missing_assets_change_detection': ['missing_assets_change_detection'],
      'missing_poor_safety_measures': ['missing_poor_safety_measures'],
      'non_functional_lights': ['non_functional_lights'],
      'overall_cleanliness': ['overall_cleanliness'],
      'pavement_marking_visibility_day_night': ['pavement_marking_visibility_day_night'],
      'road_stud_rumble_strip_visibility_day_night': ['road_stud_rumble_strip_visibility_day_night'],
      'signage_visibility_day_night': ['signage_visibility_day_night'],

      'Unauthorized Signboards / Hoardings': ['Unauthorized Signboards / Hoardings']
    };

    Object.keys(roadsegmentOptions).forEach(key => {
      const index = parseInt(key);
      if (index > 0) {
        const featureLabel = featureLabels[index - 1];
        const markerLabels = featureKeyToMarkerLabel[featureLabel];
        mapping[roadsegmentOptions[key].label.toLowerCase()] = markerLabels;
      }
    });

    return mapping;
  };

  const filterCheckboxMarkers = useCallback(() => {
    if (isFilteringRef.current) return; // prevent re-trigger loop
    isFilteringRef.current = true;
    console.log('=== filterCheckboxMarkers called ===');
    let tempMarkers = [];
    let pointKeyArray = [];
    let pointIndexArray = [];
    let selectedDefectsWithSeverity = []; // Store {label: string, severity: string|null}

    const defectMapping = createLabelMappingForCheckboxes();
    Object.values(checkboxes).forEach((checkbox, index) => {
      if (checkbox["selected"]) {
        const mappedLabels = defectMapping[checkbox["label"].toLowerCase()];
        if (mappedLabels) pointKeyArray.push(...mappedLabels);
        pointIndexArray.push(index);

        // Extract severity from label if present (e.g., "Pothole (high)" -> severity: "high")
        const label = checkbox["label"].toLowerCase();
        let severity = null;
        if (label.includes('(high)')) {
          severity = 'high';
        } else if (label.includes('(medium)')) {
          severity = 'medium';
        } else if (label.includes('(low)')) {
          severity = 'low';
        }

        console.log(`✅ Selected: "${checkbox["label"]}" -> maps to: [${mappedLabels?.join(', ')}] (${mappedLabels?.length || 0} labels) | severity: ${severity}`);

        // Store the mapping for this selected checkbox
        mappedLabels?.forEach(mappedLabel => {
          selectedDefectsWithSeverity.push({
            label: mappedLabel,
            severity: severity
          });
        });
      }
    });

    console.log('Selected defects with severity:', selectedDefectsWithSeverity);

    // Update "All" checkbox state without triggering re-render loop.
    // Guard: if only the "All Defect Types" placeholder exists (no real defect
    // types in the data, e.g. pre-inference Kota markers), checkIfAllPresent
    // returns true for the empty-vs-empty comparison and would auto-select
    // "All Defect Types" — showing a phantom "1" filter badge. Only sync
    // when there's at least one real defect type + at least one explicit
    // selection.
    const realCount = Math.max(0, Object.keys(checkboxes).length - 1);
    const allCheckboxesSelected = realCount > 0 && pointIndexArray.length > 0
      ? checkIfAllPresent(Object.keys(checkboxes).length, pointIndexArray)
      : false;
    if (checkboxes[0]?.selected !== allCheckboxesSelected) {
      // Use queueMicrotask to avoid synchronous state update during filter
      queueMicrotask(() => {
        setCheckboxes(prev => {
          if (prev[0]?.selected === allCheckboxesSelected) return prev;
          const temp = { ...prev };
          temp[0] = { ...temp[0], selected: allCheckboxesSelected };
          return temp;
        });
      });
    }

    let keyArray = [];
    let keyIndex = [];
    Object.values(severityOptions).forEach((checkbox, index) => {
      if (checkbox["selected"]) {
        keyArray.push(checkbox["label"].toLowerCase());
        keyIndex.push(index);
      }
    });

    console.log('Severity options selected (keyArray):', keyArray);

    const allSeveritySelected = checkIfAllPresent(Object.keys(severityOptions).length, keyIndex);
    if (severityOptions[0]?.selected !== allSeveritySelected) {
      queueMicrotask(() => {
        setSeverityOptions(prev => {
          if (prev[0]?.selected === allSeveritySelected) return prev;
          const temp = { ...prev };
          temp[0] = { ...temp[0], selected: allSeveritySelected };
          return temp;
        });
      });
    }

    let roadAssetKeyArray = [];
    const featureMapping = createFeatureLabelMappingForCheckboxes();
    Object.values(roadsegmentOptions).forEach((checkbox, index) => {
      if (checkbox["selected"]) {
        const mappedLabels = featureMapping[checkbox["label"].toLowerCase()];
        if (mappedLabels) roadAssetKeyArray.push(...mappedLabels);
      }
    });

    console.log('Total markers to filter:', markers.length);
    if (markers.length > 0 && markers[0].inference_info?.length > 0) {
      console.log('Sample marker inference_info:', markers[0].inference_info[0]);
    }

    // Build set of selected wards for fast lookup
    const hasWardFilter = selectedWardFilters.length > 0;
    const selectedWardSet = hasWardFilter ? new Set(selectedWardFilters) : null;

    // Helper: normalize a created value to YYYY-MM-DD
    const toDateStr = (v) => {
      if (!v) return null;
      const d = new Date(v);
      return isNaN(d.getTime()) ? String(v).slice(0, 10) : d.toISOString().slice(0, 10);
    };

    // Helper: check if a marker passes location + survey date filters
    const passesLocationFilters = (marker) => {
      // Chainage segment bbox (set when a user clicks Map on a chainage row).
      // Only markers whose coords fall within the segment's bounding box
      // (with a small buffer for GPS jitter) survive.
      if (chainageBbox) {
        const lat = marker.latitude, lng = marker.longitude;
        if (lat < chainageBbox.minLat || lat > chainageBbox.maxLat ||
            lng < chainageBbox.minLng || lng > chainageBbox.maxLng) {
          return false;
        }
      }
      if (hasWardFilter) {
        if (!selectedWardSet.has(marker._ward || 'Unknown')) return false;
      }
      if (selectedSurveyDate) {
        if (toDateStr(marker.created) !== selectedSurveyDate) return false;
      }
      if (selectedDayNight.length > 0) {
        const dn = dayNightOf(marker);
        if (!dn || !selectedDayNight.includes(dn)) return false;
      }
      if (selectedSides.length > 0) {
        if (!selectedSides.includes(sideOf(marker))) return false;
      }
      if (selectedOrganizations.length > 0) {
        if (!selectedOrganizations.includes(marker.organization || '')) return false;
      }
      if (selectedRoadNames.length > 0) {
        // Match against the same display name the dropdown built (IBI uses
        // the friendly stretch-name fallback, others use project_title_display
        // / road_id).
        let display = marker.project_title_display;
        if (!display && isBangaloreOrg && marker.road_id && IBI_ROAD_NAME_MAP[marker.road_id]) {
          display = IBI_ROAD_NAME_MAP[marker.road_id];
        }
        if (!display) display = marker.road_id || '';
        if (!selectedRoadNames.includes(display)) return false;
      }
      if (selectedAuthorities.length > 0) {
        if (!selectedAuthorities.includes(marker.authority || '')) return false;
      }
      if (selectedRoadTypes.length > 0) {
        if (!selectedRoadTypes.includes(marker.road_type || '')) return false;
      }
      return true;
    };

    // Early exit if no filters are applied - show all markers
    if (pointKeyArray.length === 0 && keyArray.length === 0 && roadAssetKeyArray.length === 0 && !isRoad && !hasWardFilter && !selectedSurveyDate && selectedConditions.length === 0 && selectedDayNight.length === 0 && selectedSides.length === 0 && selectedOrganizations.length === 0 && selectedRoadNames.length === 0 && selectedAuthorities.length === 0 && selectedRoadTypes.length === 0 && !chainageBbox) {
      const allVisible = backupMarkerState.map(marker => ({ ...marker, isvisible: true }));
      setMarkers(allVisible);
      queueMicrotask(() => { isFilteringRef.current = false; });
      return;
    }

    // If only location/condition filters are applied (no defect/severity/asset filters)
    // Map directly from backupMarkerState so no-defect markers (empty inference_info) are
    // not incorrectly hidden by the temp_num=0 path inside markers.map below.
    if (pointKeyArray.length === 0 && keyArray.length === 0 && roadAssetKeyArray.length === 0 && !isRoad) {
      const _COND_SEV_PT = { 'Poor': ['high'], 'Fair': ['medium'], 'Good': ['low', 'no defect'] };
      const allowedSevs = selectedConditions.length > 0
        ? new Set(selectedConditions.flatMap(c => _COND_SEV_PT[c] || []))
        : null;
      const _COLOR_TO_SEV_PT = { '#DC3C3C': 'high', '#E87A00': 'medium', '#C8C800': 'low', '#00BB00': 'no defect' };
      const filtered = backupMarkerState.map(marker => {
        if (!passesLocationFilters(marker)) return { ...marker, isvisible: false };
        if (allowedSevs) {
          const markerColor = getMarkerColor(marker.defect_state, false, marker.inference_info);
          const markerSev = _COLOR_TO_SEV_PT[markerColor] || 'no defect';
          return { ...marker, isvisible: allowedSevs.has(markerSev) };
        }
        return { ...marker, isvisible: true };
      });
      setMarkers(filtered);
      if (mapRef.current) {
        const visibleMarkers = filtered.filter(m => m.isvisible);
        fitMapToCoords(
          mapRef.current,
          visibleMarkers.map(m => ({ lat: m.latitude, lng: m.longitude })),
          { top: 80, bottom: 100, left: 50, right: 50 }
        );
      }
      queueMicrotask(() => { isFilteringRef.current = false; });
      return;
    }

    tempMarkers = markers.map((item) => {
      // Safety check for inference_info
      if (!item.inference_info || !Array.isArray(item.inference_info)) {
        item.inference_info = [];
      }
      if (!item.asset_info || !Array.isArray(item.asset_info)) {
        item.asset_info = [];
      }
      // Normalize: convert dashes to hyphens, then collapse spaces/underscores
      // so "unauthorized median openings" matches "unauthorized_median_openings"
      // and "Shoulder – Rain Cuts" matches "Shoulder - Rain Cuts"
      const normalizeLabel = (s) => s.replace(/–|−|—/g, '-').replace(/[\s_]+/g, '_');

      let temp_num = item.inference_info.filter((info) => {
        const backendLabel = info.label.toLowerCase();
        const backendLabelNorm = normalizeLabel(backendLabel);

        // Derive severity for filter matching.
        // Bhilwara: use info.severity directly — color depends on label+severity combination,
        // so deriving severity from label color would give wrong results (e.g. Cracking high → orange, not red).
        // Default: derive from label color first (keeps filter ↔ visual dot color in sync).
        let infoSeverity = null;
        if (isBhilwaraUser) {
          infoSeverity = _normSeverity(info.severity || '');
          if (infoSeverity === 'none') infoSeverity = null;
        } else {
          const labelColor = _getLabelColor(info.label || '');
          if (labelColor === '#DC3C3C') infoSeverity = 'high';
          else if (labelColor === '#E87A00') infoSeverity = 'medium';
          else if (labelColor === '#C8C800') infoSeverity = 'low';

          // Fallback to backend severity only when label color is unknown
          if (!infoSeverity) {
            infoSeverity = info.severity ? info.severity.toLowerCase() : null;
            if (infoSeverity) {
              if (infoSeverity.includes('high') || infoSeverity === 'h' || infoSeverity === '3') {
                infoSeverity = 'high';
              } else if (infoSeverity.includes('medium') || infoSeverity === 'm' || infoSeverity === '2') {
                infoSeverity = 'medium';
              } else if (infoSeverity.includes('low') || infoSeverity === 'l' || infoSeverity === '1') {
                infoSeverity = 'low';
              }
            }
          }
        }

        // If we have selected defects with specific severity requirements
        if (selectedDefectsWithSeverity.length > 0) {
          const matches = selectedDefectsWithSeverity.some(defectFilter => {
            // Use exact match for specific labels to avoid substring matching issues
            // e.g., "encroachment" should not match "encroachments_illegal_parking"
            const filterLabelLower = defectFilter.label.toLowerCase();
            const filterLabelNorm = normalizeLabel(filterLabelLower);
            let labelMatches;

            // // For exact match labels like "Encroachment", use strict equality
            // if (filterLabelLower === 'encroachment') {
            //   labelMatches = backendLabel === filterLabelLower;
            // } else {
            //   // For other labels, use contains logic
            //   labelMatches = backendLabel === filterLabelLower ||
            //     backendLabel.includes(filterLabelLower);
            // }
            // For exact match labels like "Encroachment", use strict equality
            if (filterLabelNorm === 'encroachment') {
              labelMatches = backendLabelNorm === filterLabelNorm;
            } else {
              // For other labels, use contains logic (normalized to handle space vs underscore)
              labelMatches = backendLabelNorm === filterLabelNorm ||
                backendLabelNorm.includes(filterLabelNorm);
            }

            // If the filter has a severity requirement, check it matches
            if (defectFilter.severity !== null) {
              const severityMatches = infoSeverity === defectFilter.severity;
              const result = labelMatches && severityMatches;

              // Debug logging
              if (labelMatches) {
                console.log(`Checking: ${backendLabel} with severity ${infoSeverity} against filter ${defectFilter.label}(${defectFilter.severity}) = ${result}`);
              }

              return result;
            } else {
              // No severity requirement, just match label
              return labelMatches;
            }
          });

          // Also check if severity filter is applied separately
          if (keyArray.length > 0 && infoSeverity && !keyArray.includes(infoSeverity)) {
            return false;
          }

          return matches;
        }

        //   // Fallback to original logic if no specific defect filters
        //   if (keyArray.length !== 0 && pointIndexArray.length !== 0) {
        //     const hasMatchingLabel = pointKeyArray.some(markerLabel => {
        //       const markerLabelLower = markerLabel.toLowerCase();
        //       // Use exact match for "Encroachment"
        //       if (markerLabelLower === 'encroachment') {
        //         return backendLabel === markerLabelLower;
        //       }
        //       return backendLabel === markerLabelLower ||
        //         backendLabel.includes(markerLabelLower);
        //     });
        //     return (hasMatchingLabel && keyArray.includes(infoSeverity));
        //   } else if (keyArray.length > 0 && pointIndexArray.length === 0) {
        //     return keyArray.includes(item.defect_state.toLowerCase());
        //   } else if (keyArray.length === 0 && pointIndexArray.length > 0) {
        //     const matches = pointKeyArray.some(markerLabel => {
        //       const markerLabelLower = markerLabel.toLowerCase();
        //       // Use exact match for "Encroachment"
        //       if (markerLabelLower === 'encroachment') {
        //         return backendLabel === markerLabelLower;
        //       }
        //       return backendLabel === markerLabelLower ||
        //         backendLabel.includes(markerLabelLower);
        //     });
        //     return matches;
        //   } else {
        //     return true;
        //   }
        // }).length;

        // Fallback to original logic if no specific defect filters
        if (keyArray.length !== 0 && pointIndexArray.length !== 0) {
          const hasMatchingLabel = pointKeyArray.some(markerLabel => {
            const markerLabelNorm = normalizeLabel(markerLabel.toLowerCase());
            if (markerLabelNorm === 'encroachment') {
              return backendLabelNorm === markerLabelNorm;
            }
            return backendLabelNorm === markerLabelNorm ||
              backendLabelNorm.includes(markerLabelNorm);
          });
          return (hasMatchingLabel && keyArray.includes(infoSeverity));
        } else if (keyArray.length > 0 && pointIndexArray.length === 0) {
          // ─── FIX v2: Severity-only filter — effective severity from both defect_state + inference_info ───
          // BEHAVIOR: "Low filter = locations whose WORST defect is low"
          //   A marker only shows under Low if its max severity across all sources equals low.
          //   If it has even one medium/high defect it will only appear in Medium/High filter.
          //
          // TO REVERT TO v1 (any matching inference_info item): uncomment the block below and
          // remove the effective-severity block that follows it.
          //
          // ── v1 (per-item check — showed mixed-severity markers in lower filter) ──
          // return keyArray.includes(infoSeverity);
          // ── end v1 ──
          //
          // ── v2: effective severity derived from getMarkerColor (visual color) ──
          // Uses the same logic as getMarkerColor so the filter matches the dot
          // color the user sees on the map. This avoids the mismatch where the
          // backend sends severity:"low" but the label maps to a red color.
          const markerColor = getMarkerColor(item.defect_state, false, item.inference_info);
          const _COLOR_TO_SEV_FILTER = { '#DC3C3C': 'high', '#E87A00': 'medium', '#C8C800': 'low', '#00BB00': 'no defect' };
          const effectiveSev = _COLOR_TO_SEV_FILTER[markerColor] ?? 'none';
          return keyArray.includes(effectiveSev);
          // ── end v2 ──
        } else if (keyArray.length === 0 && pointIndexArray.length > 0) {
          const matches = pointKeyArray.some(markerLabel => {
            const markerLabelNorm = normalizeLabel(markerLabel.toLowerCase());
            if (markerLabelNorm === 'encroachment') {
              return backendLabelNorm === markerLabelNorm;
            }
            return backendLabelNorm === markerLabelNorm ||
              backendLabelNorm.includes(markerLabelNorm);
          });
          return matches;
        } else {
          return true;
        }
      }).length;

      let asset_num = item.asset_info.filter((info) => {
        const mappedLabel = mapLabel(info.label);
        return roadAssetKeyArray.some(markerLabel =>
          mappedLabel.toLowerCase().includes(markerLabel.toLowerCase())
        );
      }).length;

      // Check location filters (road + ward) - if active and marker doesn't match, hide it
      if (!passesLocationFilters(item)) {
        return { ...item, isvisible: false };
      }

      // No-defect markers always produce temp_num=0 (empty inference_info means the
      // filter callback never runs). Use getMarkerColor — the same logic the map
      // renders — so the filter matches exactly what the user sees as green dots.
      if (keyArray.length > 0 && pointIndexArray.length === 0) {
        const markerColor = getMarkerColor(item.defect_state, false, item.inference_info);
        if (markerColor === '#00BB00') {
          return { ...item, isvisible: keyArray.includes('no defect') };
        }
      }

      return (temp_num && (roadAssetKeyArray.length === 0 || asset_num))
        ? { ...item, isvisible: true }
        : { ...item, isvisible: false };
    });

    // Condition top-bar filter for points (combined with severity/defect filters):
    // Good → low + no defect, Fair → medium, Poor → high.
    // Intersects with severity result: marker must pass BOTH.
    if (selectedConditions.length > 0) {
      const _COND_SEV_PT = { 'Poor': ['high'], 'Fair': ['medium'], 'Good': ['low', 'no defect'] };
      const allowedSevs = new Set(selectedConditions.flatMap(c => _COND_SEV_PT[c] || []));
      const _COLOR_TO_SEV_PT = { '#DC3C3C': 'high', '#E87A00': 'medium', '#C8C800': 'low', '#00BB00': 'no defect' };
      tempMarkers = tempMarkers.map(item => {
        const markerColor = getMarkerColor(item.defect_state, false, item.inference_info);
        const markerSev = _COLOR_TO_SEV_PT[markerColor] || 'no defect';
        return { ...item, isvisible: item.isvisible && allowedSevs.has(markerSev) };
      });
    }

    if (!isRoad) {
      const visibleCount = tempMarkers.filter(m => m.isvisible).length;
      console.log(`📍 Filter result: ${visibleCount} of ${tempMarkers.length} markers visible`);
      console.log(`   Searched labels: ${Array.from(new Set(pointKeyArray)).join(', ')}`);
      setMarkers(tempMarkers);

      // Auto-pan/zoom map to fit visible markers when any filter is active
      const hasActiveFilter = keyArray.length > 0 || pointIndexArray.length > 0 || hasWardFilter;
      if (hasActiveFilter && mapRef.current) {
        const visibleMarkers = tempMarkers.filter(m => m.isvisible);
        fitMapToCoords(
          mapRef.current,
          visibleMarkers.map(m => ({ lat: m.latitude, lng: m.longitude })),
          { top: 80, bottom: 100, left: 50, right: 50 }
        );
      }
    }
    // Allow next filter call after this render cycle completes
    queueMicrotask(() => { isFilteringRef.current = false; });
  }, [checkboxes, severityOptions, roadsegmentOptions, isRoad, backupMarkerState, selectedWardFilters, selectedSurveyDate, selectedDayNight, selectedSides, selectedOrganizations, selectedRoadNames, selectedAuthorities, selectedRoadTypes, getMarkerColor, selectedConditions, isBhilwaraUser, chainageBbox]);

  // Debounced filter effect — runs when filter options change or new markers arrive
  useEffect(() => {
    if (backupMarkerState.length === 0) return;

    const timeoutId = setTimeout(() => {
      startTransition(() => {
        filterCheckboxMarkers();
      });
    }, 150);

    return () => clearTimeout(timeoutId);
  }, [checkboxes, severityOptions, roadsegmentOptions, selectedWardFilters, selectedSurveyDate, selectedDayNight, selectedSides, selectedOrganizations, selectedRoadNames, selectedAuthorities, selectedRoadTypes, filterCheckboxMarkers, backupMarkerState.length, chainageBbox]);

  // Ahmedabad: names the selected processed-defect(s) that produced zero visible
  // points, so the map can show "No data found for <defect>". Returns "" when no
  // defect is selected or at least one selected defect has detections on the map.
  const noDataForSelectedDefect = useMemo(() => {
    if (!isAhmedabadUser) return "";
    const selectedDefectLabels = Object.values(checkboxes)
      .filter(cb => cb.id !== "0" && cb.selected)
      .map(cb => cb.label);
    if (selectedDefectLabels.length === 0) return "";
    // Only an empty map (no visible points at all) counts as "no data".
    if (markers.length === 0 || markers.some(m => m.isvisible)) return "";
    return selectedDefectLabels.join(", ");
  }, [isAhmedabadUser, checkboxes, markers]);

  // Fit the map to the chainage segment when the URL carries a ?bbox= param
  // (i.e. the user clicked Map on a chainage row). Runs once per bbox change,
  // after the map + the markers are ready.
  useEffect(() => {
    if (!chainageBbox || !mapRef.current) return;
    if (backupMarkerState.length === 0) return;
    const { lat1, lng1, lat2, lng2 } = chainageBbox.raw;
    // Pad bounds a touch so the map shows surrounding context, not a hairline.
    fitMapToCoords(
      mapRef.current,
      [{ lat: lat1, lng: lng1 }, { lat: lat2, lng: lng2 }],
      60
    );
  }, [chainageBbox, backupMarkerState.length]);

  const handleEnroachChange = (event, index) => {
    setIsRoad(false);
    let temp = { ...segmentOptions };
    Object.keys(temp).forEach((key) => { temp[key]["selected"] = false; });
    setSegmentOptions(temp);
    if (index === 0 && event.target.checked) setAllTrue("severity");
    else if (index === 0 && !event.target.checked) setAllFalse("severity");
    if (index !== 0) {
      const temp = { ...severityOptions };
      temp[index]["selected"] = !temp[index]["selected"];
      setSeverityOptions(temp);
    }
  };

  const handleFeatureCheckboxChange = (index) => (event) => {
    const temp = { ...roadsegmentOptions };
    if (index === 0) {
      temp[index]["selected"] = event.target.checked;
      Object.keys(temp).forEach((key) => { temp[key]["selected"] = event.target.checked; });
    } else {
      temp[index]["selected"] = event.target.checked;
      if (Object.values(temp).slice(1).every((option) => option.selected)) temp[0].selected = true;
      else temp[0].selected = false;
    }
    setRoadSegmentOptions(temp);
  };

  function containsMultipleIds(listOfIds) {
    try {
      const ids = JSON.parse(listOfIds);
      return Array.isArray(ids) && ids.length > 1;
    } catch (error) {
      return false;
    }
  }
  const listOfIds = searchParams.get("listOfIds");

  const menus = [
    {
      name: "Map",
      link: `${window.location.origin.toString()}/pavement/multiMap?listOfIds=` + searchParams.get("listOfIds"),
      icon: IoMapSharp,
    },
    {
      name: "Report",
      link: containsMultipleIds(listOfIds) ? "#" : `${window.location.origin.toString()}/pavement/report?listOfIds=${listOfIds}`,
      icon: RiArticleFill,
      onClick: containsMultipleIds(listOfIds) ? (event) => { event.preventDefault(); alert("Please select only one project."); } : undefined,
    },
    {
      name: "Video Inspection",
      link: containsMultipleIds(listOfIds) ? "#" : `${window.location.origin.toString()}/pavement/video?listOfIds=${listOfIds}`,
      icon: PiVideoDuotone,
      onClick: containsMultipleIds(listOfIds) ? (event) => { event.preventDefault(); alert("Please select only one project."); } : undefined,
    },
    {
      name: "Notifications",
      link: `${window.location.origin.toString()}/pavement/notifications?listOfIds=` + searchParams.get("listOfIds"),
      icon: RiNotification3Fill,
    },
    {
      name: "VersionControl",
      link: "#",
      icon: RiHistoryFill,
      onClick: (event) => { event.preventDefault(); alert("Only Available For Enterprise Customers!"); },
    },
    {
      name: "Budget Calculator",
      link: `${window.location.origin.toString()}/pavement/calculator?listOfIds=` + searchParams.get("listOfIds"),
      icon: RiCalculatorFill,
    },
    {
      name: "Download Report",
      link: `${window.location.origin.toString()}/pavement/multireport?listOfIds=` + searchParams.get("listOfIds"),
      icon: RiFileDownloadFill,
    },
    {
      name: "Traffic Management System",
      link: `${window.location.origin.toString()}/pavement/traffic?listOfIds=` + searchParams.get("listOfIds"),
      icon: RiTrafficLightLine,
    },
  ];

  const whiteMapStyles = [
    { elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#333333" }] },
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "on" }] },
    { featureType: "transit", elementType: "labels", stylers: [{ visibility: "on" }] },
    { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#c9c9c9" }] },
    { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#d9d9d9" }] },
    { featureType: "road", elementType: "labels", stylers: [{ visibility: "on" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#d0d0d0" }] },
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#e0e0e0" }] }
  ];

  const darkMapStyles = [
    { elementType: "geometry", stylers: [{ color: "#000000" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#808080" }] },
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "water", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#404040" }] },
    { featureType: "road", elementType: "labels", stylers: [{ visibility: "on", color: "#f9f9f9" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#404040" }] },
    { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "on", color: "#f9f9f9" }] }
  ];

  const mapStyles = mapStyleMode === 'white' ? whiteMapStyles : darkMapStyles;

  const RoadRatingGauge = ({ rating }) => (
    <GaugeChart
      id="gauge-chart1"
      nrOfLevels={10}
      needleColor="#000000"
      arcPadding={0.02}
      textColor="#000000"
      percent={(rating || 0) / 100}
      colors={['red', 'orange', 'green']}
      style={{ margin: 'auto', width: '60%', height: '60%' }}
    />
  );

  // Navigation helpers
  //
  // The master `markers` array is a concatenation of frames from every uid
  // (road × day/night × side). Walking it directly makes "next" jump across
  // road/day boundaries and look random on the map. Restrict prev/next to
  // visible frames of the SAME uid as the currently-selected marker, ordered
  // by og_file basename (frame sequence number). Wraps within the uid.
  const _frameSeq = (m) => {
    // og_file basename like ".../frames/001150.jpg" → 1150
    const base = ((m.og_file || '') + '').split('/').pop() || '';
    const n = parseInt(base.replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(n) ? n : 0;
  };
  const _siblingsOfCurrent = (prevIndex) => {
    const current = markers[prevIndex];
    if (!current) return { list: [], idx: -1 };
    const uid = current.uid;
    const list = markers
      .map((m, i) => ({ m, i }))
      .filter(({ m }) => m.isvisible && m.uid === uid)
      .sort((a, b) => _frameSeq(a.m) - _frameSeq(b.m) || a.i - b.i);
    const idx = list.findIndex(({ i }) => i === prevIndex);
    return { list, idx };
  };
  const goToPreviousMarker = () => {
    setCurrentMarkerIndex(prevIndex => {
      const { list, idx } = _siblingsOfCurrent(prevIndex);
      if (list.length === 0) return prevIndex;
      const target = list[idx > 0 ? idx - 1 : list.length - 1];
      triggerMarkerClick(target.i);
      return target.i;
    });
  };
  const goToNextMarker = () => {
    setCurrentMarkerIndex(prevIndex => {
      const { list, idx } = _siblingsOfCurrent(prevIndex);
      if (list.length === 0) return prevIndex;
      const target = list[idx >= 0 && idx < list.length - 1 ? idx + 1 : 0];
      triggerMarkerClick(target.i);
      return target.i;
    });
  };
  const triggerMarkerClick = (index) => {
    const marker = markers[index];
    if (marker) {
      // Route through openMarkerDetail so SuperAdmin map-only markers lazy-fetch
      // their detail during prev/next navigation, same as a direct click.
      openMarkerDetail(marker, index);
    }
  };

  const toggleAutoPlay = () => {
    if (isAutoPlay) {
      clearInterval(autoPlayIntervalId);
    } else {
      startAutoPlay();
    }
    setIsAutoPlay(prev => !prev);
  };

  const startAutoPlay = () => {
    const intervalId = setInterval(() => {
      goToNextMarker();
    }, 3000);
    setAutoPlayIntervalId(intervalId);
  };

  const playPause = isAutoPlay ? (<FcNoVideo onClick={toggleAutoPlay} />) : (<FcVideoCall onClick={toggleAutoPlay} />);

  // Memoize marker scale to debounce zoom changes
  const markerScale = useMemo(() => calculateScale(zoomLevel), [zoomLevel]);


  // Supercluster disabled — reverted to viewport-culled individual dots / colored
  // road segments (no cluster bubbles, per UX preference). Building the index over
  // 1M points (sc.load) was itself a load-time cost, so we skip it. Body kept for
  // rollback if cluster rendering is ever reinstated.
  const superclusterIndex = null;
  /* const superclusterIndex = useMemo(() => {
    const visibleMarkers = markers.filter(m => m.isvisible);
    if (visibleMarkers.length === 0) return null;
    const sc = new Supercluster({ radius: 80, maxZoom: 15, minPoints: 2 });
    const points = visibleMarkers.map((m) => ({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [m.longitude, m.latitude] },
      properties: {
        markerIndex: markers.indexOf(m),
        defect_state: m.defect_state,
        marker: m,
      },
    }));
    sc.load(points);
    return sc;
  }, [markers]); */

  // Compute cluster/point data for the current VIEWPORT + zoom. Querying the
  // visible bbox (not the whole world) is what keeps this bounded — supercluster
  // returns at most a screenful of clusters/points regardless of total count, so
  // deck.gl never receives the full 1M array.
  const clusterData = useMemo(() => {
    if (!superclusterIndex) return [];
    const zoom = Math.max(0, Math.min(Math.round(zoomLevel), 20));
    const bbox = mapBounds
      ? [mapBounds.west, mapBounds.south, mapBounds.east, mapBounds.north]
      : [-180, -85, 180, 85]; // before first idle: whole world (clusters keep it small)
    const raw = superclusterIndex.getClusters(bbox, zoom);
    return raw.map(c => {
      if (c.properties.cluster) {
        // Sample up to 50 leaves to estimate the cluster's dominant severity.
        // (getLeaves(Infinity) is O(cluster size) — far too slow at low zoom
        // where a single cluster can hold 100k+ points.)
        const leaves = superclusterIndex.getLeaves(c.properties.cluster_id, 50);
        let high = 0, medium = 0;
        leaves.forEach(l => {
          const color = getMarkerColor(l.properties.defect_state, false, l.properties.marker?.inference_info);
          if (color === '#DC3C3C') high++;
          else if (color === '#E87A00') medium++;
        });
        return {
          position: c.geometry.coordinates,
          count: c.properties.point_count,
          isCluster: true,
          clusterId: c.properties.cluster_id,
          dominantSeverity: high > 0 ? 'high' : medium > 0 ? 'medium' : 'low',
        };
      }
      const m = c.properties.marker;
      return {
        position: c.geometry.coordinates,
        count: 1,
        isCluster: false,
        markerIndex: c.properties.markerIndex,
        marker: m,
        // Hex here (getRGBColor is defined later); converted in the layer accessor.
        colorHex: getMarkerColor(m.defect_state, false, m.inference_info),
      };
    });
  }, [superclusterIndex, zoomLevel, mapBounds, getMarkerColor]);

  // Continuous colored road lines for the low-zoom (defects) view. Built ONCE per
  // markers load (NOT per pan): group visible markers BY ROAD (so lines never jump
  // between roads), sort each road by capture order, SIMPLIFY long roads to a
  // bounded number of points (keeps the line continuous but cheap), and color each
  // segment by its start point's effective severity (same source as the dots).
  const allDefectSegments = useMemo(() => {
    const severityColor = (s) =>
      s === 'high' ? [220, 55, 55] : s === 'medium' ? [230, 115, 0]
        : s === 'low' ? [220, 190, 0] : [0, 175, 0];
    const _COLOR_TO_SEV = { '#DC3C3C': 'high', '#E87A00': 'medium', '#C8C800': 'low' };
    const distM = (lat1, lng1, lat2, lng2) => {
      const dLat = (lat2 - lat1) * Math.PI / 180, dLng = (lng2 - lng1) * Math.PI / 180;
      const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
      return 6371000 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    };

    // Group visible markers by road.
    const byRoad = new Map();
    for (let i = 0; i < markers.length; i++) {
      const m = markers[i];
      if (!m.isvisible) continue;
      const key = m.uid || m.road_id || 'na';
      let arr = byRoad.get(key);
      if (!arr) { arr = []; byRoad.set(key, arr); }
      arr.push(m);
    }

    const MAX_PTS_PER_ROAD = 400; // simplify long roads (still smooth at any zoom)
    const BREAK_M = 2000;         // break disconnected stretches merged under one road id
    const segments = [];
    for (const arr of byRoad.values()) {
      arr.sort((a, b) => (a.markerIndex || 0) - (b.markerIndex || 0));
      const stride = arr.length > MAX_PTS_PER_ROAD ? Math.ceil(arr.length / MAX_PTS_PER_ROAD) : 1;
      const pts = stride === 1 ? arr : arr.filter((_, i) => i % stride === 0);
      for (let i = 0; i < pts.length - 1; i++) {
        const p = pts[i], q = pts[i + 1];
        if (distM(p.latitude, p.longitude, q.latitude, q.longitude) > BREAK_M) continue;
        const severity = _COLOR_TO_SEV[getMarkerColor(p.defect_state, false, p.inference_info)] || 'none';
        segments.push({
          path: [[p.longitude, p.latitude], [q.longitude, q.latitude]],
          color: severityColor(severity),
          severity,
        });
      }
    }
    return segments;
  }, [markers, getMarkerColor]);

  // Cheap per-pan viewport filter over the precomputed continuous segments.
  const defectSegments = useMemo(() => {
    const b = mapBounds;
    if (!b) return allDefectSegments;
    const inB = (lat, lng) => lat >= b.south && lat <= b.north && lng >= b.west && lng <= b.east;
    return allDefectSegments.filter(s => {
      const [[lng1, lat1], [lng2, lat2]] = s.path;
      return inB(lat1, lng1) || inB(lat2, lng2);
    });
  }, [allDefectSegments, mapBounds]);

  // Convert marker colors to RGB format for deck.gl
  const getRGBColor = useCallback((hexColor) => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return [r, g, b];
  }, []);

  // Enrich traffic congestion points with nearby defects for Google Maps markers
  const trafficPointsEnriched = useMemo(() => {
    if (!showTrafficCongestion || trafficCongestionData.length === 0) return [];
    return trafficCongestionData.map(tp => {
      const nearbyDefects = markers.filter(m => {
        if (!m.isvisible || !m.inference_info || m.inference_info.length === 0) return false;
        const dist = _haversineKm(tp.latitude, tp.longitude, Number(m.latitude), Number(m.longitude));
        return dist <= 0.05; // 50 meters
      });
      const defectLabels = [...new Set(nearbyDefects.flatMap(m => (m.inference_info || []).map(i => i.label)))];
      return { ...tp, nearbyDefects: nearbyDefects.length, defectLabels };
    });
  }, [showTrafficCongestion, trafficCongestionData, markers]);

  // Icon mapping for deck.gl IconLayer
  const ICON_MAPPING = {
    marker: {
      x: 0,
      y: 0,
      width: 128,
      height: 128,
      mask: true
    }
  };

  // Create deck.gl dot data — VIEWPORT-CULLED so we never build/render the full
  // 1M array. Only visible markers inside the current map bounds are included
  // (then strided down to VIEWPORT_RENDER_CAP if still too many). Keeps the
  // original individual-dot look while staying responsive at super-admin scale.
  const deckGLData = useMemo(() => {
    const b = mapBounds;
    const inView = [];
    const len = markers.length;
    for (let i = 0; i < len; i++) {
      const marker = markers[i];
      if (!marker.isvisible) continue;
      if (b && (marker.latitude < b.south || marker.latitude > b.north ||
                marker.longitude < b.west || marker.longitude > b.east)) continue;
      const isSelected = currentMarkerIndex === i;
      inView.push({
        position: [marker.longitude, marker.latitude],
        color: getRGBColor(isSelected ? '#00000000' : getMarkerColor(marker.defect_state, false, marker.inference_info)),
        radius: isSelected ? 0 : 5,
        isSelected,
        markerIndex: i,
        originalMarker: marker,
      });
    }
    if (inView.length > VIEWPORT_RENDER_CAP) {
      const stride = Math.ceil(inView.length / VIEWPORT_RENDER_CAP);
      return inView.filter((_, i) => i % stride === 0);
    }
    return inView;
  }, [markers, mapBounds, currentMarkerIndex, getMarkerColor, getRGBColor]);

  // Update deck.gl layers based on display mode and zoom level
  useEffect(() => {
    if (!overlayRef.current) return;

    const layers = [];

    if (mapDisplayMode === 'heatmap') {
      // Density heatmap — useful when zoomed out for concentration overview
      const visibleMarkers = markers.filter(m => m.isvisible);
      layers.push(new HeatmapLayer({
        id: 'heatmap-layer',
        data: visibleMarkers,
        getPosition: d => [d.longitude, d.latitude],
        getWeight: d => d.defect_state === 'high' ? 3 : d.defect_state === 'medium' ? 2 : 1,
        radiusPixels: 40,
        intensity: 1,
        threshold: 0.03,
        colorRange: [
          [65, 182, 196, 100],
          [127, 205, 187, 160],
          [199, 233, 180, 190],
          [255, 153, 0, 220],
          [228, 64, 64, 255],
        ],
      }));
    } else if (mapDisplayMode === 'defects') {
      // Individual colored dots (zoom ≥ 13) or colored road polylines (zoom < 13),
      // exactly like before — but the data (deckGLData / defectSegments) is now
      // VIEWPORT-CULLED + capped, so we never render the full 1M set. No clustering.
      const SHOW_DOTS = zoomLevel >= 13;
      if (SHOW_DOTS) {
        layers.push(new ScatterplotLayer({
          id: 'markers-layer',
          data: deckGLData,
          pickable: true,
          opacity: 0.92,
          stroked: !isKotaOrg(),
          filled: true,
          radiusUnits: 'pixels',
          radiusScale: 1,
          radiusMinPixels: 4,
          radiusMaxPixels: 10,
          lineWidthMinPixels: 1,
          lineWidthUnits: 'pixels',
          getPosition: d => d.position,
          getRadius: d => d.radius,
          getFillColor: d => [...d.color, 220],
          getLineColor: d => d.isSelected ? [0, 0, 0, 180] : [255, 255, 255, 120],
          getLineWidth: 1,
          onClick: (info) => {
            if (info.object) {
              openMarkerDetail(info.object.originalMarker, info.object.markerIndex);
            }
          },
          onHover: (info) => {
            if (mapRef.current) {
              mapRef.current.getCanvas().style.cursor = info.object ? 'pointer' : 'default';
            }
          },
          updateTriggers: {
            getRadius: [currentMarkerIndex],
            getFillColor: [currentMarkerIndex],
          },
        }));
      } else {
        // Low/medium zoom — colored road polyline segments (viewport-culled).
        const hasSeverityFilter = Object.values(severityOptions).slice(1).some(s => s.selected);
        const selectedSeverities = Object.values(severityOptions).slice(1)
          .filter(s => s.selected)
          .map(s => s.label.toLowerCase());

        const visibleSegs = hasSeverityFilter
          ? defectSegments.filter(s => {
            const segSev = s.severity === 'none' ? 'no defect' : s.severity;
            return selectedSeverities.includes(segSev);
          })
          : defectSegments;

        const _COND_SEV = { 'Poor': ['high'], 'Fair': ['medium'], 'Good': ['low', 'none'] };
        const conditionSegs = selectedConditions.length > 0
          ? visibleSegs.filter(s => selectedConditions.some(c => (_COND_SEV[c] || []).includes(s.severity)))
          : visibleSegs;

        if (conditionSegs.length > 0) {
          layers.push(new PathLayer({
            id: 'defect-segments-layer',
            data: conditionSegs,
            pickable: false,
            widthUnits: 'pixels',
            getWidth: zoomLevel >= 13 ? 4 : 3,
            getPath: d => d.path,
            getColor: d => [...d.color, 230],
            capRounded: true,
            jointRounded: true,
          }));
        }
      }
    }
    // mapDisplayMode === 'road_condition': no deck.gl layers, polylines remain visible

    // Traffic congestion markers are rendered as native Google Maps <Marker> components in JSX below

    overlayRef.current.setProps({ layers });
  }, [deckGLData, defectSegments, currentMarkerIndex, openMarkerDetail, mapDisplayMode, zoomLevel, markers, mapStyleMode, severityOptions, selectedConditions]);

  const spiderLines = [];

  // Road polylines as a single MapLibre GeoJSON source (was one <Polyline> per
  // inference). Each feature carries its color + index so we can color via a
  // data-driven paint expression and map a click back to its inference.
  const roadFeatureCollection = useMemo(() => ({
    type: "FeatureCollection",
    features: allInferenceList.map((inference, index) => {
      const path = getPathFromInference(inference);
      return {
        type: "Feature",
        properties: {
          idx: index,
          color: getRoadColor(inference.data?.road_rating ?? inference.road_rating),
        },
        geometry: {
          type: "LineString",
          coordinates: (path || []).map(p => [p.lng, p.lat]),
        },
      };
    }).filter(f => f.geometry.coordinates.length > 1),
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [allInferenceList, isRoad, mapDisplayMode, selectedConditions]);

  const roadInteractiveLayerIds = useMemo(
    () => (roadFeatureCollection.features.length > 0 ? ["roads-line"] : []),
    [roadFeatureCollection]
  );

  // Map-level click handler: open the road modal when a road line is clicked.
  const handleMapClick = useCallback((e) => {
    const f = e.features && e.features[0];
    if (f && f.layer && f.layer.id === "roads-line") {
      const idx = f.properties?.idx;
      if (idx != null && allInferenceList[idx]) {
        handlePolylineClick(e, allInferenceList[idx]);
      }
    }
  }, [allInferenceList]);

  // --- Render ---
  return (
    <div className="w-full h-full flex flex-col overflow-hidden bg-gradient-to-br from-blue-50 to-indigo-50">
      {/* Non-blocking loading indicator — map is visible behind it */}
      {!markersLoaded && (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 z-[100] bg-white/90 backdrop-blur-sm shadow-lg rounded-full px-5 py-2.5 flex items-center gap-3">
          <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <span className="text-sm font-medium text-gray-700">Loading markers...</span>
          {markers.length > 0 && (
            <span className="text-xs text-gray-500">({markers.filter(m => m.isvisible).length} loaded)</span>
          )}
        </div>
      )}

      {/* Header */}
      <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-full mx-auto px-6 py-3">
          <div className="flex items-center justify-between">
            {/* Left section */}
            <div></div>

            {/* Right section: controls */}
            <div className="flex items-center gap-3">
              {/* Map Display Mode Toggle */}
              {/* <div className="flex items-center rounded-lg border border-gray-300 overflow-hidden bg-white shadow-sm" title="Switch map display mode">
                {[
                  // { mode: 'road_condition', label: 'Roads' },
                  { mode: 'defects', label: 'Defects' },
                  // { mode: 'heatmap', label: 'Heatmap' },
                ].map(({ mode, label }) => (
                  <button
                    key={mode}
                    onClick={() => setMapDisplayMode(mode)}
                    className={`px-3 py-2 text-sm font-medium transition-colors border-r border-gray-300 last:border-r-0 ${mapDisplayMode === mode
                        ? 'bg-slate-800 text-white'
                        : 'text-gray-600 hover:bg-gray-100'
                      }`}
                  >
                    {label}
                  </button>
                ))}
              </div> */}
              <button
                onClick={handleOverviewClick}
                className="px-4 py-2 rounded-lg bg-white hover:bg-slate-50 text-slate-700 hover:text-slate-900 font-medium text-sm transition-all duration-200 flex items-center gap-2 border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300"
                title="View all markers on map"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                </svg>
                <span className="hidden sm:inline">Overview</span>
              </button>
              <button
                onClick={() => setMapStyleMode(mapStyleMode === 'white' ? 'dark' : 'white')}
                className="px-4 py-2 rounded-lg bg-white hover:bg-slate-50 text-slate-700 hover:text-slate-900 font-medium text-sm transition-all duration-200 flex items-center gap-2 border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300"
                title={mapStyleMode === 'white' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
              >
                {mapStyleMode === 'white' ? (
                  <>
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                    </svg>
                    <span className="hidden sm:inline">Dark</span>
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
                    </svg>
                    <span className="hidden sm:inline">Light</span>
                  </>
                )}
              </button>
              <button
                onClick={toggleFullScreen}
                className="px-4 py-2 rounded-lg bg-white hover:bg-slate-50 text-slate-700 hover:text-slate-900 font-medium text-sm transition-all duration-200 flex items-center gap-2 border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300"
                title={isFullScreen ? 'Exit Full Screen' : 'Full Screen'}
              >
                {isFullScreen ? (
                  <>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25" />
                    </svg>
                    <span className="hidden sm:inline">Exit</span>
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
                    </svg>
                    <span className="hidden sm:inline">Full Screen</span>
                  </>
                )}
              </button>
              {/* <ProfileMenu /> */}
            </div>
          </div>
        </div>
      </header>


      {/* Top Filter Bar */}
      <div className="bg-white border-b border-gray-200 z-40 shadow-sm">

        {/* Filter buttons row */}
        <div className="px-4 py-2 flex items-center gap-2 flex-wrap">
          {/* Filter icon */}
          <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
          </svg>

          {/* Organization (SuperAdmin only) — deselect orgs to hide them from the map */}
          {isSuperAdmin && ORG_OPTIONS.length > 0 && (
            <div className="relative" ref={orgDropdownRef}>
              <button
                onClick={() => setOrgDropdownOpen(v => !v)}
                className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
              >
                Organization
                {selectedOrganizations.length > 0 && <span className="bg-gray-800 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center leading-none font-semibold">{selectedOrganizations.length}</span>}
                <svg className={`w-3 h-3 transition-transform ${orgDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
              </button>
              {orgDropdownOpen && (
                <FilterCheckboxMenu
                  options={ORG_OPTIONS}
                  selected={selectedOrganizations}
                  onToggle={(opt) => toggleTopFilter(setSelectedOrganizations, opt)}
                  width="w-56"
                  placeholder="Search organization..."
                />
              )}
            </div>
          )}

          {/* Road Name */}
          <div className="relative" ref={roadNameDropdownRef}>
            <button
              onClick={() => setRoadNameDropdownOpen(v => !v)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
            >
              Road Name
              {selectedRoadNames.length > 0 && <span className="bg-gray-800 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center leading-none font-semibold">{selectedRoadNames.length}</span>}
              <svg className={`w-3 h-3 transition-transform ${roadNameDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {roadNameDropdownOpen && (
              <FilterCheckboxMenu
                options={ROAD_NAME_OPTIONS}
                selected={selectedRoadNames}
                onToggle={(opt) => toggleTopFilter(setSelectedRoadNames, opt)}
                width="w-56"
                placeholder="Search road name..."
              />
            )}
          </div>

          {/* Authority */}
          <div className="relative" ref={authorityDropdownRef}>
            <button
              onClick={() => setAuthorityDropdownOpen(v => !v)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
            >
              Authority
              {selectedAuthorities.length > 0 && <span className="bg-gray-800 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center leading-none font-semibold">{selectedAuthorities.length}</span>}
              <svg className={`w-3 h-3 transition-transform ${authorityDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {authorityDropdownOpen && (
              <FilterCheckboxMenu
                options={AUTHORITY_OPTIONS}
                selected={selectedAuthorities}
                onToggle={(opt) => toggleTopFilter(setSelectedAuthorities, opt)}
                width="w-48"
                placeholder="Search authority..."
              />
            )}
          </div>

          {/* Ward */}
          {isKhammamUser && wardOptions.length > 0 && (
            <div className="relative" ref={wardDropdownRef}>
              <button
                onClick={() => setWardDropdownOpen(o => !o)}
                className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
              >
                <svg className="w-3.5 h-3.5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                Ward
                {selectedWardFilters.length > 0 && (
                  <span className="bg-gray-800 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center leading-none font-semibold">{selectedWardFilters.length}</span>
                )}
                <svg className={`w-3 h-3 transition-transform ${wardDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {wardDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-50 max-h-80 flex flex-col">
                  <div className="p-2 border-b border-gray-100">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search ward..."
                        value={wardSearchTerm}
                        onChange={(e) => setWardSearchTerm(e.target.value)}
                        className="w-full px-3 py-1.5 pl-8 text-xs border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                      <svg className="w-3.5 h-3.5 text-slate-400 absolute left-2.5 top-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                  </div>
                  <div className="overflow-y-auto flex-1 p-2">
                    <FormGroup className="space-y-0.5">
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={selectedWardFilters.length === wardOptions.length && wardOptions.length > 0}
                            indeterminate={selectedWardFilters.length > 0 && selectedWardFilters.length < wardOptions.length}
                            onChange={() => handleWardFilterToggle('__ALL__')}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 16 }, '&.Mui-checked': { color: '#0d9488' }, '&.MuiCheckbox-indeterminate': { color: '#0d9488' } }}
                          />
                        }
                        label={<span className="text-xs font-semibold text-slate-700">Select All</span>}
                        className="ml-0"
                      />
                      {filteredWardOptions.length > 0 ? filteredWardOptions.map((ward, idx) => {
                        const count = backupMarkerState.filter(m => m._ward === ward).length;
                        return (
                          <FormControlLabel
                            key={`ward-${idx}`}
                            control={
                              <Checkbox
                                size="small"
                                checked={selectedWardFilters.includes(ward)}
                                onChange={() => handleWardFilterToggle(ward)}
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 16 }, '&.Mui-checked': { color: '#0d9488' } }}
                              />
                            }
                            label={
                              <span className="text-xs text-slate-700 flex items-center gap-1">
                                {ward}
                                <span className="text-[10px] text-slate-400">({count})</span>
                              </span>
                            }
                            className="ml-0"
                          />
                        );
                      }) : (
                        <div className="text-xs text-slate-500 text-center py-2">No wards found</div>
                      )}
                    </FormGroup>
                  </div>
                  {selectedWardFilters.length > 0 && (
                    <div className="p-2 border-t border-gray-100">
                      <button
                        onClick={() => setSelectedWardFilters([])}
                        className="w-full py-1 px-3 text-xs font-medium text-teal-700 bg-teal-50 hover:bg-teal-100 border border-teal-200 rounded-md transition-colors"
                      >
                        Clear Ward Filter
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Road Type */}
          <div className="relative" ref={roadTypeDropdownRef}>
            <button
              onClick={() => setRoadTypeDropdownOpen(v => !v)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
            >
              Road Type
              {selectedRoadTypes.length > 0 && <span className="bg-gray-800 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center leading-none font-semibold">{selectedRoadTypes.length}</span>}
              <svg className={`w-3 h-3 transition-transform ${roadTypeDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {roadTypeDropdownOpen && (
              <FilterCheckboxMenu
                options={ROAD_TYPE_OPTIONS}
                selected={selectedRoadTypes}
                onToggle={(opt) => toggleTopFilter(setSelectedRoadTypes, opt)}
                width="w-56"
                placeholder="Search road type..."
              />
            )}
          </div>

          {/* Condition */}
          <div className="relative" ref={conditionDropdownRef}>
            <button
              onClick={() => setConditionDropdownOpen(v => !v)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
            >
              Road Condition
              {selectedConditions.length > 0 && <span className="bg-gray-800 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center leading-none font-semibold">{selectedConditions.length}</span>}
              <svg className={`w-3 h-3 transition-transform ${conditionDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {conditionDropdownOpen && (
              <FilterCheckboxMenu
                options={CONDITION_OPTIONS}
                selected={selectedConditions}
                onToggle={(opt) => toggleTopFilter(setSelectedConditions, opt)}
                width="w-48"
                placeholder="Search condition..."
              />
            )}
          </div>

          {/* Survey Date */}
          <div className="relative" ref={surveyDateRef}>
            <button
              onClick={() => setSurveyDateOpen(prev => !prev)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
            >
              Survey Date
              {selectedSurveyDate && <span className="bg-gray-800 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center leading-none font-semibold">1</span>}
              <svg className={`w-3 h-3 transition-transform ${surveyDateOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {surveyDateOpen && (
              <div className="absolute top-full left-0 mt-1 w-44 bg-white rounded-lg shadow-xl border border-gray-200 z-50 py-1 max-h-52 overflow-y-auto">
                {uniqueSurveyDates.length === 0 ? (
                  <div className="px-3 py-2 text-xs text-gray-400">No dates available</div>
                ) : (
                  uniqueSurveyDates.map(date => {
                    const isSelected = date === selectedSurveyDate;
                    const label = new Date(date + 'T00:00:00').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
                    return (
                      <div
                        key={date}
                        role="button"
                        onClick={() => { setSelectedSurveyDate(isSelected ? '' : date); setSurveyDateOpen(false); }}
                        className={`flex items-center justify-between px-3 py-2 text-sm cursor-pointer transition-colors ${isSelected ? 'bg-blue-50 text-blue-700 font-medium' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                      >
                        <span>{label}</span>
                        {isSelected && (
                          <svg className="w-3.5 h-3.5 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                          </svg>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>

          {/* Day/Night */}
          <div className="relative" ref={dayNightDropdownRef}>
            <button
              onClick={() => setDayNightDropdownOpen(v => !v)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
            >
              {selectedDayNight.length > 0 ? selectedDayNight.join(', ') : 'Day/Night'}
              <svg className={`w-3 h-3 transition-transform ${dayNightDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {dayNightDropdownOpen && (
              <div className="absolute top-full left-0 mt-1 w-32 bg-white rounded-lg shadow-xl border border-gray-200 z-50 py-1">
                {DAY_NIGHT_OPTIONS.map(opt => {
                  const isSelected = selectedDayNight.includes(opt);
                  return (
                    <div
                      key={opt}
                      role="button"
                      onClick={() => { setSelectedDayNight([opt]); setDayNightDropdownOpen(false); }}
                      className={`flex items-center justify-between px-3 py-1.5 cursor-pointer text-sm ${isSelected ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700 hover:bg-gray-50'}`}
                    >
                      <span>{opt}</span>
                      {isSelected && (
                        <svg className="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" /></svg>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* LHS/RHS (Road Side) */}
          <div className="relative" ref={sideDropdownRef}>
            <button
              onClick={() => setSideDropdownOpen(v => !v)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-300 rounded-full text-gray-700 hover:border-gray-500 transition-colors focus:outline-none"
            >
              {selectedSides.length > 0 ? selectedSides.join(', ') : 'LHS/RHS'}
              <svg className={`w-3 h-3 transition-transform ${sideDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {sideDropdownOpen && (
              <div className="absolute top-full left-0 mt-1 w-28 bg-white rounded-lg shadow-xl border border-gray-200 z-50 py-1">
                {SIDE_OPTIONS.map(opt => {
                  const isSelected = selectedSides.includes(opt);
                  return (
                    <div
                      key={opt}
                      role="button"
                      onClick={() => { setSelectedSides([opt]); setSideDropdownOpen(false); }}
                      className={`flex items-center justify-between px-3 py-1.5 cursor-pointer text-sm ${isSelected ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700 hover:bg-gray-50'}`}
                    >
                      <span>{opt}</span>
                      {isSelected && (
                        <svg className="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" /></svg>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Traffic Congestion Toggle */}
          {trafficCongestionData.length > 0 && (
            <button
              onClick={() => { setShowTrafficCongestion(v => !v); setSelectedTrafficPoint(null); }}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-sm border rounded-full transition-colors focus:outline-none ${showTrafficCongestion
                  ? 'bg-amber-500 border-amber-500 text-white font-medium'
                  : 'bg-white border-gray-300 text-gray-700 hover:border-gray-500'
                }`}
            >
              <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              Traffic Congestion
              <span className={`text-xs rounded-full px-1.5 py-0.5 leading-none font-semibold ${showTrafficCongestion ? 'bg-white text-amber-600' : 'bg-amber-100 text-amber-700'}`}>
                {trafficCongestionData.length}
              </span>
            </button>
          )}

          {/* Clear top filters */}
          {hasTopFilters && (
            <button
              onClick={clearTopFilters}
              className="ml-auto flex items-center gap-1.5 text-xs text-red-500 hover:text-red-700 transition-colors"
            >
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              Clear filters
            </button>
          )}
        </div>{/* end filter buttons row */}

        {/* Active filter chips row */}
        {hasTopFilters && (
          <div className="px-4 py-1.5 flex items-center gap-1.5 flex-wrap border-t border-gray-100 bg-gray-50">
            <svg className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
            </svg>
            {selectedOrganizations.map(v => (
              <span key={v} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => toggleTopFilter(setSelectedOrganizations, v)} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedAuthorities.map(v => (
              <span key={v} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => toggleTopFilter(setSelectedAuthorities, v)} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedRoadNames.map(v => (
              <span key={v} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => toggleTopFilter(setSelectedRoadNames, v)} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedRoadTypes.map(v => (
              <span key={v} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => toggleTopFilter(setSelectedRoadTypes, v)} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedConditions.map(v => (
              <span key={v} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => toggleTopFilter(setSelectedConditions, v)} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedWardFilters.map(v => (
              <span key={v} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => setSelectedWardFilters(prev => prev.filter(w => w !== v))} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedDayNight.map(v => (
              <span key={`dn-${v}`} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => toggleTopFilter(setSelectedDayNight, v)} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedSides.map(v => (
              <span key={`side-${v}`} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                {v}
                <button onClick={() => toggleTopFilter(setSelectedSides, v)} className="hover:text-blue-900 leading-none">×</button>
              </span>
            ))}
            {selectedSurveyDate && (
              <span className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                Survey: {new Date(selectedSurveyDate + 'T00:00:00').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                <button onClick={() => setSelectedSurveyDate('')} className="hover:text-blue-900 leading-none">×</button>
              </span>
            )}
            {showTrafficCongestion && (
              <span className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-amber-50 border border-amber-200 text-amber-700 text-xs rounded-full font-medium">
                Traffic Congestion ({trafficCongestionData.length})
                <button onClick={() => setShowTrafficCongestion(false)} className="hover:text-amber-900 leading-none">×</button>
              </span>
            )}
          </div>
        )}
      </div>

      {/* Main layout */}
      <div className="flex flex-1 overflow-hidden bg-gray-50">

        {/* Map area */}
        <main className="flex-1 relative">
          <div className="absolute inset-0">
            {/* Full screen loading - only while map API loads */}
            {!isLoaded && (
              <div className="absolute inset-0 z-10 flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
                <div className="text-center">
                  <div className="w-12 h-12 border-3 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
                  <p className="mt-4 text-gray-600 font-medium">Initializing map...</p>
                </div>
              </div>
            )}

            {/* Zoom-level hint for defects mode */}
            {isLoaded && mapDisplayMode === 'defects' && markers.filter(m => m.isvisible).length > 0 && zoomLevel < 16 && (
              <div className={`absolute left-1/2 -translate-x-1/2 z-30 pointer-events-none transition-all duration-200 ${showDefectFilters
                  ? (Object.values(severityOptions).slice(1).some(s => s.selected) || Object.values(checkboxes).some(cb => cb.selected) ? 'bottom-36' : 'bottom-24')
                  : 'bottom-10'
                }`}>
                <div className="bg-slate-800/80 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full shadow-md">
                  Zoom in to see individual defect points
                </div>
              </div>
            )}

            {/* Dynamic Color Legend — toggle button + panel that opens to the left */}
            {isLoaded && (
              <div className={`absolute right-4 z-30 flex items-end gap-2 transition-all duration-200 ${showDefectFilters
                  ? (Object.values(severityOptions).slice(1).some(s => s.selected) || Object.values(checkboxes).some(cb => cb.selected) ? 'bottom-36' : 'bottom-24')
                  : 'bottom-10'
                }`}>

                {/* Legend panel — slides in from right */}
                {showLegend && (
                  <div className={`backdrop-blur-sm rounded-xl shadow-lg px-4 py-3 min-w-[170px] transition-all duration-200 ${mapStyleMode === 'dark'
                      ? 'bg-slate-800/90 border border-slate-600'
                      : 'bg-white/92 border border-gray-200'
                    }`}>

                    {/* Individual defect points (zoom ≥ 16) — show severity labels */}
                    {mapDisplayMode === 'defects' && zoomLevel >= 16 && (
                      <>
                        <p className={`text-xs font-bold mb-2 ${mapStyleMode === 'dark' ? 'text-slate-100' : 'text-slate-700'}`}>Severity</p>
                        {[
                          { color: '#DC3C3C', label: 'High' },
                          { color: '#E87A00', label: 'Medium' },
                          { color: '#C8C800', label: 'Low' },
                          { color: '#00BB00', label: 'No Defect' },
                        ].map(({ color, label }) => (
                          <div key={label} className="flex items-center gap-2 mb-1 last:mb-0">
                            <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: color }} />
                            <span className={`text-xs ${mapStyleMode === 'dark' ? 'text-slate-200' : 'text-slate-600'}`}>{label}</span>
                          </div>
                        ))}
                      </>
                    )}

                    {/* Polyline overview (zoom < 16) */}
                    {mapDisplayMode === 'defects' && zoomLevel < 16 && (
                      <>
                        <p className={`text-xs font-bold mb-2 ${mapStyleMode === 'dark' ? 'text-slate-100' : 'text-slate-700'}`}>Severity</p>
                        {[
                          { color: '#DC3737', label: 'High', km: kmBySeverity.high },
                          { color: '#E67300', label: 'Medium', km: kmBySeverity.medium },
                          { color: '#DCBE00', label: 'Low', km: kmBySeverity.low },
                          { color: '#00AF00', label: 'No Defect', km: kmBySeverity.noDefect },
                        ].map(({ color, label, km }) => (
                          <div key={label} className="flex items-center gap-2 mb-1 last:mb-0">
                            <span className="w-5 h-1.5 rounded flex-shrink-0" style={{ backgroundColor: color }} />
                            <span className={`text-xs ${mapStyleMode === 'dark' ? 'text-slate-200' : 'text-slate-600'}`}>{label}</span>
                          </div>
                        ))}
                      </>
                    )}

                    {/* Heatmap gradient scale */}
                    {mapDisplayMode === 'heatmap' && (
                      <>
                        <p className={`text-xs font-bold mb-2 ${mapStyleMode === 'dark' ? 'text-slate-100' : 'text-slate-700'}`}>Heatmap Legend</p>
                        <div
                          className="h-3 w-full rounded mb-1"
                          style={{ background: 'linear-gradient(to right, #41B6C4, #7FCDBB, #C7E9B4, #FF9900, #E44040)' }}
                        />
                        <div className={`flex justify-between text-[10px] mb-1 ${mapStyleMode === 'dark' ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span>Low</span>
                          <span>High</span>
                        </div>
                        <p className={`text-[10px] ${mapStyleMode === 'dark' ? 'text-slate-400' : 'text-slate-400'}`}>Defect density</p>
                      </>
                    )}

                    {/* Road condition polyline colors */}
                    {mapDisplayMode === 'road_condition' && (
                      <>
                        <p className={`text-xs font-bold mb-2 ${mapStyleMode === 'dark' ? 'text-slate-100' : 'text-slate-700'}`}>Road Condition</p>
                        {[
                          { color: '#FF0000', label: 'Poor  (≤ 40)' },
                          { color: '#FFFF00', label: 'Fair  (40 – 80)', border: true },
                          { color: '#00FF00', label: 'Good  (> 80)', border: true },
                        ].map(({ color, label, border }) => (
                          <div key={label} className="flex items-center gap-2 mb-1 last:mb-0">
                            <span
                              className="w-3 h-3 rounded-full flex-shrink-0"
                              style={{ backgroundColor: color, border: border ? '1px solid #bbb' : 'none' }}
                            />
                            <span className={`text-xs ${mapStyleMode === 'dark' ? 'text-slate-200' : 'text-slate-600'}`}>{label}</span>
                          </div>
                        ))}
                      </>
                    )}

                    {/* Traffic Congestion legend */}
                    {showTrafficCongestion && (
                      <>
                        <div className={`${(mapDisplayMode === 'defects' || mapDisplayMode === 'heatmap' || mapDisplayMode === 'road_condition') ? 'mt-3 pt-2 border-t border-gray-200' : ''}`}>
                          <p className={`text-xs font-bold mb-2 ${mapStyleMode === 'dark' ? 'text-slate-100' : 'text-slate-700'}`}>Traffic Congestion</p>
                          <div className="flex items-center gap-2 mb-0">
                            <span className="w-3 h-3 flex-shrink-0" style={{ backgroundColor: '#DC3C3C', transform: 'rotate(45deg)' }} />
                            <span className={`text-xs ${mapStyleMode === 'dark' ? 'text-slate-200' : 'text-slate-600'}`}>Congestion Point</span>
                          </div>
                        </div>
                      </>
                    )}

                  </div>
                )}

                {/* Toggle button */}
                <button
                  onClick={() => setShowLegend(v => !v)}
                  className={`w-9 h-9 rounded-full shadow-lg flex items-center justify-center transition-all duration-200 flex-shrink-0 ${mapStyleMode === 'dark'
                      ? 'bg-slate-800/90 border border-slate-600 text-slate-200 hover:bg-slate-700'
                      : 'bg-white border border-gray-200 text-slate-600 hover:bg-gray-50'
                    }`}
                  title={showLegend ? 'Hide legend' : 'Show legend'}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
                  </svg>
                </button>

              </div>
            )}

            {/* Small loading indicator while markers load - overlayed on map */}
            {isLoaded && markers.length === 0 && (
              <div className="absolute top-20 left-1/2 transform -translate-x-1/2 z-50 bg-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 max-w-sm">
                <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin flex-shrink-0"></div>
                <div className="text-sm">
                  <p className="font-medium text-gray-700">Loading defect points...</p>
                  <p className="text-xs text-gray-500 mt-1">Fetching from server, this may take a moment</p>
                </div>
              </div>
            )}

            {/* Ahmedabad: a processed defect was selected but has no detections on
                the map. The filter lists every processed defect, so this is the
                expected empty-state for a defect the model looked for but never found. */}
            {isLoaded && noDataForSelectedDefect && (
              <div className="absolute top-20 left-1/2 transform -translate-x-1/2 z-50 bg-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 max-w-sm">
                <div className="text-sm">
                  <p className="font-medium text-gray-700">No data found for “{noDataForSelectedDefect}”</p>
                  <p className="text-xs text-gray-500 mt-1">This defect was processed but no detections were found for the current selection.</p>
                </div>
              </div>
            )}

            {isLoaded && (
              <MapGL
                initialViewState={{
                  longitude: center?.lng ?? 80.1514,
                  latitude: center?.lat ?? 17.2473,
                  zoom: 5,
                }}
                style={{ height: "100%", width: "100%" }}
                mapStyle={isCustomTile ? customTileStyle : (mapStyleMode === 'dark' ? MAPLIBRE_STYLE_DARK : MAPLIBRE_STYLE_LIGHT)}
                minZoom={3}
                maxZoom={20}
                dragRotate={false}
                cursor="pointer"
                onLoad={handleMapLoad}
                onIdle={handleMapIdle}
                onZoom={handleZoomChanged}
                interactiveLayerIds={roadInteractiveLayerIds}
                onClick={handleMapClick}
              >
                <NavigationControl position="top-right" showCompass={false} />

                {/* Spider lines for spiderfied markers */}
                {spiderLines}

                {/* Defect markers are rendered via the deck.gl overlay (handleMapLoad) */}

                {/* Road polylines — single GeoJSON source, colored per road rating */}
                {roadFeatureCollection.features.length > 0 && (
                  <Source id="roads" type="geojson" data={roadFeatureCollection}>
                    <Layer
                      id="roads-line"
                      type="line"
                      layout={{ "line-cap": "round", "line-join": "round" }}
                      paint={{
                        "line-color": ["get", "color"],
                        "line-width": 5,
                        "line-opacity": 0.9,
                      }}
                    />
                  </Source>
                )}

                {/* Selected point marker — road engineer icon (markerPos is the
                    tweened position so it glides between defect points) */}
                {markerPos.latitude !== null && markerPos.longitude !== null && (
                  <Marker
                    longitude={Number(markerPos.longitude)}
                    latitude={Number(markerPos.latitude)}
                    anchor="bottom"
                  >
                    <img src={selectedPointIcon} alt="" width={40} height={40} style={{ pointerEvents: 'none' }} />
                  </Marker>
                )}

                {/* Traffic Congestion pin markers */}
                {showTrafficCongestion && trafficPointsEnriched.map((tp, index) => (
                  <Marker
                    key={`traffic-${index}`}
                    longitude={Number(tp.longitude)}
                    latitude={Number(tp.latitude)}
                    anchor="center"
                    onClick={(e) => { e.originalEvent?.stopPropagation?.(); setSelectedTrafficPoint(tp); }}
                  >
                    <img
                      src={trafficSignalIcon}
                      alt=""
                      width={18}
                      height={21}
                      title={`Traffic Congestion: ${tp.address || `${tp.latitude}, ${tp.longitude}`}`}
                      style={{ cursor: 'pointer' }}
                    />
                  </Marker>
                ))}

              </MapGL>
            )}

            {/* Traffic Congestion overlay card — top-left corner */}
            {selectedTrafficPoint && (() => {
              const dk = mapStyleMode === 'dark';
              return (
                <div className={`absolute top-3 left-3 z-40 rounded-xl shadow-lg border p-4 max-w-xs backdrop-blur-sm ${dk ? 'bg-slate-800/95 border-slate-700' : 'bg-white border-slate-200'}`} style={{ fontFamily: "'DM Sans', sans-serif" }}>
                  {/* Header with close */}
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <div className="flex items-center gap-2">
                      <div className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${dk ? 'bg-orange-900/40' : 'bg-orange-50'}`}>
                        <svg className="w-4 h-4 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span className={`font-semibold text-sm leading-tight ${dk ? 'text-slate-100' : 'text-slate-800'}`}>
                        {selectedTrafficPoint.address || `${selectedTrafficPoint.latitude}, ${selectedTrafficPoint.longitude}`}
                      </span>
                    </div>
                    <button onClick={() => setSelectedTrafficPoint(null)} className={`p-1 rounded-md transition-colors flex-shrink-0 ${dk ? 'hover:bg-slate-700' : 'hover:bg-slate-100'}`}>
                      <svg className={`w-4 h-4 ${dk ? 'text-slate-400' : 'text-slate-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>
                  </div>

                  {/* Badges */}
                  <div className="flex gap-1.5 mb-3">
                    <span className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wide ${dk ? 'bg-red-900/40 text-red-400' : 'bg-red-50 text-red-600'}`}>
                      <span className="w-1.5 h-1.5 rounded-full bg-red-500" /> HIGH
                    </span>
                    <span className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wide ${dk ? 'bg-red-900/40 text-red-400' : 'bg-red-50 text-red-600'}`}>
                      <span className="w-1.5 h-1.5 rounded-full bg-red-500" /> HOTSPOT
                    </span>
                  </div>

                  {/* Road name */}
                  {selectedTrafficPoint.road_name && (
                    <p className={`text-xs mb-2 ${dk ? 'text-slate-400' : 'text-slate-500'}`}>Road: {selectedTrafficPoint.road_name}</p>
                  )}

                  {/* Nearby defects */}
                  {selectedTrafficPoint.defectLabels && selectedTrafficPoint.defectLabels.length > 0 ? (
                    <div>
                      <p className={`text-[10px] font-semibold uppercase tracking-wide mb-1 ${dk ? 'text-slate-500' : 'text-slate-400'}`}>Nearby Defects</p>
                      <div className="flex flex-wrap gap-1">
                        {selectedTrafficPoint.defectLabels.map((label, i) => (
                          <span key={i} className={`text-[11px] rounded-full px-2 py-0.5 border ${dk ? 'text-slate-300 bg-slate-700/60 border-slate-600' : 'text-slate-600 bg-slate-50 border-slate-200'}`}>
                            {label.replace(/[_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <p className={`text-xs ${dk ? 'text-slate-500' : 'text-slate-400'}`}>No defects detected nearby</p>
                  )}

                  {/* Coordinates */}
                  <div className={`flex gap-2 mt-2 pt-2 border-t ${dk ? 'border-slate-700' : 'border-slate-100'}`}>
                    <span className={`text-[10px] font-mono px-1.5 py-0.5 rounded border ${dk ? 'text-slate-400 bg-slate-700/60 border-slate-600' : 'text-slate-500 bg-slate-50 border-slate-200'}`}>
                      {Number(selectedTrafficPoint.latitude).toFixed(6)}
                    </span>
                    <span className={`text-[10px] font-mono px-1.5 py-0.5 rounded border ${dk ? 'text-slate-400 bg-slate-700/60 border-slate-600' : 'text-slate-500 bg-slate-50 border-slate-200'}`}>
                      {Number(selectedTrafficPoint.longitude).toFixed(6)}
                    </span>
                  </div>
                </div>
              );
            })()}
          </div>

          {/* Bottom Defect Filter Bar */}
          <div className="absolute bottom-0 left-0 right-0 z-30 pointer-events-none">
            {/* Toggle tab */}
            <div className="flex justify-center pointer-events-auto">
              <button
                onClick={() => setShowDefectFilters(v => !v)}
                className="bg-white border border-b-0 border-gray-200 rounded-t-lg px-4 py-1 text-xs text-gray-500 hover:text-gray-800 flex items-center gap-1.5 shadow-sm transition-colors"
              >
                <svg className={`w-3 h-3 transition-transform ${showDefectFilters ? '' : 'rotate-180'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
                {showDefectFilters ? 'Hide' : 'Show'} Defect Filters
              </button>
            </div>
            {showDefectFilters && (
              <div className="bg-white border-t border-gray-200 shadow-lg pointer-events-auto">

                {/* Active filter chips row */}
                {(Object.values(severityOptions).slice(1).some(s => s.selected) || Object.values(checkboxes).some(cb => cb.selected)) && (
                  <div className="px-6 py-1.5 flex items-center gap-1.5 flex-wrap border-b border-gray-100 bg-gray-50">
                    <svg className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
                    </svg>
                    {Object.values(severityOptions).slice(1).filter(s => s.selected).map(s => (
                      <span key={s.label} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                        {s.label}
                        <button onClick={() => setSeverityOptions(prev => { const t = { ...prev }; const idx = Object.values(t).findIndex(o => o.label === s.label); if (idx >= 0) t[idx] = { ...t[idx], selected: false }; return t; })} className="hover:text-blue-900 leading-none">×</button>
                      </span>
                    ))}
                    {Object.entries(checkboxes).filter(([k, cb]) => k !== '0' && cb.selected).map(([k, cb]) => (
                      <span key={k} className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded-full font-medium">
                        {cb.label}
                        <button onClick={() => setCheckboxes(prev => ({ ...prev, [k]: { ...prev[k], selected: false } }))} className="hover:text-blue-900 leading-none">×</button>
                      </span>
                    ))}
                  </div>
                )}

                <div className="px-6 py-2.5 flex items-center gap-5 flex-wrap">
                  {/* Severity toggles */}
                  <div className="flex items-center gap-3">
                    <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">Severity</span>
                    <div className="flex items-center gap-1.5">
                      {Object.values(severityOptions).map(({ label, checkedColor, color }, index) => {
                        if (index === 0) return null; // skip "Select All"
                        const isSelected = severityOptions[index].selected;
                        const dotColor = checkedColor || color;
                        return (
                          <label
                            key={index}
                            className={`flex items-center gap-1.5 cursor-pointer px-2.5 py-1 rounded-full border text-xs font-medium transition-all select-none ${isSelected
                                ? 'bg-gray-800 border-gray-800 text-white'
                                : 'border-gray-300 text-gray-600 bg-white hover:border-gray-400'
                              }`}
                          >
                            <input
                              type="checkbox"
                              className="hidden"
                              checked={isSelected}
                              onChange={(e) => handleEnroachChange(e, index)}
                            />
                            <span
                              className="w-2.5 h-2.5 rounded-full flex-shrink-0 border border-white/40"
                              style={{ backgroundColor: dotColor }}
                            />
                            {label}
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="h-6 w-px bg-gray-200 flex-shrink-0" />

                  {/* Defect Types dropdown */}
                  <div className="relative" ref={defectDropdownRef}>
                    <button
                      onClick={() => setDefectDropdownOpen(v => !v)}
                      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm border rounded-full transition-colors focus:outline-none ${Object.values(checkboxes).some(cb => cb.selected)
                          ? 'bg-blue-600 border-blue-600 text-white font-medium'
                          : 'bg-white border-gray-300 text-gray-700 hover:border-gray-400'
                        }`}
                    >
                      <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                      Defect Types
                      {Object.values(checkboxes).filter(cb => cb.selected).length > 0 && (
                        <span className="bg-white text-blue-600 text-xs rounded-full px-1.5 py-0.5 leading-none font-semibold">
                          {Object.values(checkboxes).filter(cb => cb.selected).length}
                        </span>
                      )}
                      <svg className={`w-3 h-3 transition-transform ${defectDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {defectDropdownOpen && (
                      // Centered in the viewport (fixed) rather than anchored to
                      // the off-center Defect Types button, so the wide 3-column
                      // panel can't run off-screen or clip under the sidebar.
                      // Height-capped to 55vh; the 3-column row below scrolls as a
                      // single unit (one scrollbar at the dropdown edge).
                      <div className="fixed left-1/2 -translate-x-1/2 ml-20 bottom-14 bg-white rounded-lg shadow-xl border border-gray-200 z-50 flex flex-col overflow-hidden" style={{ width: 'min(680px, 92vw)', maxHeight: '55vh' }}>
                        {/* Search bar */}
                        <div className="p-2.5 border-b border-gray-100 flex-shrink-0">
                          <div className="relative">
                            <input
                              type="text"
                              placeholder="Search defects..."
                              value={defectSearchTerm}
                              onChange={(e) => setDefectSearchTerm(e.target.value)}
                              className="w-full px-3 py-1.5 pl-8 text-xs border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <svg className="w-3.5 h-3.5 text-slate-400 absolute left-2.5 top-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            {defectSearchTerm && (
                              <button onClick={() => setDefectSearchTerm("")} className="absolute right-2 top-1.5 text-slate-400 hover:text-slate-600">
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            )}
                          </div>
                          {Object.values(checkboxes).some(cb => cb.selected) && (
                            <button
                              onClick={() => {
                                setCheckboxes(prev => {
                                  const cleared = {};
                                  Object.keys(prev).forEach(k => { cleared[k] = { ...prev[k], selected: false }; });
                                  return cleared;
                                });
                              }}
                              className="mt-1.5 w-full text-xs text-red-600 hover:text-red-800 hover:bg-red-50 border border-red-200 rounded-md py-1 transition-colors"
                            >
                              Clear all filters
                            </button>
                          )}
                        </div>

                        {/* 3-column layout — the row is the single scrollable
                            area. Columns themselves don't scroll; they share
                            the row's vertical scroll so all three move together
                            (one scrollbar at the dropdown edge, not three). */}
                        <div className="flex flex-1 divide-x divide-gray-100 overflow-y-auto">
                          {[
                            { key: 'pavement', label: 'Roadway Surface', color: '#3B82F6' },
                            { key: 'assets', label: 'Asset Management', color: '#3B82F6' },
                            { key: 'roadSafety', label: 'Road Safety', color: '#A855F7' },
                          ].map(({ key: catKey, label: catLabel, color }) => {
                            const subGroups = categorizedCheckboxes[catKey];
                            const allItems = subGroups.flatMap(sg => sg.items);
                            const selectedCount = allItems.filter(cb => checkboxes[cb.key]?.selected).length;
                            const allSelected = allItems.length > 0 && selectedCount === allItems.length;
                            if (defectSearchTerm.trim() !== '' && allItems.length === 0) return null;
                            return (
                              <div key={catKey} className="flex-1 flex flex-col min-w-0">
                                {/* Category header */}
                                <div className="flex items-center gap-2 px-3 py-2.5 border-b border-gray-100 flex-shrink-0">
                                  <button
                                    className="flex items-center gap-2 flex-1 text-left"
                                    onClick={() => {
                                      setCheckboxes(prev => {
                                        const updated = { ...prev };
                                        allItems.forEach(cb => {
                                          updated[cb.key] = { ...updated[cb.key], selected: !allSelected };
                                        });
                                        return updated;
                                      });
                                    }}
                                  >
                                    <div style={{
                                      width: 20, height: 20, borderRadius: '50%',
                                      border: `2px solid ${color}`,
                                      backgroundColor: allSelected ? color : selectedCount > 0 ? `${color}33` : 'transparent',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                    }}>
                                      {(allSelected || selectedCount > 0) && (
                                        <div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: allSelected ? 'white' : color }} />
                                      )}
                                    </div>
                                    <span style={{ color, fontWeight: 700, fontSize: '0.8125rem' }}>{catLabel}</span>
                                    {selectedCount > 0 && (
                                      <span style={{ fontSize: '0.625rem', backgroundColor: color, color: 'white', borderRadius: 9999, padding: '1px 6px', fontWeight: 600, marginLeft: 'auto', flexShrink: 0 }}>
                                        {selectedCount}
                                      </span>
                                    )}
                                  </button>
                                </div>

                                {/* Sub-categories — no scrollbar; column grows
                                    to fit all entries. */}
                                <div className="flex-1 px-3 py-2 space-y-3">
                                  {subGroups.length === 0 ? (
                                    <div className="text-xs text-gray-400 text-center py-4">No defect types found</div>
                                  ) : subGroups.map(({ subKey, subLabel, items }) => {
                                    const subSelectedCount = items.filter(cb => checkboxes[cb.key]?.selected).length;
                                    const subAllSelected = items.length > 0 && subSelectedCount === items.length;
                                    return (
                                      <div key={subKey}>
                                        {/* Sub-category header */}
                                        <button
                                          className="flex items-center gap-1.5 mb-1 w-full text-left"
                                          onClick={() => {
                                            setCheckboxes(prev => {
                                              const updated = { ...prev };
                                              items.forEach(cb => {
                                                updated[cb.key] = { ...updated[cb.key], selected: !subAllSelected };
                                              });
                                              return updated;
                                            });
                                          }}
                                        >
                                          <div style={{
                                            width: 13, height: 13, borderRadius: '50%',
                                            border: `2px solid ${color}`,
                                            backgroundColor: subAllSelected ? color : subSelectedCount > 0 ? `${color}33` : 'transparent',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                          }}>
                                            {subSelectedCount > 0 && (
                                              <div style={{ width: 5, height: 5, borderRadius: '50%', backgroundColor: subAllSelected ? 'white' : color }} />
                                            )}
                                          </div>
                                          <span style={{ fontSize: '0.6875rem', fontWeight: 600, color: '#374151' }}>{subLabel}</span>
                                        </button>

                                        {/* Items with colored left border */}
                                        <div style={{ borderLeft: `2px solid ${color}`, marginLeft: 5, paddingLeft: 10 }}>
                                          {items.map((cb) => (
                                            <button
                                              key={cb.key}
                                              className="flex items-center gap-1.5 w-full text-left py-0.5 rounded hover:bg-gray-50"
                                              onClick={() => handleCheckboxChange({ target: { checked: !checkboxes[cb.key]?.selected } }, parseInt(cb.key))}
                                            >
                                              <div style={{
                                                width: 11, height: 11, borderRadius: '50%',
                                                border: `2px solid ${checkboxes[cb.key]?.selected ? color : '#D1D5DB'}`,
                                                backgroundColor: checkboxes[cb.key]?.selected ? color : 'transparent',
                                                flexShrink: 0,
                                              }} />
                                              <span style={{ fontSize: '0.6875rem', color: '#4B5563', lineHeight: 1.4 }}>{cb.label}</span>
                                            </button>
                                          ))}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                          {Object.values(categorizedCheckboxes).every(arr => arr.length === 0) && (
                            <div className="flex-1 flex items-center justify-center text-xs text-slate-500 py-4">No defect types found</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Clear bottom filters */}
                  {(Object.values(checkboxes).some(cb => cb.selected) || Object.values(severityOptions).slice(1).some(s => s.selected)) && (
                    <button
                      onClick={() => {
                        setCheckboxes(prev => {
                          const cleared = {};
                          Object.keys(prev).forEach(k => { cleared[k] = { ...prev[k], selected: false }; });
                          return cleared;
                        });
                        setSeverityOptions(prev => {
                          const cleared = {};
                          Object.keys(prev).forEach(k => { cleared[k] = { ...prev[k], selected: false }; });
                          return cleared;
                        });
                      }}
                      className="ml-auto flex items-center gap-1.5 px-3 py-1.5 text-xs text-red-600 hover:text-red-800 hover:bg-red-50 border border-red-200 rounded-full transition-colors"
                    >
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                      Clear filters
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </main>

        {/* Right panels: point modal & polyline modal */}
        {open && (
          <div
            className="relative bg-white shadow-2xl border-l border-slate-200 z-10 flex flex-col flex-shrink-0 overflow-hidden"
            style={{ width: panelWidth }}
          >
            {/* VS Code-style drag handle on left edge */}
            <div
              className="absolute left-0 top-0 bottom-0 w-1 z-20 cursor-col-resize hover:bg-blue-500 transition-colors duration-150"
              onMouseDown={(e) => {
                e.preventDefault();
                setIsPanelDragging(true);
                const startX = e.clientX;
                const startWidth = panelWidth;
                const onMove = (ev) => {
                  const delta = startX - ev.clientX;
                  setPanelWidth(Math.min(700, Math.max(280, startWidth + delta)));
                };
                const onUp = () => {
                  setIsPanelDragging(false);
                  window.removeEventListener('mousemove', onMove);
                  window.removeEventListener('mouseup', onUp);
                };
                window.addEventListener('mousemove', onMove);
                window.addEventListener('mouseup', onUp);
              }}
            />
            {/* Header */}
            <div className="bg-slate-800 px-6 py-4 flex items-center justify-between border-b border-slate-700">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-slate-700 rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold text-base">Inspection Point</h3>
                  <p className="text-slate-400 text-xs">Detailed Analysis</p>
                </div>
              </div>
              <button onClick={handleClose} className="p-1.5 hover:bg-slate-700 rounded-lg transition-colors">
                <Close className="text-slate-400 hover:text-white text-xl" />
              </button>
            </div>

            {/* Content — the side panel renders the image inline. Clicking
                the expand icon (defined below) calls toggleImageFullView,
                which uses the browser's native Fullscreen API on the image
                element directly. No overlay/lightbox needed. */}
            <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden bg-slate-50">
                {loading ? (
                  <div className="flex items-center justify-center h-full">
                    <LoadingScreen />
                  </div>
                ) : (
                  <div className="p-4 space-y-3">
                    {/* Image wrapper — this div is what we fullscreen, so the
                        buttons rendered inside it stay visible on top of the
                        image when the user enters fullscreen mode. */}
                    <div
                      ref={imageWrapperRef}
                      className={`relative shadow-sm overflow-hidden ${
                        isImageFullView
                          ? 'bg-black w-screen h-screen flex items-center justify-center rounded-none'
                          : 'rounded-lg bg-slate-200 aspect-video'
                      }`}
                    >
                      {/* Previous image stays underneath (panel mode only) so the
                          next point's image cross-fades in over it instead of
                          flashing the empty background while it loads. */}
                      {!isImageFullView && prevImgSrc && prevImgSrc !== selectedImageSrc && (
                        <img
                          src={prevImgSrc}
                          alt=""
                          aria-hidden="true"
                          className="absolute inset-0 w-full h-full object-cover"
                        />
                      )}
                      <img
                        key={selectedImageSrc}
                        ref={imageRef}
                        src={selectedImageSrc}
                        alt="Road analysis"
                        onLoad={() => { setImgLoaded(true); measureGeom(); }}
                        onTransitionEnd={() => setPrevImgSrc(selectedImageSrc)}
                        className={`transition-opacity duration-500 ease-out ${imgLoaded ? 'opacity-100' : 'opacity-0'} ${isImageFullView
                          ? 'max-w-full max-h-full object-contain'
                          : `absolute inset-0 w-full h-full ${selectedRadio === 'original' ? 'object-contain' : 'object-cover'}`}`}
                        onError={(e) => { e.target.src = "/assests/404image.svg"; }}
                      />
                      {/* Runtime defect bounding boxes (Original frame, filter-aware) */}
                      {imgLoaded && overlayBoxes.map(b => (
                        <div
                          key={b.key}
                          className="absolute pointer-events-none rounded-sm"
                          style={{ left: b.left, top: b.top, width: b.width, height: b.height, border: `2px solid ${b.color}`, boxShadow: '0 0 0 1px rgba(0,0,0,0.35)' }}
                        >
                          <span
                            className="absolute left-0 -top-[15px] px-1 text-[10px] font-bold leading-[14px] text-white whitespace-nowrap rounded-sm"
                            style={{ background: b.color, textShadow: '0 1px 1px rgba(0,0,0,0.4)' }}
                          >
                            {b.name}
                          </span>
                        </div>
                      ))}
                      {/* Top-left: full-view toggle (in panel mode) /
                          dedicated Close button (in fullscreen). Both call
                          toggleImageFullView, so a click exits fullscreen. */}
                      <div className="absolute top-3 left-3 flex items-center gap-2">
                        <button onClick={toggleImageFullView} className="p-2 bg-white/90 hover:bg-white dark:bg-slate-800/80 dark:hover:bg-slate-800 backdrop-blur-sm rounded-lg transition-all shadow" title={isImageFullView ? "Exit full view (Esc)" : "Full view"}>
                          {isImageFullView ? (
                            // Close (X) icon — only shown in fullscreen
                            <svg className="w-5 h-5 text-slate-900 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          ) : (
                            // Expand-arrows icon — only shown in panel mode
                            <svg className="w-4 h-4 text-slate-900 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                            </svg>
                          )}
                        </button>
                      </div>
                      {/* Download button — top right (visible in both modes) */}
                      <div className="absolute top-3 right-3">
                        <button onClick={handleDownload} className="p-2 bg-white/90 hover:bg-white dark:bg-slate-800/80 dark:hover:bg-slate-800 backdrop-blur-sm rounded-lg transition-all shadow" title="Download">
                          <svg className={`${isImageFullView ? 'w-5 h-5' : 'w-4 h-4'} text-slate-900 dark:text-white`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* Image Type Toggle */}
                    <div className="bg-white rounded-lg p-2 shadow-sm">
                      <div className="flex gap-2">
                        <button
                          onClick={() => setSelectedRadio("original")}
                          className={`flex-1 py-2.5 px-4 rounded-md text-sm font-medium transition-all ${selectedRadio === "original"
                            ? "bg-slate-800 text-white"
                            : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                            }`}
                        >
                          Original
                        </button>
                        <button
                          onClick={() => setSelectedRadio("ai_analyzed")}
                          className={`flex-1 py-2.5 px-4 rounded-md text-sm font-medium transition-all ${selectedRadio === "ai_analyzed"
                            ? "bg-slate-800 text-white"
                            : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                            }`}
                        >
                          AI Analyzed
                        </button>
                      </div>
                    </div>

                    {/* Navigation Controls */}
                    <div className="bg-white rounded-lg p-3 shadow-sm">
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex gap-2">
                          <button
                            onClick={goToPreviousMarker}
                            className="p-2.5 bg-slate-100 hover:bg-slate-200 rounded-lg transition-all"
                            title="Previous marker"
                          >
                            <svg className="w-5 h-5 text-slate-700" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          </button>
                          <button
                            onClick={goToNextMarker}
                            className="p-2.5 bg-slate-100 hover:bg-slate-200 rounded-lg transition-all"
                            title="Next marker"
                          >
                            <svg className="w-5 h-5 text-slate-700" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                            </svg>
                          </button>
                        </div>
                        <button
                          onClick={toggleAutoPlay}
                          className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${isAutoPlay
                            ? 'bg-amber-500 hover:bg-amber-600 text-white'
                            : 'bg-slate-100 hover:bg-slate-200 text-slate-700'
                            }`}
                        >
                          {isAutoPlay ? (
                            <>
                              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                              </svg>
                              Stop
                            </>
                          ) : (
                            <>
                              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                              </svg>
                              Play
                            </>
                          )}
                        </button>
                      </div>
                    </div>

                    {/* Defect Information */}
                    <div className="bg-white rounded-lg p-4 shadow-sm">
                      <div className="flex items-start gap-3 mb-3">
                        <div className="w-9 h-9 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
                          <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">Defect Type</p>
                          {Array.isArray(info.label) && info.label.length > 0 ? (
                            <div className="flex flex-wrap gap-1.5 mt-1">
                              {info.label.map((lbl, i) => (
                                <span key={i} className="inline-block text-xs font-medium text-slate-800 bg-slate-100 border border-slate-200 rounded-full px-2.5 py-1">
                                  {lbl}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <p className="text-sm font-semibold text-slate-900">No defects detected</p>
                          )}
                        </div>
                      </div>
                      <div className="pt-3 border-t border-slate-100">
                        <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">Date Captured</p>
                        <p className="text-sm text-slate-700">{info.date_time || 'N/A'}</p>
                      </div>
                    </div>

                    {/* Location Information */}
                    <div className="bg-white rounded-lg p-4 shadow-sm">
                      <div className="flex items-start gap-3 mb-3">
                        <div className="w-9 h-9 bg-emerald-50 rounded-lg flex items-center justify-center flex-shrink-0">
                          <svg className="w-5 h-5 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">Location</p>
                          <p className="text-sm text-slate-700 leading-snug break-words">{info.address || 'Address not available'}</p>
                        </div>
                      </div>
                      <div className="pt-3 border-t border-slate-100">
                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <p className="text-xs text-slate-500 mb-1.5 font-medium">Latitude</p>
                            <p className="text-xs font-mono text-slate-800 bg-slate-50 px-2.5 py-1.5 rounded border border-slate-200">
                              {info.latitude || 'N/A'}
                            </p>
                          </div>
                          <div>
                            <p className="text-xs text-slate-500 mb-1.5 font-medium">Longitude</p>
                            <p className="text-xs font-mono text-slate-800 bg-slate-50 px-2.5 py-1.5 rounded border border-slate-200">
                              {info.longitude || 'N/A'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Feedback Section - commented out (no backend logic)
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <label className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-2 block">Notes & Observations</label>
                    <textarea
                      placeholder="Add notes, observations, or recommendations..."
                      rows="3"
                      className="w-full px-3 py-2.5 border border-slate-300 rounded-lg text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent resize-none bg-slate-50"
                    />
                  </div>
                  */}

                    {/* Severity Analysis for this point */}
                    {(() => {
                      const currentMarker = markers[currentMarkerIndex];
                      if (!currentMarker) return null;
                      const COLOR_TO_SEVERITY = { '#DC3C3C': 'High', '#E87A00': 'Medium', '#C8C800': 'Low', '#00BB00': 'No Defects' };

                      // Group defects by their severity color (per-label breakdown).
                      // Each entry is { name, count }: distinct defect types are
                      // grouped (so the header count and the color logic agree on
                      // "types"), while count carries the raw number of detections
                      // for that type so the chip can show "Name ×N".
                      const defectsBySeverity = { '#DC3C3C': [], '#E87A00': [], '#C8C800': [] };
                      if (currentMarker.inference_info) {
                        const byName = new Map(); // name → { color, count }, first-seen order
                        currentMarker.inference_info.forEach(inf => {
                          const raw = mapLabel(inf.label);
                          const name = raw.replace(/[_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                          const color = isBhilwaraUser
                            ? (_getBhilwaraLabelColor(inf.label || '', inf.severity || '') || '#C8C800')
                            : _getLabelColor(inf.label || '');
                          // Universal map: unmapped labels are not defects → skip.
                          if (!color) return;
                          const existing = byName.get(name);
                          if (existing) existing.count += 1;
                          else byName.set(name, { color, count: 1 });
                        });
                        byName.forEach(({ color, count }, name) => {
                          if (defectsBySeverity[color]) defectsBySeverity[color].push({ name, count });
                        });
                      }
                      // Headline severity must match the GIS map marker exactly, so derive it
                      // from the SAME single source of truth (getMarkerColor) instead of
                      // re-deriving from labels here. getMarkerColor honors the frame-level
                      // defect_state first and only falls back to per-label severity when
                      // defect_state is "none" — re-implementing label logic here ignored
                      // defect_state and could disagree with the marker shown on the map.
                      const pointColor = getMarkerColor(currentMarker.defect_state, false, currentMarker.inference_info);
                      const severityLabel = COLOR_TO_SEVERITY[pointColor] || 'Unknown';

                      return (
                        <div className="bg-white rounded-lg p-4 shadow-sm">
                          <div className="flex items-center justify-between mb-3">
                            <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">Severity Analysis</p>
                            <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full" style={{ backgroundColor: pointColor + '20', border: `1.5px solid ${pointColor}` }}>
                              <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: pointColor }} />
                              <span className="text-xs font-bold" style={{ color: pointColor }}>{severityLabel}</span>
                            </div>
                          </div>

                          {pointColor === '#00BB00' ? (
                            <p className="text-xs text-slate-500">No defects detected at this inspection point.</p>
                          ) : (
                            <div className="space-y-2">
                              {[
                                { color: '#DC3C3C', label: 'High', items: defectsBySeverity['#DC3C3C'] },
                                { color: '#E87A00', label: 'Medium', items: defectsBySeverity['#E87A00'] },
                                { color: '#C8C800', label: 'Low', items: defectsBySeverity['#C8C800'] },
                              ].filter(g => g.items.length > 0).map(({ color, label, items }) => (
                                <div key={label}>
                                  <div className="flex items-center gap-1.5 mb-1">
                                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
                                    <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color }}>{label} ({items.reduce((s, i) => s + i.count, 0)})</span>
                                  </div>
                                  <div className="flex flex-wrap gap-1 ml-3.5">
                                    {items.map(({ name, count }) => (
                                      <span key={name} className="text-[10px] text-slate-600 bg-slate-50 border border-slate-200 rounded px-1.5 py-0.5">
                                        {name}{count > 1 ? ` ×${count}` : ''}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* Legend */}
                          <div className="mt-3 pt-3 border-t border-slate-100">
                            <p className="text-[10px] text-slate-400 uppercase tracking-wide mb-1.5">Legend</p>
                            <div className="flex flex-wrap gap-x-4 gap-y-0.5">
                              {[
                                { color: '#DC3C3C', label: 'High' },
                                { color: '#E87A00', label: 'Medium' },
                                { color: '#C8C800', label: 'Low' },
                                { color: '#00BB00', label: 'No Defects' },
                              ].map(({ color, label }) => (
                                <div key={label} className="flex items-center gap-1">
                                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
                                  <span className="text-[10px] text-slate-500">{label}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
          </div>
        )}

        {/* Drag-lock overlay — keeps col-resize cursor over entire screen while resizing */}
        {isPanelDragging && (
          <div className="fixed inset-0 z-[9999]" style={{ cursor: 'col-resize' }} />
        )}


        {isPolylineModalOpen && (
          <div className="absolute left-72 top-0 bottom-0 w-[400px] bg-white shadow-2xl border-r border-slate-200 z-50 flex flex-col">
            {/* Header */}
            <div className="bg-slate-800 px-6 py-4 flex items-center justify-between border-b border-slate-700">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-slate-700 rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold text-base">Road Segment</h3>
                  <p className="text-slate-400 text-xs">Overall Analysis</p>
                </div>
              </div>
              <button onClick={() => setPolylineModalOpen(false)} className="p-1.5 hover:bg-slate-700 rounded-lg transition-colors">
                <Close className="text-slate-400 hover:text-white text-xl" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto bg-slate-50">
              <div className="p-4 space-y-3">
                {/* RoadVision Score */}
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="text-center">
                    <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-white font-semibold text-base ${selectedPolylineData?.roadRating <= 40 ? 'bg-red-600' :
                      selectedPolylineData?.roadRating <= 80 ? 'bg-orange-500' :
                        'bg-emerald-600'
                      }`}>
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                      Score: {selectedPolylineData?.roadRating || 0}
                    </div>
                  </div>
                  <div className="mt-3">
                    <RoadRatingGauge rating={selectedPolylineData?.roadRating} />
                  </div>
                </div>

                {/* Quick Stats */}
                <div className="grid grid-cols-1 gap-3">
                  {/* Road Condition */}
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${selectedPolylineData?.roadCondition === "Poor" ? "bg-red-50" :
                        selectedPolylineData?.roadCondition === "Fair" ? "bg-orange-50" :
                          "bg-emerald-50"
                        }`}>
                        <svg className={`w-5 h-5 ${selectedPolylineData?.roadCondition === "Poor" ? "text-red-600" :
                          selectedPolylineData?.roadCondition === "Fair" ? "text-orange-600" :
                            "text-emerald-600"
                          }`} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-0.5">Condition</p>
                        <p className="text-base font-semibold text-slate-900">{selectedPolylineData?.roadCondition || 'N/A'}</p>
                      </div>
                    </div>
                  </div>

                  {/* Road Length */}
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-0.5">Length</p>
                        <p className="text-base font-semibold text-slate-900">{selectedPolylineData?.roadLength || 0} km</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Location Details */}
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  {/* Starting Point */}
                  <div className="mb-4 pb-4 border-b border-slate-100">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold">Start Point</p>
                    </div>
                    <p className="text-sm text-slate-700 leading-snug mb-2">{selectedPolylineData?.startingAddress || 'N/A'}</p>
                    <div className="flex gap-2 text-xs">
                      <span className="bg-slate-100 px-2.5 py-1 rounded font-mono text-slate-700 border border-slate-200">
                        {selectedPolylineData?.entryPoint?.lat?.toFixed(6)}
                      </span>
                      <span className="bg-slate-100 px-2.5 py-1 rounded font-mono text-slate-700 border border-slate-200">
                        {selectedPolylineData?.entryPoint?.lng?.toFixed(6)}
                      </span>
                    </div>
                  </div>

                  {/* Ending Point */}
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-8 h-8 bg-red-50 rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold">End Point</p>
                    </div>
                    <p className="text-sm text-slate-700 leading-snug mb-2">{selectedPolylineData?.endingAddress || 'N/A'}</p>
                    <div className="flex gap-2 text-xs">
                      <span className="bg-slate-100 px-2.5 py-1 rounded font-mono text-slate-700 border border-slate-200">
                        {selectedPolylineData?.exitPoint?.lat?.toFixed(6)}
                      </span>
                      <span className="bg-slate-100 px-2.5 py-1 rounded font-mono text-slate-700 border border-slate-200">
                        {selectedPolylineData?.exitPoint?.lng?.toFixed(6)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default MultiMap;
